import "core-js/modules/esnext.string.match-all.js";

/**
 * @license
 * author: Jacco Meijer (https://www.jaccomeijer.nl)
 * blue-lib v3.1.10
 * Released under the MIT license.
 */
import { jsx as e, jsxs as o, Fragment as n } from "react/jsx-runtime";
import { jsx as r } from "@emotion/react";
import t, { Children as i, useState as s, useRef as l, useEffect as a } from "react";
import { MARKS as d, BLOCKS as c, INLINES as h } from "@contentful/rich-text-types";
import { documentToReactComponents as u } from "@contentful/rich-text-react-renderer";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _v = function v() {
  return _v = Object.assign || function (e) {
    for (var o, n = 1, r = arguments.length; n < r; n++) {
      for (var t in o = arguments[n]) {
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
      }
    }

    return e;
  }, _v.apply(this, arguments);
};

function g(e, o) {
  var n = {};

  for (var r in e) {
    Object.prototype.hasOwnProperty.call(e, r) && o.indexOf(r) < 0 && (n[r] = e[r]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var t = 0;

    for (r = Object.getOwnPropertySymbols(e); t < r.length; t++) {
      o.indexOf(r[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[t]) && (n[r[t]] = e[r[t]]);
    }
  }

  return n;
}

function f(e, o, n) {
  if (n || 2 === arguments.length) for (var r, t = 0, i = o.length; t < i; t++) {
    !r && t in o || (r || (r = Array.prototype.slice.call(o, 0, t)), r[t] = o[t]);
  }
  return e.concat(r || Array.prototype.slice.call(o));
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _p = function p() {
  return _p = Object.assign || function (e) {
    for (var o, n = 1, r = arguments.length; n < r; n++) {
      for (var t in o = arguments[n]) {
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
      }
    }

    return e;
  }, _p.apply(this, arguments);
};

var w = {
  boxSizing: "border-box"
},
    m = {
  fontWeight: "bolder"
},
    _ = {
  fontFamily: "monospace, monospace",
  fontSize: "1em"
},
    k = {
  fontSize: "75%",
  lineHeight: 0,
  position: "relative",
  verticalAlign: "baseline"
},
    y = _p(_p({}, k), {
  bottom: "-0.25em"
}),
    x = _p(_p({}, k), {
  top: "-0.5em"
}),
    b = {
  fontFamily: "inherit",
  fontSize: "100%",
  lineHeight: 1.15,
  margin: 0
},
    C = {
  a: {
    backgroundColor: "transparent"
  },
  abbr: {
    "&[title]": {
      borderBottom: "none",
      textDecoration: "underline dotted"
    }
  },
  b: m,
  body: {
    margin: 0
  },
  button: _p(_p({}, b), {
    overflow: "visible",
    textTransform: "none",
    WebkitAppearance: "button",
    '&[type="button"], &[type="reset"], &[type="submit"]': {
      WebkitAppearance: "button"
    },
    '&::-moz-focus-inner, &[type="button"]::-moz-focus-inner, &[type="reset"]::-moz-focus-inner, &[type="submit"]::-moz-focus-inner': {
      borderStyle: "none",
      padding: 0
    },
    '&:-moz-focusring, &[type="button"]:-moz-focusring, &[type="reset"]:-moz-focusring, &[type="submit"]:-moz-focusring': {
      outline: "1px dotted ButtonText"
    }
  }),
  code: _,
  details: {
    display: "block"
  },
  fieldset: {
    padding: "0.35em 0.75em 0.625em"
  },
  h1: {
    fontSize: "2em",
    margin: "0.67em 0"
  },
  hr: {
    boxSizing: "content-box",
    height: 0,
    overflow: "visible"
  },
  html: {
    lineHeight: 1.15,
    WebkitTextSizeAdjust: "100%"
  },
  img: {
    borderStyle: "none"
  },
  input: _p(_p({}, b), {
    overflow: "visible",
    '&[type="checkbox"], &[type="radio"]': {
      boxSizing: "border-box",
      padding: 0
    },
    '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
      height: "auto"
    },
    '&[type="search"]': {
      WebkitAppearance: "textfield",
      outlineOffset: -2
    },
    '&[type="search"]::-webkit-search-decoration': {
      WebkitAppearance: "none"
    },
    "&::-webkit-file-upload-button": {
      WebkitAppearance: "button",
      font: "inherit"
    }
  }),
  kbd: _,
  legend: {
    boxSizing: "border-box",
    color: "inherit",
    display: "table",
    maxWidth: "100%",
    padding: 0,
    whiteSpace: "normal"
  },
  main: {
    display: "block"
  },
  optgroup: b,
  pre: {
    fontFamily: "monospace, monospace",
    fontSize: "1em"
  },
  progress: {
    verticalAlign: "baseline"
  },
  samp: _,
  select: _p(_p({}, b), {
    textTransform: "none"
  }),
  small: {
    fontSize: "80%"
  },
  strong: m,
  sub: y,
  summary: {
    display: "list-item"
  },
  sup: x,
  template: {
    display: "none"
  },
  textarea: _p(_p({}, b), {
    overflow: "auto"
  })
},
    M = function M(e) {
  var o = e.anyCss,
      n = e.is,
      t = function (e, o) {
    var n = {};

    for (var r in e) {
      Object.prototype.hasOwnProperty.call(e, r) && o.indexOf(r) < 0 && (n[r] = e[r]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var t = 0;

      for (r = Object.getOwnPropertySymbols(e); t < r.length; t++) {
        o.indexOf(r[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[t]) && (n[r[t]] = e[r[t]]);
      }
    }

    return n;
  }(e, ["anyCss", "is"]),
      i = n || "div";

  return r(i, _p({
    css: [w, C[i], o]
  }, t), t.children);
},
    L = function L(o) {
  return e(M, _p({
    is: "a"
  }, o), void 0);
},
    j = function j(o) {
  return e(M, _p({
    is: "b"
  }, o), void 0);
},
    W = function W(o) {
  return e(M, _p({
    is: "blockquote"
  }, o), void 0);
},
    N = function N(o) {
  return e(M, _p({
    is: "button"
  }, o), void 0);
},
    A = function A(o) {
  return e(M, _p({
    is: "code"
  }, o), void 0);
},
    S = function S(o) {
  return e(M, _p({
    is: "div"
  }, o), void 0);
},
    H = function H(o) {
  return e(M, _p({
    is: "figure"
  }, o), void 0);
},
    z = function z(o) {
  return e(M, _p({
    is: "h1"
  }, o), void 0);
},
    T = function T(o) {
  return e(M, _p({
    is: "hr"
  }, o), void 0);
},
    O = function O(o) {
  return e(M, _p({
    is: "i"
  }, o), void 0);
},
    E = function E(o) {
  return e(M, _p({
    is: "img"
  }, o), void 0);
},
    V = function V(o) {
  return e(M, _p({
    is: "input"
  }, o), void 0);
},
    I = function I(o) {
  return e(M, _p({
    is: "label"
  }, o), void 0);
},
    D = function D(o) {
  return e(M, _p({
    is: "li"
  }, o), void 0);
},
    P = function P(o) {
  return e(M, _p({
    is: "nav"
  }, o), void 0);
},
    R = function R(o) {
  return e(M, _p({
    is: "ol"
  }, o), void 0);
},
    U = function U(o) {
  return e(M, _p({
    is: "p"
  }, o), void 0);
},
    F = function F(o) {
  return e(M, _p({
    is: "picture"
  }, o), void 0);
},
    B = function B(o) {
  return e(M, _p({
    is: "section"
  }, o), void 0);
},
    q = function q(o) {
  return e(M, _p({
    is: "source"
  }, o), void 0);
},
    $ = function $(o) {
  return e(M, _p({
    is: "span"
  }, o), void 0);
},
    Y = function Y(o) {
  return e(M, _p({
    is: "sup"
  }, o), void 0);
},
    G = function G(o) {
  return e(M, _p({
    is: "table"
  }, o), void 0);
},
    K = function K(o) {
  return e(M, _p({
    is: "tbody"
  }, o), void 0);
},
    J = function J(o) {
  return e(M, _p({
    is: "td"
  }, o), void 0);
},
    Q = function Q(o) {
  return e(M, _p({
    is: "textarea"
  }, o), void 0);
},
    X = function X(o) {
  return e(M, _p({
    is: "tr"
  }, o), void 0);
},
    Z = function Z(o) {
  return e(M, _p({
    is: "u"
  }, o), void 0);
},
    ee = function ee(o) {
  return e(M, _p({
    is: "ul"
  }, o), void 0);
},
    oe = function oe(o) {
  return e(M, _p({
    is: "video"
  }, o), void 0);
},
    ne = [768],
    re = function (e) {
  var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      n = o.literal,
      r = o.overlap,
      t = n ? e : ["&"].concat(e);

  function i(e) {
    if ("object" != typeof e || null == e) return [];
    if (Array.isArray(e)) return e.map(i);
    var o = {},
        s = {},
        l = {};
    return Object.keys(e).forEach(function (a) {
      var d = e[a];

      if (!Array.isArray(d) && n && (d = [d]), (n || Array.isArray(d)) && 38 !== a.charCodeAt(0)) {
        var c = void 0;
        d.forEach(function (e, i) {
          if ((!r || c !== e) && null != e) if (c = e, 0 !== i || n) {
            if (void 0 === o[t[i]]) {
              var s;
              o[t[i]] = ((s = {})[a] = e, s);
            } else o[t[i]][a] = e;
          } else l[a] = e;
        });
      } else "object" == typeof d ? s[a] = i(d) : l[a] = d;
    }), t.forEach(function (e) {
      o[e] && (l[e] = o[e]);
    }), Object.assign(l, s), l;
  }

  return function () {
    for (var e = arguments.length, o = Array(e), n = 0; n < e; n++) {
      o[n] = arguments[n];
    }

    return o.map(i);
  };
}(ne.map(function (e) {
  return "@media (min-width: ".concat(e, "px)");
})),
    te = {
  color: "var(--color-stone-500)",
  fontFamily: "var(--heading-font-family)",
  fontWeight: "var(--heading-font-weight)",
  margin: 0
},
    ie = {
  xl: _v(_v({}, te), {
    fontSize: "var(--heading-font-size-xl)",
    lineHeight: "var(--heading-line-height-xl)"
  }),
  l: _v(_v({}, te), {
    fontSize: "var(--heading-font-size-l)",
    lineHeight: "var(--heading-line-height-l)"
  }),
  m: _v(_v({}, te), {
    fontSize: "var(--heading-font-size-m)",
    lineHeight: "var(--heading-line-height-m)"
  }),
  s: _v(_v({}, te), {
    fontSize: "var(--heading-font-size-s)",
    lineHeight: "var(--heading-line-height-s)"
  })
},
    se = {
  marginBottom: 16
},
    le = {
  fontWeight: "var(--heading-font-weight-bold)"
},
    ae = function ae(e) {
  var o,
      n,
      r = e.variant || "m";
  return [ie[r], (null === (o = e.options) || void 0 === o ? void 0 : o.margin) && se, (null === (n = e.options) || void 0 === n ? void 0 : n.bold) && le];
},
    de = function de(o) {
  var n = o.anyCss,
      r = o.variant,
      t = o.options,
      i = g(o, ["anyCss", "variant", "options"]),
      s = ae({
    variant: r,
    options: t
  });
  return e(z, _v({
    anyCss: re([s, n])
  }, i), void 0);
},
    ce = {
  color: "var(--color-stone-500)",
  fontFamily: "var(--body-font-family)",
  fontWeight: "var(--body-font-weight)",
  margin: 0
},
    he = {
  xl: _v(_v({}, ce), {
    fontSize: "var(--body-font-size-xl)",
    lineHeight: "var(--body-line-height-xl)"
  }),
  l: _v(_v({}, ce), {
    fontSize: "var(--body-font-size-l)",
    lineHeight: "var(--body-line-height-l)"
  }),
  m: _v(_v({}, ce), {
    fontSize: "var(--body-font-size-m)",
    lineHeight: "var(--body-line-height-m)"
  }),
  s: _v(_v({}, ce), {
    fontSize: "var(--body-font-size-s)",
    lineHeight: "var(--body-line-height-s)"
  })
},
    ue = {
  marginBottom: 16
},
    ve = {
  fontWeight: "var(--body-font-weight-bold)"
},
    ge = function ge(e) {
  var o,
      n,
      r = e.variant || "m";
  return [he[r], (null === (o = e.options) || void 0 === o ? void 0 : o.margin) && ue, (null === (n = e.options) || void 0 === n ? void 0 : n.bold) && ve];
},
    fe = function fe(o) {
  var n = o.anyCss,
      r = o.variant,
      t = o.options,
      i = g(o, ["anyCss", "variant", "options"]),
      s = ge({
    variant: r,
    options: t
  });
  return e(U, _v({
    anyCss: re([s, n])
  }, i), void 0);
},
    pe = {
  color: "var(--color-stone-500)",
  fontFamily: "var(--display-font-family)",
  fontWeight: "var(--display-font-weight)",
  margin: 0
},
    we = {
  l: _v(_v({}, pe), {
    fontSize: ["var(--display-font-size-m)", "var(--display-font-size-l)"],
    lineHeight: ["var(--display-line-height-m)", "var(--display-line-height-l)"]
  }),
  m: _v(_v({}, pe), {
    fontSize: "var(--display-font-size-m)",
    lineHeight: "var(--display-line-height-m)"
  })
},
    me = {
  marginBottom: 16
},
    _e = {
  fontWeight: "var(--display-font-weight-bold)"
},
    ke = function ke(e) {
  var o,
      n,
      r = e.variant || "m";
  return [we[r], (null === (o = e.options) || void 0 === o ? void 0 : o.margin) && me, (null === (n = e.options) || void 0 === n ? void 0 : n.bold) && _e];
},
    ye = function ye(o) {
  var n = o.anyCss,
      r = o.variant,
      t = o.options,
      i = g(o, ["anyCss", "variant", "options"]),
      s = ke({
    variant: r,
    options: t
  });
  return e(U, _v({
    anyCss: re([s, n])
  }, i), void 0);
};

var xe = {
  activity: function activity(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "activity_svg__feather activity_svg__feather-activity"
    }, o, {
      children: e("path", {
        d: "M22 12h-4l-3 9L9 3l-3 9H2"
      }, void 0)
    }), void 0);
  },
  airplay: function airplay(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "airplay_svg__feather airplay_svg__feather-airplay"
    }, n, {
      children: [e("path", {
        d: "M5 17H4a2 2 0 01-2-2V5a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2h-1"
      }, void 0), e("path", {
        d: "M12 15l5 6H7l5-6z"
      }, void 0)]
    }), void 0);
  },
  "alert-circle": function alertCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "alert-circle_svg__feather alert-circle_svg__feather-alert-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M12 8v4M12 16h.01"
      }, void 0)]
    }), void 0);
  },
  "alert-octagon": function alertOctagon(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "alert-octagon_svg__feather alert-octagon_svg__feather-alert-octagon"
    }, o, {
      children: e("path", {
        d: "M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2zM12 8v4M12 16h.01"
      }, void 0)
    }), void 0);
  },
  "alert-triangle": function alertTriangle(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "alert-triangle_svg__feather alert-triangle_svg__feather-alert-triangle"
    }, o, {
      children: e("path", {
        d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01"
      }, void 0)
    }), void 0);
  },
  "align-center": function alignCenter(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "align-center_svg__feather align-center_svg__feather-align-center"
    }, o, {
      children: e("path", {
        d: "M18 10H6M21 6H3M21 14H3M18 18H6"
      }, void 0)
    }), void 0);
  },
  "align-justify": function alignJustify(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "align-justify_svg__feather align-justify_svg__feather-align-justify"
    }, o, {
      children: e("path", {
        d: "M21 10H3M21 6H3M21 14H3M21 18H3"
      }, void 0)
    }), void 0);
  },
  "align-left": function alignLeft(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "align-left_svg__feather align-left_svg__feather-align-left"
    }, o, {
      children: e("path", {
        d: "M17 10H3M21 6H3M21 14H3M17 18H3"
      }, void 0)
    }), void 0);
  },
  "align-right": function alignRight(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "align-right_svg__feather align-right_svg__feather-align-right"
    }, o, {
      children: e("path", {
        d: "M21 10H7M21 6H3M21 14H3M21 18H7"
      }, void 0)
    }), void 0);
  },
  anchor: function anchor(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "anchor_svg__feather anchor_svg__feather-anchor"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 5,
        r: 3
      }, void 0), e("path", {
        d: "M12 22V8M5 12H2a10 10 0 0020 0h-3"
      }, void 0)]
    }), void 0);
  },
  aperture: function aperture(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "aperture_svg__feather aperture_svg__feather-aperture"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M14.31 8l5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94M9.69 16L3.95 6.06M14.31 16H2.83M16.62 12l-5.74 9.94"
      }, void 0)]
    }), void 0);
  },
  archive: function archive(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "archive_svg__feather archive_svg__feather-archive"
    }, o, {
      children: e("path", {
        d: "M21 8v13H3V8M1 3h22v5H1zM10 12h4"
      }, void 0)
    }), void 0);
  },
  "arrow-down-circle": function arrowDownCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-down-circle_svg__feather arrow-down-circle_svg__feather-arrow-down-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M8 12l4 4 4-4M12 8v8"
      }, void 0)]
    }), void 0);
  },
  "arrow-down-left": function arrowDownLeft(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-down-left_svg__feather arrow-down-left_svg__feather-arrow-down-left"
    }, o, {
      children: e("path", {
        d: "M17 7L7 17M17 17H7V7"
      }, void 0)
    }), void 0);
  },
  "arrow-down-right": function arrowDownRight(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-down-right_svg__feather arrow-down-right_svg__feather-arrow-down-right"
    }, o, {
      children: e("path", {
        d: "M7 7l10 10M17 7v10H7"
      }, void 0)
    }), void 0);
  },
  "arrow-down": function arrowDown(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-down_svg__feather arrow-down_svg__feather-arrow-down"
    }, o, {
      children: e("path", {
        d: "M12 5v14M19 12l-7 7-7-7"
      }, void 0)
    }), void 0);
  },
  "arrow-left-circle": function arrowLeftCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-left-circle_svg__feather arrow-left-circle_svg__feather-arrow-left-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M12 8l-4 4 4 4M16 12H8"
      }, void 0)]
    }), void 0);
  },
  "arrow-left": function arrowLeft(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-left_svg__feather arrow-left_svg__feather-arrow-left"
    }, o, {
      children: e("path", {
        d: "M19 12H5M12 19l-7-7 7-7"
      }, void 0)
    }), void 0);
  },
  "arrow-right-circle": function arrowRightCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-right-circle_svg__feather arrow-right-circle_svg__feather-arrow-right-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M12 16l4-4-4-4M8 12h8"
      }, void 0)]
    }), void 0);
  },
  "arrow-right": function arrowRight(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-right_svg__feather arrow-right_svg__feather-arrow-right"
    }, o, {
      children: e("path", {
        d: "M5 12h14M12 5l7 7-7 7"
      }, void 0)
    }), void 0);
  },
  "arrow-up-circle": function arrowUpCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-up-circle_svg__feather arrow-up-circle_svg__feather-arrow-up-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M16 12l-4-4-4 4M12 16V8"
      }, void 0)]
    }), void 0);
  },
  "arrow-up-left": function arrowUpLeft(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-up-left_svg__feather arrow-up-left_svg__feather-arrow-up-left"
    }, o, {
      children: e("path", {
        d: "M17 17L7 7M7 17V7h10"
      }, void 0)
    }), void 0);
  },
  "arrow-up-right": function arrowUpRight(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-up-right_svg__feather arrow-up-right_svg__feather-arrow-up-right"
    }, o, {
      children: e("path", {
        d: "M7 17L17 7M7 7h10v10"
      }, void 0)
    }), void 0);
  },
  "arrow-up": function arrowUp(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "arrow-up_svg__feather arrow-up_svg__feather-arrow-up"
    }, o, {
      children: e("path", {
        d: "M12 19V5M5 12l7-7 7 7"
      }, void 0)
    }), void 0);
  },
  "at-sign": function atSign(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "at-sign_svg__feather at-sign_svg__feather-at-sign"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 4
      }, void 0), e("path", {
        d: "M16 8v5a3 3 0 006 0v-1a10 10 0 10-3.92 7.94"
      }, void 0)]
    }), void 0);
  },
  award: function award(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "award_svg__feather award_svg__feather-award"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 8,
        r: 7
      }, void 0), e("path", {
        d: "M8.21 13.89L7 23l5-3 5 3-1.21-9.12"
      }, void 0)]
    }), void 0);
  },
  "bar-chart-2": function barChart2(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "bar-chart-2_svg__feather bar-chart-2_svg__feather-bar-chart-2"
    }, o, {
      children: e("path", {
        d: "M18 20V10M12 20V4M6 20v-6"
      }, void 0)
    }), void 0);
  },
  "bar-chart": function barChart(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "bar-chart_svg__feather bar-chart_svg__feather-bar-chart"
    }, o, {
      children: e("path", {
        d: "M12 20V10M18 20V4M6 20v-4"
      }, void 0)
    }), void 0);
  },
  "battery-charging": function batteryCharging(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "battery-charging_svg__feather battery-charging_svg__feather-battery-charging"
    }, o, {
      children: e("path", {
        d: "M5 18H3a2 2 0 01-2-2V8a2 2 0 012-2h3.19M15 6h2a2 2 0 012 2v8a2 2 0 01-2 2h-3.19M23 13v-2M11 6l-4 6h6l-4 6"
      }, void 0)
    }), void 0);
  },
  battery: function battery(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "battery_svg__feather battery_svg__feather-battery"
    }, n, {
      children: [e("rect", {
        x: 1,
        y: 6,
        width: 18,
        height: 12,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M23 13v-2"
      }, void 0)]
    }), void 0);
  },
  "bell-off": function bellOff(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "bell-off_svg__feather bell-off_svg__feather-bell-off"
    }, o, {
      children: e("path", {
        d: "M13.73 21a2 2 0 01-3.46 0M18.63 13A17.89 17.89 0 0118 8M6.26 6.26A5.86 5.86 0 006 8c0 7-3 9-3 9h14M18 8a6 6 0 00-9.33-5M1 1l22 22"
      }, void 0)
    }), void 0);
  },
  bell: function bell(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "bell_svg__feather bell_svg__feather-bell"
    }, o, {
      children: e("path", {
        d: "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0"
      }, void 0)
    }), void 0);
  },
  bluetooth: function bluetooth(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "bluetooth_svg__feather bluetooth_svg__feather-bluetooth"
    }, o, {
      children: e("path", {
        d: "M6.5 6.5l11 11L12 23V1l5.5 5.5-11 11"
      }, void 0)
    }), void 0);
  },
  bold: function bold(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "bold_svg__feather bold_svg__feather-bold"
    }, o, {
      children: e("path", {
        d: "M6 4h8a4 4 0 014 4 4 4 0 01-4 4H6zM6 12h9a4 4 0 014 4 4 4 0 01-4 4H6z"
      }, void 0)
    }), void 0);
  },
  "book-open": function bookOpen(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "book-open_svg__feather book-open_svg__feather-book-open"
    }, o, {
      children: e("path", {
        d: "M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"
      }, void 0)
    }), void 0);
  },
  book: function book(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "book_svg__feather book_svg__feather-book"
    }, n, {
      children: [e("path", {
        d: "M4 19.5A2.5 2.5 0 016.5 17H20"
      }, void 0), e("path", {
        d: "M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"
      }, void 0)]
    }), void 0);
  },
  bookmark: function bookmark(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "bookmark_svg__feather bookmark_svg__feather-bookmark"
    }, o, {
      children: e("path", {
        d: "M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z"
      }, void 0)
    }), void 0);
  },
  box: function box(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "box_svg__feather box_svg__feather-box"
    }, n, {
      children: [e("path", {
        d: "M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"
      }, void 0), e("path", {
        d: "M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"
      }, void 0)]
    }), void 0);
  },
  briefcase: function briefcase(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "briefcase_svg__feather briefcase_svg__feather-briefcase"
    }, n, {
      children: [e("rect", {
        x: 2,
        y: 7,
        width: 20,
        height: 14,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"
      }, void 0)]
    }), void 0);
  },
  calendar: function calendar(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "calendar_svg__feather calendar_svg__feather-calendar"
    }, n, {
      children: [e("rect", {
        x: 3,
        y: 4,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M16 2v4M8 2v4M3 10h18"
      }, void 0)]
    }), void 0);
  },
  "camera-off": function cameraOff(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "camera-off_svg__feather camera-off_svg__feather-camera-off"
    }, o, {
      children: e("path", {
        d: "M1 1l22 22M21 21H3a2 2 0 01-2-2V8a2 2 0 012-2h3m3-3h6l2 3h4a2 2 0 012 2v9.34m-7.72-2.06a4 4 0 11-5.56-5.56"
      }, void 0)
    }), void 0);
  },
  camera: function camera(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "camera_svg__feather camera_svg__feather-camera"
    }, n, {
      children: [e("path", {
        d: "M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"
      }, void 0), e("circle", {
        cx: 12,
        cy: 13,
        r: 4
      }, void 0)]
    }), void 0);
  },
  cast: function cast(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "cast_svg__feather cast_svg__feather-cast"
    }, o, {
      children: e("path", {
        d: "M2 16.1A5 5 0 015.9 20M2 12.05A9 9 0 019.95 20M2 8V6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2h-6M2 20h.01"
      }, void 0)
    }), void 0);
  },
  "check-circle": function checkCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "check-circle_svg__feather check-circle_svg__feather-check-circle"
    }, n, {
      children: [e("path", {
        d: "M22 11.08V12a10 10 0 11-5.93-9.14"
      }, void 0), e("path", {
        d: "M22 4L12 14.01l-3-3"
      }, void 0)]
    }), void 0);
  },
  "check-square": function checkSquare(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "check-square_svg__feather check-square_svg__feather-check-square"
    }, n, {
      children: [e("path", {
        d: "M9 11l3 3L22 4"
      }, void 0), e("path", {
        d: "M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"
      }, void 0)]
    }), void 0);
  },
  check: function check(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "check_svg__feather check_svg__feather-check"
    }, o, {
      children: e("path", {
        d: "M20 6L9 17l-5-5"
      }, void 0)
    }), void 0);
  },
  "chevron-down": function chevronDown(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "chevron-down_svg__feather chevron-down_svg__feather-chevron-down"
    }, o, {
      children: e("path", {
        d: "M6 9l6 6 6-6"
      }, void 0)
    }), void 0);
  },
  "chevron-left": function chevronLeft(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "chevron-left_svg__feather chevron-left_svg__feather-chevron-left"
    }, o, {
      children: e("path", {
        d: "M15 18l-6-6 6-6"
      }, void 0)
    }), void 0);
  },
  "chevron-right": function chevronRight(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "chevron-right_svg__feather chevron-right_svg__feather-chevron-right"
    }, o, {
      children: e("path", {
        d: "M9 18l6-6-6-6"
      }, void 0)
    }), void 0);
  },
  "chevron-up": function chevronUp(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "chevron-up_svg__feather chevron-up_svg__feather-chevron-up"
    }, o, {
      children: e("path", {
        d: "M18 15l-6-6-6 6"
      }, void 0)
    }), void 0);
  },
  "chevrons-down": function chevronsDown(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "chevrons-down_svg__feather chevrons-down_svg__feather-chevrons-down"
    }, o, {
      children: e("path", {
        d: "M7 13l5 5 5-5M7 6l5 5 5-5"
      }, void 0)
    }), void 0);
  },
  "chevrons-left": function chevronsLeft(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "chevrons-left_svg__feather chevrons-left_svg__feather-chevrons-left"
    }, o, {
      children: e("path", {
        d: "M11 17l-5-5 5-5M18 17l-5-5 5-5"
      }, void 0)
    }), void 0);
  },
  "chevrons-right": function chevronsRight(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "chevrons-right_svg__feather chevrons-right_svg__feather-chevrons-right"
    }, o, {
      children: e("path", {
        d: "M13 17l5-5-5-5M6 17l5-5-5-5"
      }, void 0)
    }), void 0);
  },
  "chevrons-up": function chevronsUp(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "chevrons-up_svg__feather chevrons-up_svg__feather-chevrons-up"
    }, o, {
      children: e("path", {
        d: "M17 11l-5-5-5 5M17 18l-5-5-5 5"
      }, void 0)
    }), void 0);
  },
  chrome: function chrome(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "chrome_svg__feather chrome_svg__feather-chrome"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("circle", {
        cx: 12,
        cy: 12,
        r: 4
      }, void 0), e("path", {
        d: "M21.17 8H12M3.95 6.06L8.54 14M10.88 21.94L15.46 14"
      }, void 0)]
    }), void 0);
  },
  circle: function circle(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "circle_svg__feather circle_svg__feather-circle"
    }, o, {
      children: e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0)
    }), void 0);
  },
  clipboard: function clipboard(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "clipboard_svg__feather clipboard_svg__feather-clipboard"
    }, n, {
      children: [e("path", {
        d: "M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"
      }, void 0), e("rect", {
        x: 8,
        y: 2,
        width: 8,
        height: 4,
        rx: 1,
        ry: 1
      }, void 0)]
    }), void 0);
  },
  clock: function clock(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "clock_svg__feather clock_svg__feather-clock"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M12 6v6l4 2"
      }, void 0)]
    }), void 0);
  },
  "cloud-drizzle": function cloudDrizzle(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "cloud-drizzle_svg__feather cloud-drizzle_svg__feather-cloud-drizzle"
    }, o, {
      children: e("path", {
        d: "M8 19v2M8 13v2M16 19v2M16 13v2M12 21v2M12 15v2M20 16.58A5 5 0 0018 7h-1.26A8 8 0 104 15.25"
      }, void 0)
    }), void 0);
  },
  "cloud-lightning": function cloudLightning(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "cloud-lightning_svg__feather cloud-lightning_svg__feather-cloud-lightning"
    }, n, {
      children: [e("path", {
        d: "M19 16.9A5 5 0 0018 7h-1.26a8 8 0 10-11.62 9"
      }, void 0), e("path", {
        d: "M13 11l-4 6h6l-4 6"
      }, void 0)]
    }), void 0);
  },
  "cloud-off": function cloudOff(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "cloud-off_svg__feather cloud-off_svg__feather-cloud-off"
    }, o, {
      children: e("path", {
        d: "M22.61 16.95A5 5 0 0018 10h-1.26a8 8 0 00-7.05-6M5 5a8 8 0 004 15h9a5 5 0 001.7-.3M1 1l22 22"
      }, void 0)
    }), void 0);
  },
  "cloud-rain": function cloudRain(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "cloud-rain_svg__feather cloud-rain_svg__feather-cloud-rain"
    }, o, {
      children: e("path", {
        d: "M16 13v8M8 13v8M12 15v8M20 16.58A5 5 0 0018 7h-1.26A8 8 0 104 15.25"
      }, void 0)
    }), void 0);
  },
  "cloud-snow": function cloudSnow(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "cloud-snow_svg__feather cloud-snow_svg__feather-cloud-snow"
    }, o, {
      children: e("path", {
        d: "M20 17.58A5 5 0 0018 8h-1.26A8 8 0 104 16.25M8 16h.01M8 20h.01M12 18h.01M12 22h.01M16 16h.01M16 20h.01"
      }, void 0)
    }), void 0);
  },
  cloud: function cloud(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "cloud_svg__feather cloud_svg__feather-cloud"
    }, o, {
      children: e("path", {
        d: "M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z"
      }, void 0)
    }), void 0);
  },
  code: function code(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "code_svg__feather code_svg__feather-code"
    }, o, {
      children: e("path", {
        d: "M16 18l6-6-6-6M8 6l-6 6 6 6"
      }, void 0)
    }), void 0);
  },
  codepen: function codepen(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "codepen_svg__feather codepen_svg__feather-codepen"
    }, n, {
      children: [e("path", {
        d: "M12 2l10 6.5v7L12 22 2 15.5v-7L12 2zM12 22v-6.5"
      }, void 0), e("path", {
        d: "M22 8.5l-10 7-10-7"
      }, void 0), e("path", {
        d: "M2 15.5l10-7 10 7M12 2v6.5"
      }, void 0)]
    }), void 0);
  },
  codesandbox: function codesandbox(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "codesandbox_svg__feather codesandbox_svg__feather-codesandbox"
    }, n, {
      children: [e("path", {
        d: "M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"
      }, void 0), e("path", {
        d: "M7.5 4.21l4.5 2.6 4.5-2.6M7.5 19.79V14.6L3 12M21 12l-4.5 2.6v5.19M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"
      }, void 0)]
    }), void 0);
  },
  coffee: function coffee(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "coffee_svg__feather coffee_svg__feather-coffee"
    }, o, {
      children: e("path", {
        d: "M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8zM6 1v3M10 1v3M14 1v3"
      }, void 0)
    }), void 0);
  },
  columns: function columns(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "columns_svg__feather columns_svg__feather-columns"
    }, o, {
      children: e("path", {
        d: "M12 3h7a2 2 0 012 2v14a2 2 0 01-2 2h-7m0-18H5a2 2 0 00-2 2v14a2 2 0 002 2h7m0-18v18"
      }, void 0)
    }), void 0);
  },
  command: function command(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "command_svg__feather command_svg__feather-command"
    }, o, {
      children: e("path", {
        d: "M18 3a3 3 0 00-3 3v12a3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3H6a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3V6a3 3 0 00-3-3 3 3 0 00-3 3 3 3 0 003 3h12a3 3 0 003-3 3 3 0 00-3-3z"
      }, void 0)
    }), void 0);
  },
  compass: function compass(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "compass_svg__feather compass_svg__feather-compass"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12z"
      }, void 0)]
    }), void 0);
  },
  copy: function copy(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "copy_svg__feather copy_svg__feather-copy"
    }, n, {
      children: [e("rect", {
        x: 9,
        y: 9,
        width: 13,
        height: 13,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"
      }, void 0)]
    }), void 0);
  },
  "corner-down-left": function cornerDownLeft(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "corner-down-left_svg__feather corner-down-left_svg__feather-corner-down-left"
    }, n, {
      children: [e("path", {
        d: "M9 10l-5 5 5 5"
      }, void 0), e("path", {
        d: "M20 4v7a4 4 0 01-4 4H4"
      }, void 0)]
    }), void 0);
  },
  "corner-down-right": function cornerDownRight(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "corner-down-right_svg__feather corner-down-right_svg__feather-corner-down-right"
    }, n, {
      children: [e("path", {
        d: "M15 10l5 5-5 5"
      }, void 0), e("path", {
        d: "M4 4v7a4 4 0 004 4h12"
      }, void 0)]
    }), void 0);
  },
  "corner-left-down": function cornerLeftDown(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "corner-left-down_svg__feather corner-left-down_svg__feather-corner-left-down"
    }, n, {
      children: [e("path", {
        d: "M14 15l-5 5-5-5"
      }, void 0), e("path", {
        d: "M20 4h-7a4 4 0 00-4 4v12"
      }, void 0)]
    }), void 0);
  },
  "corner-left-up": function cornerLeftUp(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "corner-left-up_svg__feather corner-left-up_svg__feather-corner-left-up"
    }, n, {
      children: [e("path", {
        d: "M14 9L9 4 4 9"
      }, void 0), e("path", {
        d: "M20 20h-7a4 4 0 01-4-4V4"
      }, void 0)]
    }), void 0);
  },
  "corner-right-down": function cornerRightDown(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "corner-right-down_svg__feather corner-right-down_svg__feather-corner-right-down"
    }, n, {
      children: [e("path", {
        d: "M10 15l5 5 5-5"
      }, void 0), e("path", {
        d: "M4 4h7a4 4 0 014 4v12"
      }, void 0)]
    }), void 0);
  },
  "corner-right-up": function cornerRightUp(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "corner-right-up_svg__feather corner-right-up_svg__feather-corner-right-up"
    }, n, {
      children: [e("path", {
        d: "M10 9l5-5 5 5"
      }, void 0), e("path", {
        d: "M4 20h7a4 4 0 004-4V4"
      }, void 0)]
    }), void 0);
  },
  "corner-up-left": function cornerUpLeft(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "corner-up-left_svg__feather corner-up-left_svg__feather-corner-up-left"
    }, n, {
      children: [e("path", {
        d: "M9 14L4 9l5-5"
      }, void 0), e("path", {
        d: "M20 20v-7a4 4 0 00-4-4H4"
      }, void 0)]
    }), void 0);
  },
  "corner-up-right": function cornerUpRight(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "corner-up-right_svg__feather corner-up-right_svg__feather-corner-up-right"
    }, n, {
      children: [e("path", {
        d: "M15 14l5-5-5-5"
      }, void 0), e("path", {
        d: "M4 20v-7a4 4 0 014-4h12"
      }, void 0)]
    }), void 0);
  },
  cpu: function cpu(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "cpu_svg__feather cpu_svg__feather-cpu"
    }, n, {
      children: [e("rect", {
        x: 4,
        y: 4,
        width: 16,
        height: 16,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M9 9h6v6H9zM9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3"
      }, void 0)]
    }), void 0);
  },
  "credit-card": function creditCard(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "credit-card_svg__feather credit-card_svg__feather-credit-card"
    }, n, {
      children: [e("rect", {
        x: 1,
        y: 4,
        width: 22,
        height: 16,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M1 10h22"
      }, void 0)]
    }), void 0);
  },
  crop: function crop(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "crop_svg__feather crop_svg__feather-crop"
    }, n, {
      children: [e("path", {
        d: "M6.13 1L6 16a2 2 0 002 2h15"
      }, void 0), e("path", {
        d: "M1 6.13L16 6a2 2 0 012 2v15"
      }, void 0)]
    }), void 0);
  },
  crosshair: function crosshair(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "crosshair_svg__feather crosshair_svg__feather-crosshair"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M22 12h-4M6 12H2M12 6V2M12 22v-4"
      }, void 0)]
    }), void 0);
  },
  database: function database(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "database_svg__feather database_svg__feather-database"
    }, n, {
      children: [e("ellipse", {
        cx: 12,
        cy: 5,
        rx: 9,
        ry: 3
      }, void 0), e("path", {
        d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
      }, void 0), e("path", {
        d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
      }, void 0)]
    }), void 0);
  },
  delete: function _delete(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "delete_svg__feather delete_svg__feather-delete"
    }, o, {
      children: e("path", {
        d: "M21 4H8l-7 8 7 8h13a2 2 0 002-2V6a2 2 0 00-2-2zM18 9l-6 6M12 9l6 6"
      }, void 0)
    }), void 0);
  },
  disc: function disc(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "disc_svg__feather disc_svg__feather-disc"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("circle", {
        cx: 12,
        cy: 12,
        r: 3
      }, void 0)]
    }), void 0);
  },
  "dollar-sign": function dollarSign(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "dollar-sign_svg__feather dollar-sign_svg__feather-dollar-sign"
    }, o, {
      children: e("path", {
        d: "M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"
      }, void 0)
    }), void 0);
  },
  "download-cloud": function downloadCloud(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "download-cloud_svg__feather download-cloud_svg__feather-download-cloud"
    }, n, {
      children: [e("path", {
        d: "M8 17l4 4 4-4M12 12v9"
      }, void 0), e("path", {
        d: "M20.88 18.09A5 5 0 0018 9h-1.26A8 8 0 103 16.29"
      }, void 0)]
    }), void 0);
  },
  download: function download(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "download_svg__feather download_svg__feather-download"
    }, o, {
      children: e("path", {
        d: "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"
      }, void 0)
    }), void 0);
  },
  droplet: function droplet(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "droplet_svg__feather droplet_svg__feather-droplet"
    }, o, {
      children: e("path", {
        d: "M12 2.69l5.66 5.66a8 8 0 11-11.31 0z"
      }, void 0)
    }), void 0);
  },
  "edit-2": function edit2(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "edit-2_svg__feather edit-2_svg__feather-edit-2"
    }, o, {
      children: e("path", {
        d: "M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"
      }, void 0)
    }), void 0);
  },
  "edit-3": function edit3(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "edit-3_svg__feather edit-3_svg__feather-edit-3"
    }, o, {
      children: e("path", {
        d: "M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"
      }, void 0)
    }), void 0);
  },
  edit: function edit(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "edit_svg__feather edit_svg__feather-edit"
    }, n, {
      children: [e("path", {
        d: "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
      }, void 0), e("path", {
        d: "M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
      }, void 0)]
    }), void 0);
  },
  "external-link": function externalLink(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "external-link_svg__feather external-link_svg__feather-external-link"
    }, o, {
      children: e("path", {
        d: "M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"
      }, void 0)
    }), void 0);
  },
  "eye-off": function eyeOff(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "eye-off_svg__feather eye-off_svg__feather-eye-off"
    }, o, {
      children: e("path", {
        d: "M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22"
      }, void 0)
    }), void 0);
  },
  eye: function eye(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "eye_svg__feather eye_svg__feather-eye"
    }, n, {
      children: [e("path", {
        d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
      }, void 0), e("circle", {
        cx: 12,
        cy: 12,
        r: 3
      }, void 0)]
    }), void 0);
  },
  facebook: function facebook(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "facebook_svg__feather facebook_svg__feather-facebook"
    }, o, {
      children: e("path", {
        d: "M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"
      }, void 0)
    }), void 0);
  },
  "fast-forward": function fastForward(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "fast-forward_svg__feather fast-forward_svg__feather-fast-forward"
    }, o, {
      children: e("path", {
        d: "M13 19l9-7-9-7v14zM2 19l9-7-9-7v14z"
      }, void 0)
    }), void 0);
  },
  feather: function feather(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "feather_svg__feather feather_svg__feather-feather"
    }, o, {
      children: e("path", {
        d: "M20.24 12.24a6 6 0 00-8.49-8.49L5 10.5V19h8.5zM16 8L2 22M17.5 15H9"
      }, void 0)
    }), void 0);
  },
  figma: function figma(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "figma_svg__feather figma_svg__feather-figma"
    }, n, {
      children: [e("path", {
        d: "M5 5.5A3.5 3.5 0 018.5 2H12v7H8.5A3.5 3.5 0 015 5.5zM12 2h3.5a3.5 3.5 0 110 7H12V2z"
      }, void 0), e("path", {
        d: "M12 12.5a3.5 3.5 0 117 0 3.5 3.5 0 11-7 0zM5 19.5A3.5 3.5 0 018.5 16H12v3.5a3.5 3.5 0 11-7 0zM5 12.5A3.5 3.5 0 018.5 9H12v7H8.5A3.5 3.5 0 015 12.5z"
      }, void 0)]
    }), void 0);
  },
  "file-minus": function fileMinus(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "file-minus_svg__feather file-minus_svg__feather-file-minus"
    }, n, {
      children: [e("path", {
        d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
      }, void 0), e("path", {
        d: "M14 2v6h6M9 15h6"
      }, void 0)]
    }), void 0);
  },
  "file-plus": function filePlus(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "file-plus_svg__feather file-plus_svg__feather-file-plus"
    }, n, {
      children: [e("path", {
        d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
      }, void 0), e("path", {
        d: "M14 2v6h6M12 18v-6M9 15h6"
      }, void 0)]
    }), void 0);
  },
  "file-text": function fileText(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "file-text_svg__feather file-text_svg__feather-file-text"
    }, n, {
      children: [e("path", {
        d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
      }, void 0), e("path", {
        d: "M14 2v6h6M16 13H8M16 17H8M10 9H8"
      }, void 0)]
    }), void 0);
  },
  file: function file(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "file_svg__feather file_svg__feather-file"
    }, n, {
      children: [e("path", {
        d: "M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z"
      }, void 0), e("path", {
        d: "M13 2v7h7"
      }, void 0)]
    }), void 0);
  },
  film: function film(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "film_svg__feather film_svg__feather-film"
    }, n, {
      children: [e("rect", {
        x: 2,
        y: 2,
        width: 20,
        height: 20,
        rx: 2.18,
        ry: 2.18
      }, void 0), e("path", {
        d: "M7 2v20M17 2v20M2 12h20M2 7h5M2 17h5M17 17h5M17 7h5"
      }, void 0)]
    }), void 0);
  },
  filter: function filter(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "filter_svg__feather filter_svg__feather-filter"
    }, o, {
      children: e("path", {
        d: "M22 3H2l8 9.46V19l4 2v-8.54L22 3z"
      }, void 0)
    }), void 0);
  },
  flag: function flag(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "flag_svg__feather flag_svg__feather-flag"
    }, o, {
      children: e("path", {
        d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7"
      }, void 0)
    }), void 0);
  },
  "folder-minus": function folderMinus(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "folder-minus_svg__feather folder-minus_svg__feather-folder-minus"
    }, o, {
      children: e("path", {
        d: "M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2zM9 14h6"
      }, void 0)
    }), void 0);
  },
  "folder-plus": function folderPlus(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "folder-plus_svg__feather folder-plus_svg__feather-folder-plus"
    }, o, {
      children: e("path", {
        d: "M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2zM12 11v6M9 14h6"
      }, void 0)
    }), void 0);
  },
  folder: function folder(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "folder_svg__feather folder_svg__feather-folder"
    }, o, {
      children: e("path", {
        d: "M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"
      }, void 0)
    }), void 0);
  },
  framer: function framer(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "framer_svg__feather framer_svg__feather-framer"
    }, o, {
      children: e("path", {
        d: "M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"
      }, void 0)
    }), void 0);
  },
  frown: function frown(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "frown_svg__feather frown_svg__feather-frown"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M16 16s-1.5-2-4-2-4 2-4 2M9 9h.01M15 9h.01"
      }, void 0)]
    }), void 0);
  },
  gift: function gift(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "gift_svg__feather gift_svg__feather-gift"
    }, o, {
      children: e("path", {
        d: "M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"
      }, void 0)
    }), void 0);
  },
  "git-branch": function gitBranch(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "git-branch_svg__feather git-branch_svg__feather-git-branch"
    }, n, {
      children: [e("path", {
        d: "M6 3v12"
      }, void 0), e("circle", {
        cx: 18,
        cy: 6,
        r: 3
      }, void 0), e("circle", {
        cx: 6,
        cy: 18,
        r: 3
      }, void 0), e("path", {
        d: "M18 9a9 9 0 01-9 9"
      }, void 0)]
    }), void 0);
  },
  "git-commit": function gitCommit(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "git-commit_svg__feather git-commit_svg__feather-git-commit"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 4
      }, void 0), e("path", {
        d: "M1.05 12H7M17.01 12h5.95"
      }, void 0)]
    }), void 0);
  },
  "git-merge": function gitMerge(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "git-merge_svg__feather git-merge_svg__feather-git-merge"
    }, n, {
      children: [e("circle", {
        cx: 18,
        cy: 18,
        r: 3
      }, void 0), e("circle", {
        cx: 6,
        cy: 6,
        r: 3
      }, void 0), e("path", {
        d: "M6 21V9a9 9 0 009 9"
      }, void 0)]
    }), void 0);
  },
  "git-pull-request": function gitPullRequest(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "git-pull-request_svg__feather git-pull-request_svg__feather-git-pull-request"
    }, n, {
      children: [e("circle", {
        cx: 18,
        cy: 18,
        r: 3
      }, void 0), e("circle", {
        cx: 6,
        cy: 6,
        r: 3
      }, void 0), e("path", {
        d: "M13 6h3a2 2 0 012 2v7M6 9v12"
      }, void 0)]
    }), void 0);
  },
  github: function github(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "github_svg__feather github_svg__feather-github"
    }, o, {
      children: e("path", {
        d: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"
      }, void 0)
    }), void 0);
  },
  gitlab: function gitlab(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "gitlab_svg__feather gitlab_svg__feather-gitlab"
    }, o, {
      children: e("path", {
        d: "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 01-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 014.82 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0118.6 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.51L23 13.45a.84.84 0 01-.35.94z"
      }, void 0)
    }), void 0);
  },
  globe: function globe(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "globe_svg__feather globe_svg__feather-globe"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"
      }, void 0)]
    }), void 0);
  },
  grid: function grid(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "grid_svg__feather grid_svg__feather-grid"
    }, o, {
      children: e("path", {
        d: "M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z"
      }, void 0)
    }), void 0);
  },
  "hard-drive": function hardDrive(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "hard-drive_svg__feather hard-drive_svg__feather-hard-drive"
    }, o, {
      children: e("path", {
        d: "M22 12H2M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11zM6 16h.01M10 16h.01"
      }, void 0)
    }), void 0);
  },
  hash: function hash(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "hash_svg__feather hash_svg__feather-hash"
    }, o, {
      children: e("path", {
        d: "M4 9h16M4 15h16M10 3L8 21M16 3l-2 18"
      }, void 0)
    }), void 0);
  },
  headphones: function headphones(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "headphones_svg__feather headphones_svg__feather-headphones"
    }, n, {
      children: [e("path", {
        d: "M3 18v-6a9 9 0 0118 0v6"
      }, void 0), e("path", {
        d: "M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z"
      }, void 0)]
    }), void 0);
  },
  heart: function heart(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "heart_svg__feather heart_svg__feather-heart"
    }, o, {
      children: e("path", {
        d: "M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"
      }, void 0)
    }), void 0);
  },
  "help-circle": function helpCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "help-circle_svg__feather help-circle_svg__feather-help-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01"
      }, void 0)]
    }), void 0);
  },
  hexagon: function hexagon(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "hexagon_svg__feather hexagon_svg__feather-hexagon"
    }, o, {
      children: e("path", {
        d: "M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"
      }, void 0)
    }), void 0);
  },
  home: function home(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "home_svg__feather home_svg__feather-home"
    }, n, {
      children: [e("path", {
        d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
      }, void 0), e("path", {
        d: "M9 22V12h6v10"
      }, void 0)]
    }), void 0);
  },
  image: function image(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "image_svg__feather image_svg__feather-image"
    }, n, {
      children: [e("rect", {
        x: 3,
        y: 3,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2
      }, void 0), e("circle", {
        cx: 8.5,
        cy: 8.5,
        r: 1.5
      }, void 0), e("path", {
        d: "M21 15l-5-5L5 21"
      }, void 0)]
    }), void 0);
  },
  inbox: function inbox(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "inbox_svg__feather inbox_svg__feather-inbox"
    }, n, {
      children: [e("path", {
        d: "M22 12h-6l-2 3h-4l-2-3H2"
      }, void 0), e("path", {
        d: "M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z"
      }, void 0)]
    }), void 0);
  },
  info: function info(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "info_svg__feather info_svg__feather-info"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M12 16v-4M12 8h.01"
      }, void 0)]
    }), void 0);
  },
  instagram: function instagram(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "instagram_svg__feather instagram_svg__feather-instagram"
    }, n, {
      children: [e("rect", {
        x: 2,
        y: 2,
        width: 20,
        height: 20,
        rx: 5,
        ry: 5
      }, void 0), e("path", {
        d: "M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zM17.5 6.5h.01"
      }, void 0)]
    }), void 0);
  },
  italic: function italic(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "italic_svg__feather italic_svg__feather-italic"
    }, o, {
      children: e("path", {
        d: "M19 4h-9M14 20H5M15 4L9 20"
      }, void 0)
    }), void 0);
  },
  key: function key(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "key_svg__feather key_svg__feather-key"
    }, o, {
      children: e("path", {
        d: "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
      }, void 0)
    }), void 0);
  },
  layers: function layers(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "layers_svg__feather layers_svg__feather-layers"
    }, o, {
      children: e("path", {
        d: "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
      }, void 0)
    }), void 0);
  },
  layout: function layout(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "layout_svg__feather layout_svg__feather-layout"
    }, n, {
      children: [e("rect", {
        x: 3,
        y: 3,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M3 9h18M9 21V9"
      }, void 0)]
    }), void 0);
  },
  "life-buoy": function lifeBuoy(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "life-buoy_svg__feather life-buoy_svg__feather-life-buoy"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("circle", {
        cx: 12,
        cy: 12,
        r: 4
      }, void 0), e("path", {
        d: "M4.93 4.93l4.24 4.24M14.83 14.83l4.24 4.24M14.83 9.17l4.24-4.24M14.83 9.17l3.53-3.53M4.93 19.07l4.24-4.24"
      }, void 0)]
    }), void 0);
  },
  "link-2": function link2(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "link-2_svg__feather link-2_svg__feather-link-2"
    }, o, {
      children: e("path", {
        d: "M15 7h3a5 5 0 015 5 5 5 0 01-5 5h-3m-6 0H6a5 5 0 01-5-5 5 5 0 015-5h3M8 12h8"
      }, void 0)
    }), void 0);
  },
  link: function link(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "link_svg__feather link_svg__feather-link"
    }, n, {
      children: [e("path", {
        d: "M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"
      }, void 0), e("path", {
        d: "M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"
      }, void 0)]
    }), void 0);
  },
  linkedin: function linkedin(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "linkedin_svg__feather linkedin_svg__feather-linkedin"
    }, n, {
      children: [e("path", {
        d: "M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
      }, void 0), e("circle", {
        cx: 4,
        cy: 4,
        r: 2
      }, void 0)]
    }), void 0);
  },
  list: function list(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "list_svg__feather list_svg__feather-list"
    }, o, {
      children: e("path", {
        d: "M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"
      }, void 0)
    }), void 0);
  },
  loader: function loader(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "loader_svg__feather loader_svg__feather-loader"
    }, o, {
      children: e("path", {
        d: "M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"
      }, void 0)
    }), void 0);
  },
  lock: function lock(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "lock_svg__feather lock_svg__feather-lock"
    }, n, {
      children: [e("rect", {
        x: 3,
        y: 11,
        width: 18,
        height: 11,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M7 11V7a5 5 0 0110 0v4"
      }, void 0)]
    }), void 0);
  },
  "log-in": function logIn(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "log-in_svg__feather log-in_svg__feather-log-in"
    }, o, {
      children: e("path", {
        d: "M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M15 12H3"
      }, void 0)
    }), void 0);
  },
  "log-out": function logOut(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "log-out_svg__feather log-out_svg__feather-log-out"
    }, o, {
      children: e("path", {
        d: "M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"
      }, void 0)
    }), void 0);
  },
  mail: function mail(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "mail_svg__feather mail_svg__feather-mail"
    }, n, {
      children: [e("path", {
        d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
      }, void 0), e("path", {
        d: "M22 6l-10 7L2 6"
      }, void 0)]
    }), void 0);
  },
  "map-pin": function mapPin(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "map-pin_svg__feather map-pin_svg__feather-map-pin"
    }, n, {
      children: [e("path", {
        d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"
      }, void 0), e("circle", {
        cx: 12,
        cy: 10,
        r: 3
      }, void 0)]
    }), void 0);
  },
  map: function map(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "map_svg__feather map_svg__feather-map"
    }, o, {
      children: e("path", {
        d: "M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4zM8 2v16M16 6v16"
      }, void 0)
    }), void 0);
  },
  "maximize-2": function maximize2(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "maximize-2_svg__feather maximize-2_svg__feather-maximize-2"
    }, o, {
      children: e("path", {
        d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"
      }, void 0)
    }), void 0);
  },
  maximize: function maximize(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "maximize_svg__feather maximize_svg__feather-maximize"
    }, o, {
      children: e("path", {
        d: "M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3"
      }, void 0)
    }), void 0);
  },
  meh: function meh(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "meh_svg__feather meh_svg__feather-meh"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M8 15h8M9 9h.01M15 9h.01"
      }, void 0)]
    }), void 0);
  },
  menu: function menu(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "menu_svg__feather menu_svg__feather-menu"
    }, o, {
      children: e("path", {
        d: "M3 12h18M3 6h18M3 18h18"
      }, void 0)
    }), void 0);
  },
  "message-circle": function messageCircle(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "message-circle_svg__feather message-circle_svg__feather-message-circle"
    }, o, {
      children: e("path", {
        d: "M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"
      }, void 0)
    }), void 0);
  },
  "message-square": function messageSquare(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "message-square_svg__feather message-square_svg__feather-message-square"
    }, o, {
      children: e("path", {
        d: "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"
      }, void 0)
    }), void 0);
  },
  "mic-off": function micOff(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "mic-off_svg__feather mic-off_svg__feather-mic-off"
    }, n, {
      children: [e("path", {
        d: "M1 1l22 22M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6"
      }, void 0), e("path", {
        d: "M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23M12 19v4M8 23h8"
      }, void 0)]
    }), void 0);
  },
  mic: function mic(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "mic_svg__feather mic_svg__feather-mic"
    }, n, {
      children: [e("path", {
        d: "M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"
      }, void 0), e("path", {
        d: "M19 10v2a7 7 0 01-14 0v-2M12 19v4M8 23h8"
      }, void 0)]
    }), void 0);
  },
  "minimize-2": function minimize2(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "minimize-2_svg__feather minimize-2_svg__feather-minimize-2"
    }, o, {
      children: e("path", {
        d: "M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7"
      }, void 0)
    }), void 0);
  },
  minimize: function minimize(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "minimize_svg__feather minimize_svg__feather-minimize"
    }, o, {
      children: e("path", {
        d: "M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3"
      }, void 0)
    }), void 0);
  },
  "minus-circle": function minusCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "minus-circle_svg__feather minus-circle_svg__feather-minus-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M8 12h8"
      }, void 0)]
    }), void 0);
  },
  "minus-square": function minusSquare(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "minus-square_svg__feather minus-square_svg__feather-minus-square"
    }, n, {
      children: [e("rect", {
        x: 3,
        y: 3,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M8 12h8"
      }, void 0)]
    }), void 0);
  },
  minus: function minus(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "minus_svg__feather minus_svg__feather-minus"
    }, o, {
      children: e("path", {
        d: "M5 12h14"
      }, void 0)
    }), void 0);
  },
  monitor: function monitor(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "monitor_svg__feather monitor_svg__feather-monitor"
    }, n, {
      children: [e("rect", {
        x: 2,
        y: 3,
        width: 20,
        height: 14,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M8 21h8M12 17v4"
      }, void 0)]
    }), void 0);
  },
  moon: function moon(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "moon_svg__feather moon_svg__feather-moon"
    }, o, {
      children: e("path", {
        d: "M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
      }, void 0)
    }), void 0);
  },
  "more-horizontal": function moreHorizontal(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "more-horizontal_svg__feather more-horizontal_svg__feather-more-horizontal"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 1
      }, void 0), e("circle", {
        cx: 19,
        cy: 12,
        r: 1
      }, void 0), e("circle", {
        cx: 5,
        cy: 12,
        r: 1
      }, void 0)]
    }), void 0);
  },
  "more-vertical": function moreVertical(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "more-vertical_svg__feather more-vertical_svg__feather-more-vertical"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 1
      }, void 0), e("circle", {
        cx: 12,
        cy: 5,
        r: 1
      }, void 0), e("circle", {
        cx: 12,
        cy: 19,
        r: 1
      }, void 0)]
    }), void 0);
  },
  "mouse-pointer": function mousePointer(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "mouse-pointer_svg__feather mouse-pointer_svg__feather-mouse-pointer"
    }, o, {
      children: e("path", {
        d: "M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3zM13 13l6 6"
      }, void 0)
    }), void 0);
  },
  move: function move(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "move_svg__feather move_svg__feather-move"
    }, o, {
      children: e("path", {
        d: "M5 9l-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20"
      }, void 0)
    }), void 0);
  },
  music: function music(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "music_svg__feather music_svg__feather-music"
    }, n, {
      children: [e("path", {
        d: "M9 18V5l12-2v13"
      }, void 0), e("circle", {
        cx: 6,
        cy: 18,
        r: 3
      }, void 0), e("circle", {
        cx: 18,
        cy: 16,
        r: 3
      }, void 0)]
    }), void 0);
  },
  "navigation-2": function navigation2(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "navigation-2_svg__feather navigation-2_svg__feather-navigation-2"
    }, o, {
      children: e("path", {
        d: "M12 2l7 19-7-4-7 4 7-19z"
      }, void 0)
    }), void 0);
  },
  navigation: function navigation(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "navigation_svg__feather navigation_svg__feather-navigation"
    }, o, {
      children: e("path", {
        d: "M3 11l19-9-9 19-2-8-8-2z"
      }, void 0)
    }), void 0);
  },
  octagon: function octagon(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "octagon_svg__feather octagon_svg__feather-octagon"
    }, o, {
      children: e("path", {
        d: "M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2z"
      }, void 0)
    }), void 0);
  },
  package: function _package(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "package_svg__feather package_svg__feather-package"
    }, n, {
      children: [e("path", {
        d: "M16.5 9.4l-9-5.19M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"
      }, void 0), e("path", {
        d: "M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"
      }, void 0)]
    }), void 0);
  },
  paperclip: function paperclip(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "paperclip_svg__feather paperclip_svg__feather-paperclip"
    }, o, {
      children: e("path", {
        d: "M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"
      }, void 0)
    }), void 0);
  },
  "pause-circle": function pauseCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "pause-circle_svg__feather pause-circle_svg__feather-pause-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M10 15V9M14 15V9"
      }, void 0)]
    }), void 0);
  },
  pause: function pause(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "pause_svg__feather pause_svg__feather-pause"
    }, o, {
      children: e("path", {
        d: "M6 4h4v16H6zM14 4h4v16h-4z"
      }, void 0)
    }), void 0);
  },
  "pen-tool": function penTool(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "pen-tool_svg__feather pen-tool_svg__feather-pen-tool"
    }, n, {
      children: [e("path", {
        d: "M12 19l7-7 3 3-7 7-3-3z"
      }, void 0), e("path", {
        d: "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5zM2 2l7.586 7.586"
      }, void 0), e("circle", {
        cx: 11,
        cy: 11,
        r: 2
      }, void 0)]
    }), void 0);
  },
  percent: function percent(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "percent_svg__feather percent_svg__feather-percent"
    }, n, {
      children: [e("path", {
        d: "M19 5L5 19"
      }, void 0), e("circle", {
        cx: 6.5,
        cy: 6.5,
        r: 2.5
      }, void 0), e("circle", {
        cx: 17.5,
        cy: 17.5,
        r: 2.5
      }, void 0)]
    }), void 0);
  },
  "phone-call": function phoneCall(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "phone-call_svg__feather phone-call_svg__feather-phone-call"
    }, o, {
      children: e("path", {
        d: "M15.05 5A5 5 0 0119 8.95M15.05 1A9 9 0 0123 8.94m-1 7.98v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
      }, void 0)
    }), void 0);
  },
  "phone-forwarded": function phoneForwarded(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "phone-forwarded_svg__feather phone-forwarded_svg__feather-phone-forwarded"
    }, o, {
      children: e("path", {
        d: "M19 1l4 4-4 4M15 5h8M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
      }, void 0)
    }), void 0);
  },
  "phone-incoming": function phoneIncoming(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "phone-incoming_svg__feather phone-incoming_svg__feather-phone-incoming"
    }, o, {
      children: e("path", {
        d: "M16 2v6h6M23 1l-7 7M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
      }, void 0)
    }), void 0);
  },
  "phone-missed": function phoneMissed(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "phone-missed_svg__feather phone-missed_svg__feather-phone-missed"
    }, o, {
      children: e("path", {
        d: "M23 1l-6 6M17 1l6 6M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
      }, void 0)
    }), void 0);
  },
  "phone-off": function phoneOff(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "phone-off_svg__feather phone-off_svg__feather-phone-off"
    }, o, {
      children: e("path", {
        d: "M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7 2 2 0 011.72 2v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.42 19.42 0 01-3.33-2.67m-2.67-3.34a19.79 19.79 0 01-3.07-8.63A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91M23 1L1 23"
      }, void 0)
    }), void 0);
  },
  "phone-outgoing": function phoneOutgoing(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "phone-outgoing_svg__feather phone-outgoing_svg__feather-phone-outgoing"
    }, o, {
      children: e("path", {
        d: "M23 7V1h-6M16 8l7-7M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
      }, void 0)
    }), void 0);
  },
  phone: function phone(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "phone_svg__feather phone_svg__feather-phone"
    }, o, {
      children: e("path", {
        d: "M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
      }, void 0)
    }), void 0);
  },
  "pie-chart": function pieChart(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "pie-chart_svg__feather pie-chart_svg__feather-pie-chart"
    }, o, {
      children: e("path", {
        d: "M21.21 15.89A10 10 0 118 2.83M22 12A10 10 0 0012 2v10z"
      }, void 0)
    }), void 0);
  },
  "play-circle": function playCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "play-circle_svg__feather play-circle_svg__feather-play-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M10 8l6 4-6 4V8z"
      }, void 0)]
    }), void 0);
  },
  play: function play(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "play_svg__feather play_svg__feather-play"
    }, o, {
      children: e("path", {
        d: "M5 3l14 9-14 9V3z"
      }, void 0)
    }), void 0);
  },
  "plus-circle": function plusCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "plus-circle_svg__feather plus-circle_svg__feather-plus-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M12 8v8M8 12h8"
      }, void 0)]
    }), void 0);
  },
  "plus-square": function plusSquare(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "plus-square_svg__feather plus-square_svg__feather-plus-square"
    }, n, {
      children: [e("rect", {
        x: 3,
        y: 3,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M12 8v8M8 12h8"
      }, void 0)]
    }), void 0);
  },
  plus: function plus(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "plus_svg__feather plus_svg__feather-plus"
    }, o, {
      children: e("path", {
        d: "M12 5v14M5 12h14"
      }, void 0)
    }), void 0);
  },
  pocket: function pocket(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "pocket_svg__feather pocket_svg__feather-pocket"
    }, n, {
      children: [e("path", {
        d: "M4 3h16a2 2 0 012 2v6a10 10 0 01-10 10A10 10 0 012 11V5a2 2 0 012-2z"
      }, void 0), e("path", {
        d: "M8 10l4 4 4-4"
      }, void 0)]
    }), void 0);
  },
  power: function power(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "power_svg__feather power_svg__feather-power"
    }, o, {
      children: e("path", {
        d: "M18.36 6.64a9 9 0 11-12.73 0M12 2v10"
      }, void 0)
    }), void 0);
  },
  printer: function printer(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "printer_svg__feather printer_svg__feather-printer"
    }, n, {
      children: [e("path", {
        d: "M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"
      }, void 0), e("path", {
        d: "M6 14h12v8H6z"
      }, void 0)]
    }), void 0);
  },
  radio: function radio(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "radio_svg__feather radio_svg__feather-radio"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 2
      }, void 0), e("path", {
        d: "M16.24 7.76a6 6 0 010 8.49m-8.48-.01a6 6 0 010-8.49m11.31-2.82a10 10 0 010 14.14m-14.14 0a10 10 0 010-14.14"
      }, void 0)]
    }), void 0);
  },
  "refresh-ccw": function refreshCcw(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "refresh-ccw_svg__feather refresh-ccw_svg__feather-refresh-ccw"
    }, n, {
      children: [e("path", {
        d: "M1 4v6h6M23 20v-6h-6"
      }, void 0), e("path", {
        d: "M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15"
      }, void 0)]
    }), void 0);
  },
  "refresh-cw": function refreshCw(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "refresh-cw_svg__feather refresh-cw_svg__feather-refresh-cw"
    }, n, {
      children: [e("path", {
        d: "M23 4v6h-6M1 20v-6h6"
      }, void 0), e("path", {
        d: "M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"
      }, void 0)]
    }), void 0);
  },
  repeat: function repeat(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "repeat_svg__feather repeat_svg__feather-repeat"
    }, n, {
      children: [e("path", {
        d: "M17 1l4 4-4 4"
      }, void 0), e("path", {
        d: "M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4"
      }, void 0), e("path", {
        d: "M21 13v2a4 4 0 01-4 4H3"
      }, void 0)]
    }), void 0);
  },
  rewind: function rewind(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "rewind_svg__feather rewind_svg__feather-rewind"
    }, o, {
      children: e("path", {
        d: "M11 19l-9-7 9-7v14zM22 19l-9-7 9-7v14z"
      }, void 0)
    }), void 0);
  },
  "rotate-ccw": function rotateCcw(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "rotate-ccw_svg__feather rotate-ccw_svg__feather-rotate-ccw"
    }, n, {
      children: [e("path", {
        d: "M1 4v6h6"
      }, void 0), e("path", {
        d: "M3.51 15a9 9 0 102.13-9.36L1 10"
      }, void 0)]
    }), void 0);
  },
  "rotate-cw": function rotateCw(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "rotate-cw_svg__feather rotate-cw_svg__feather-rotate-cw"
    }, n, {
      children: [e("path", {
        d: "M23 4v6h-6"
      }, void 0), e("path", {
        d: "M20.49 15a9 9 0 11-2.12-9.36L23 10"
      }, void 0)]
    }), void 0);
  },
  rss: function rss(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "rss_svg__feather rss_svg__feather-rss"
    }, n, {
      children: [e("path", {
        d: "M4 11a9 9 0 019 9M4 4a16 16 0 0116 16"
      }, void 0), e("circle", {
        cx: 5,
        cy: 19,
        r: 1
      }, void 0)]
    }), void 0);
  },
  save: function save(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "save_svg__feather save_svg__feather-save"
    }, n, {
      children: [e("path", {
        d: "M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"
      }, void 0), e("path", {
        d: "M17 21v-8H7v8M7 3v5h8"
      }, void 0)]
    }), void 0);
  },
  scissors: function scissors(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "scissors_svg__feather scissors_svg__feather-scissors"
    }, n, {
      children: [e("circle", {
        cx: 6,
        cy: 6,
        r: 3
      }, void 0), e("circle", {
        cx: 6,
        cy: 18,
        r: 3
      }, void 0), e("path", {
        d: "M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12"
      }, void 0)]
    }), void 0);
  },
  search: function search(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "search_svg__feather search_svg__feather-search"
    }, n, {
      children: [e("circle", {
        cx: 11,
        cy: 11,
        r: 8
      }, void 0), e("path", {
        d: "M21 21l-4.35-4.35"
      }, void 0)]
    }), void 0);
  },
  send: function send(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "send_svg__feather send_svg__feather-send"
    }, o, {
      children: e("path", {
        d: "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"
      }, void 0)
    }), void 0);
  },
  server: function server(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "server_svg__feather server_svg__feather-server"
    }, n, {
      children: [e("rect", {
        x: 2,
        y: 2,
        width: 20,
        height: 8,
        rx: 2,
        ry: 2
      }, void 0), e("rect", {
        x: 2,
        y: 14,
        width: 20,
        height: 8,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M6 6h.01M6 18h.01"
      }, void 0)]
    }), void 0);
  },
  settings: function settings(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "settings_svg__feather settings_svg__feather-settings"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 3
      }, void 0), e("path", {
        d: "M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"
      }, void 0)]
    }), void 0);
  },
  "share-2": function share2(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "share-2_svg__feather share-2_svg__feather-share-2"
    }, n, {
      children: [e("circle", {
        cx: 18,
        cy: 5,
        r: 3
      }, void 0), e("circle", {
        cx: 6,
        cy: 12,
        r: 3
      }, void 0), e("circle", {
        cx: 18,
        cy: 19,
        r: 3
      }, void 0), e("path", {
        d: "M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98"
      }, void 0)]
    }), void 0);
  },
  share: function share(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "share_svg__feather share_svg__feather-share"
    }, o, {
      children: e("path", {
        d: "M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13"
      }, void 0)
    }), void 0);
  },
  "shield-off": function shieldOff(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "shield-off_svg__feather shield-off_svg__feather-shield-off"
    }, o, {
      children: e("path", {
        d: "M19.69 14a6.9 6.9 0 00.31-2V5l-8-3-3.16 1.18M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 005.62-4.38M1 1l22 22"
      }, void 0)
    }), void 0);
  },
  shield: function shield(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "shield_svg__feather shield_svg__feather-shield"
    }, o, {
      children: e("path", {
        d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
      }, void 0)
    }), void 0);
  },
  "shopping-bag": function shoppingBag(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "shopping-bag_svg__feather shopping-bag_svg__feather-shopping-bag"
    }, o, {
      children: e("path", {
        d: "M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"
      }, void 0)
    }), void 0);
  },
  "shopping-cart": function shoppingCart(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "shopping-cart_svg__feather shopping-cart_svg__feather-shopping-cart"
    }, n, {
      children: [e("circle", {
        cx: 9,
        cy: 21,
        r: 1
      }, void 0), e("circle", {
        cx: 20,
        cy: 21,
        r: 1
      }, void 0), e("path", {
        d: "M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"
      }, void 0)]
    }), void 0);
  },
  shuffle: function shuffle(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "shuffle_svg__feather shuffle_svg__feather-shuffle"
    }, o, {
      children: e("path", {
        d: "M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5"
      }, void 0)
    }), void 0);
  },
  sidebar: function sidebar(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "sidebar_svg__feather sidebar_svg__feather-sidebar"
    }, n, {
      children: [e("rect", {
        x: 3,
        y: 3,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M9 3v18"
      }, void 0)]
    }), void 0);
  },
  "skip-back": function skipBack(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "skip-back_svg__feather skip-back_svg__feather-skip-back"
    }, o, {
      children: e("path", {
        d: "M19 20L9 12l10-8v16zM5 19V5"
      }, void 0)
    }), void 0);
  },
  "skip-forward": function skipForward(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "skip-forward_svg__feather skip-forward_svg__feather-skip-forward"
    }, o, {
      children: e("path", {
        d: "M5 4l10 8-10 8V4zM19 5v14"
      }, void 0)
    }), void 0);
  },
  slack: function slack(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "slack_svg__feather slack_svg__feather-slack"
    }, o, {
      children: e("path", {
        d: "M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5zM20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5zM3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14zM14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5zM15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zM10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5zM8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"
      }, void 0)
    }), void 0);
  },
  slash: function slash(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "slash_svg__feather slash_svg__feather-slash"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M4.93 4.93l14.14 14.14"
      }, void 0)]
    }), void 0);
  },
  sliders: function sliders(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "sliders_svg__feather sliders_svg__feather-sliders"
    }, o, {
      children: e("path", {
        d: "M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6"
      }, void 0)
    }), void 0);
  },
  smartphone: function smartphone(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "smartphone_svg__feather smartphone_svg__feather-smartphone"
    }, n, {
      children: [e("rect", {
        x: 5,
        y: 2,
        width: 14,
        height: 20,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M12 18h.01"
      }, void 0)]
    }), void 0);
  },
  smile: function smile(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "smile_svg__feather smile_svg__feather-smile"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"
      }, void 0)]
    }), void 0);
  },
  speaker: function speaker(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "speaker_svg__feather speaker_svg__feather-speaker"
    }, n, {
      children: [e("rect", {
        x: 4,
        y: 2,
        width: 16,
        height: 20,
        rx: 2,
        ry: 2
      }, void 0), e("circle", {
        cx: 12,
        cy: 14,
        r: 4
      }, void 0), e("path", {
        d: "M12 6h.01"
      }, void 0)]
    }), void 0);
  },
  square: function square(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "square_svg__feather square_svg__feather-square"
    }, o, {
      children: e("rect", {
        x: 3,
        y: 3,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2
      }, void 0)
    }), void 0);
  },
  star: function star(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "star_svg__feather star_svg__feather-star"
    }, o, {
      children: e("path", {
        d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
      }, void 0)
    }), void 0);
  },
  "stop-circle": function stopCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "stop-circle_svg__feather stop-circle_svg__feather-stop-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M9 9h6v6H9z"
      }, void 0)]
    }), void 0);
  },
  sun: function sun(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "sun_svg__feather sun_svg__feather-sun"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 5
      }, void 0), e("path", {
        d: "M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
      }, void 0)]
    }), void 0);
  },
  sunrise: function sunrise(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "sunrise_svg__feather sunrise_svg__feather-sunrise"
    }, o, {
      children: e("path", {
        d: "M17 18a5 5 0 00-10 0M12 2v7M4.22 10.22l1.42 1.42M1 18h2M21 18h2M18.36 11.64l1.42-1.42M23 22H1M8 6l4-4 4 4"
      }, void 0)
    }), void 0);
  },
  sunset: function sunset(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "sunset_svg__feather sunset_svg__feather-sunset"
    }, o, {
      children: e("path", {
        d: "M17 18a5 5 0 00-10 0M12 9V2M4.22 10.22l1.42 1.42M1 18h2M21 18h2M18.36 11.64l1.42-1.42M23 22H1M16 5l-4 4-4-4"
      }, void 0)
    }), void 0);
  },
  tablet: function tablet(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "tablet_svg__feather tablet_svg__feather-tablet"
    }, n, {
      children: [e("rect", {
        x: 4,
        y: 2,
        width: 16,
        height: 20,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M12 18h.01"
      }, void 0)]
    }), void 0);
  },
  tag: function tag(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "tag_svg__feather tag_svg__feather-tag"
    }, o, {
      children: e("path", {
        d: "M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82zM7 7h.01"
      }, void 0)
    }), void 0);
  },
  target: function target(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "target_svg__feather target_svg__feather-target"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("circle", {
        cx: 12,
        cy: 12,
        r: 6
      }, void 0), e("circle", {
        cx: 12,
        cy: 12,
        r: 2
      }, void 0)]
    }), void 0);
  },
  terminal: function terminal(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "terminal_svg__feather terminal_svg__feather-terminal"
    }, o, {
      children: e("path", {
        d: "M4 17l6-6-6-6M12 19h8"
      }, void 0)
    }), void 0);
  },
  thermometer: function thermometer(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "thermometer_svg__feather thermometer_svg__feather-thermometer"
    }, o, {
      children: e("path", {
        d: "M14 14.76V3.5a2.5 2.5 0 00-5 0v11.26a4.5 4.5 0 105 0z"
      }, void 0)
    }), void 0);
  },
  "thumbs-down": function thumbsDown(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "thumbs-down_svg__feather thumbs-down_svg__feather-thumbs-down"
    }, o, {
      children: e("path", {
        d: "M10 15v4a3 3 0 003 3l4-9V2H5.72a2 2 0 00-2 1.7l-1.38 9a2 2 0 002 2.3zm7-13h2.67A2.31 2.31 0 0122 4v7a2.31 2.31 0 01-2.33 2H17"
      }, void 0)
    }), void 0);
  },
  "thumbs-up": function thumbsUp(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "thumbs-up_svg__feather thumbs-up_svg__feather-thumbs-up"
    }, o, {
      children: e("path", {
        d: "M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3"
      }, void 0)
    }), void 0);
  },
  "toggle-left": function toggleLeft(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "toggle-left_svg__feather toggle-left_svg__feather-toggle-left"
    }, n, {
      children: [e("rect", {
        x: 1,
        y: 5,
        width: 22,
        height: 14,
        rx: 7,
        ry: 7
      }, void 0), e("circle", {
        cx: 8,
        cy: 12,
        r: 3
      }, void 0)]
    }), void 0);
  },
  "toggle-right": function toggleRight(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "toggle-right_svg__feather toggle-right_svg__feather-toggle-right"
    }, n, {
      children: [e("rect", {
        x: 1,
        y: 5,
        width: 22,
        height: 14,
        rx: 7,
        ry: 7
      }, void 0), e("circle", {
        cx: 16,
        cy: 12,
        r: 3
      }, void 0)]
    }), void 0);
  },
  tool: function tool(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "tool_svg__feather tool_svg__feather-tool"
    }, o, {
      children: e("path", {
        d: "M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"
      }, void 0)
    }), void 0);
  },
  "trash-2": function trash2(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "trash-2_svg__feather trash-2_svg__feather-trash-2"
    }, o, {
      children: e("path", {
        d: "M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6"
      }, void 0)
    }), void 0);
  },
  trash: function trash(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "trash_svg__feather trash_svg__feather-trash"
    }, o, {
      children: e("path", {
        d: "M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"
      }, void 0)
    }), void 0);
  },
  trello: function trello(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "trello_svg__feather trello_svg__feather-trello"
    }, n, {
      children: [e("rect", {
        x: 3,
        y: 3,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M7 7h3v9H7zM14 7h3v5h-3z"
      }, void 0)]
    }), void 0);
  },
  "trending-down": function trendingDown(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "trending-down_svg__feather trending-down_svg__feather-trending-down"
    }, n, {
      children: [e("path", {
        d: "M23 18l-9.5-9.5-5 5L1 6"
      }, void 0), e("path", {
        d: "M17 18h6v-6"
      }, void 0)]
    }), void 0);
  },
  "trending-up": function trendingUp(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "trending-up_svg__feather trending-up_svg__feather-trending-up"
    }, n, {
      children: [e("path", {
        d: "M23 6l-9.5 9.5-5-5L1 18"
      }, void 0), e("path", {
        d: "M17 6h6v6"
      }, void 0)]
    }), void 0);
  },
  triangle: function triangle(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "triangle_svg__feather triangle_svg__feather-triangle"
    }, o, {
      children: e("path", {
        d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
      }, void 0)
    }), void 0);
  },
  truck: function truck(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "truck_svg__feather truck_svg__feather-truck"
    }, n, {
      children: [e("path", {
        d: "M1 3h15v13H1zM16 8h4l3 3v5h-7V8z"
      }, void 0), e("circle", {
        cx: 5.5,
        cy: 18.5,
        r: 2.5
      }, void 0), e("circle", {
        cx: 18.5,
        cy: 18.5,
        r: 2.5
      }, void 0)]
    }), void 0);
  },
  tv: function tv(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "tv_svg__feather tv_svg__feather-tv"
    }, n, {
      children: [e("rect", {
        x: 2,
        y: 7,
        width: 20,
        height: 15,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M17 2l-5 5-5-5"
      }, void 0)]
    }), void 0);
  },
  twitch: function twitch(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "twitch_svg__feather twitch_svg__feather-twitch"
    }, o, {
      children: e("path", {
        d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"
      }, void 0)
    }), void 0);
  },
  twitter: function twitter(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "twitter_svg__feather twitter_svg__feather-twitter"
    }, o, {
      children: e("path", {
        d: "M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"
      }, void 0)
    }), void 0);
  },
  type: function type(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "type_svg__feather type_svg__feather-type"
    }, o, {
      children: e("path", {
        d: "M4 7V4h16v3M9 20h6M12 4v16"
      }, void 0)
    }), void 0);
  },
  umbrella: function umbrella(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "umbrella_svg__feather umbrella_svg__feather-umbrella"
    }, o, {
      children: e("path", {
        d: "M23 12a11.05 11.05 0 00-22 0zm-5 7a3 3 0 01-6 0v-7"
      }, void 0)
    }), void 0);
  },
  underline: function underline(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "underline_svg__feather underline_svg__feather-underline"
    }, o, {
      children: e("path", {
        d: "M6 3v7a6 6 0 006 6 6 6 0 006-6V3M4 21h16"
      }, void 0)
    }), void 0);
  },
  unlock: function unlock(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "unlock_svg__feather unlock_svg__feather-unlock"
    }, n, {
      children: [e("rect", {
        x: 3,
        y: 11,
        width: 18,
        height: 11,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M7 11V7a5 5 0 019.9-1"
      }, void 0)]
    }), void 0);
  },
  "upload-cloud": function uploadCloud(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "upload-cloud_svg__feather upload-cloud_svg__feather-upload-cloud"
    }, n, {
      children: [e("path", {
        d: "M16 16l-4-4-4 4M12 12v9"
      }, void 0), e("path", {
        d: "M20.39 18.39A5 5 0 0018 9h-1.26A8 8 0 103 16.3"
      }, void 0), e("path", {
        d: "M16 16l-4-4-4 4"
      }, void 0)]
    }), void 0);
  },
  upload: function upload(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "upload_svg__feather upload_svg__feather-upload"
    }, o, {
      children: e("path", {
        d: "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"
      }, void 0)
    }), void 0);
  },
  "user-check": function userCheck(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "user-check_svg__feather user-check_svg__feather-user-check"
    }, n, {
      children: [e("path", {
        d: "M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
      }, void 0), e("circle", {
        cx: 8.5,
        cy: 7,
        r: 4
      }, void 0), e("path", {
        d: "M17 11l2 2 4-4"
      }, void 0)]
    }), void 0);
  },
  "user-minus": function userMinus(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "user-minus_svg__feather user-minus_svg__feather-user-minus"
    }, n, {
      children: [e("path", {
        d: "M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
      }, void 0), e("circle", {
        cx: 8.5,
        cy: 7,
        r: 4
      }, void 0), e("path", {
        d: "M23 11h-6"
      }, void 0)]
    }), void 0);
  },
  "user-plus": function userPlus(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "user-plus_svg__feather user-plus_svg__feather-user-plus"
    }, n, {
      children: [e("path", {
        d: "M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
      }, void 0), e("circle", {
        cx: 8.5,
        cy: 7,
        r: 4
      }, void 0), e("path", {
        d: "M20 8v6M23 11h-6"
      }, void 0)]
    }), void 0);
  },
  "user-x": function userX(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "user-x_svg__feather user-x_svg__feather-user-x"
    }, n, {
      children: [e("path", {
        d: "M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
      }, void 0), e("circle", {
        cx: 8.5,
        cy: 7,
        r: 4
      }, void 0), e("path", {
        d: "M18 8l5 5M23 8l-5 5"
      }, void 0)]
    }), void 0);
  },
  user: function user(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "user_svg__feather user_svg__feather-user"
    }, n, {
      children: [e("path", {
        d: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
      }, void 0), e("circle", {
        cx: 12,
        cy: 7,
        r: 4
      }, void 0)]
    }), void 0);
  },
  users: function users(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "users_svg__feather users_svg__feather-users"
    }, n, {
      children: [e("path", {
        d: "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
      }, void 0), e("circle", {
        cx: 9,
        cy: 7,
        r: 4
      }, void 0), e("path", {
        d: "M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
      }, void 0)]
    }), void 0);
  },
  "video-off": function videoOff(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "video-off_svg__feather video-off_svg__feather-video-off"
    }, o, {
      children: e("path", {
        d: "M16 16v1a2 2 0 01-2 2H3a2 2 0 01-2-2V7a2 2 0 012-2h2m5.66 0H14a2 2 0 012 2v3.34l1 1L23 7v10M1 1l22 22"
      }, void 0)
    }), void 0);
  },
  video: function video(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "video_svg__feather video_svg__feather-video"
    }, n, {
      children: [e("path", {
        d: "M23 7l-7 5 7 5V7z"
      }, void 0), e("rect", {
        x: 1,
        y: 5,
        width: 15,
        height: 14,
        rx: 2,
        ry: 2
      }, void 0)]
    }), void 0);
  },
  voicemail: function voicemail(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "voicemail_svg__feather voicemail_svg__feather-voicemail"
    }, n, {
      children: [e("circle", {
        cx: 5.5,
        cy: 11.5,
        r: 4.5
      }, void 0), e("circle", {
        cx: 18.5,
        cy: 11.5,
        r: 4.5
      }, void 0), e("path", {
        d: "M5.5 16h13"
      }, void 0)]
    }), void 0);
  },
  "volume-1": function volume1(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "volume-1_svg__feather volume-1_svg__feather-volume-1"
    }, o, {
      children: e("path", {
        d: "M11 5L6 9H2v6h4l5 4V5zM15.54 8.46a5 5 0 010 7.07"
      }, void 0)
    }), void 0);
  },
  "volume-2": function volume2(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "volume-2_svg__feather volume-2_svg__feather-volume-2"
    }, o, {
      children: e("path", {
        d: "M11 5L6 9H2v6h4l5 4V5zM19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"
      }, void 0)
    }), void 0);
  },
  "volume-x": function volumeX(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "volume-x_svg__feather volume-x_svg__feather-volume-x"
    }, o, {
      children: e("path", {
        d: "M11 5L6 9H2v6h4l5 4V5zM23 9l-6 6M17 9l6 6"
      }, void 0)
    }), void 0);
  },
  volume: function volume(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "volume_svg__feather volume_svg__feather-volume"
    }, o, {
      children: e("path", {
        d: "M11 5L6 9H2v6h4l5 4V5z"
      }, void 0)
    }), void 0);
  },
  watch: function watch(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "watch_svg__feather watch_svg__feather-watch"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 7
      }, void 0), e("path", {
        d: "M12 9v3l1.5 1.5M16.51 17.35l-.35 3.83a2 2 0 01-2 1.82H9.83a2 2 0 01-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 019.83 1h4.35a2 2 0 012 1.82l.35 3.83"
      }, void 0)]
    }), void 0);
  },
  "wifi-off": function wifiOff(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "wifi-off_svg__feather wifi-off_svg__feather-wifi-off"
    }, o, {
      children: e("path", {
        d: "M1 1l22 22M16.72 11.06A10.94 10.94 0 0119 12.55M5 12.55a10.94 10.94 0 015.17-2.39M10.71 5.05A16 16 0 0122.58 9M1.42 9a15.91 15.91 0 014.7-2.88M8.53 16.11a6 6 0 016.95 0M12 20h.01"
      }, void 0)
    }), void 0);
  },
  wifi: function wifi(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "wifi_svg__feather wifi_svg__feather-wifi"
    }, o, {
      children: e("path", {
        d: "M5 12.55a11 11 0 0114.08 0M1.42 9a16 16 0 0121.16 0M8.53 16.11a6 6 0 016.95 0M12 20h.01"
      }, void 0)
    }), void 0);
  },
  wind: function wind(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "wind_svg__feather wind_svg__feather-wind"
    }, o, {
      children: e("path", {
        d: "M9.59 4.59A2 2 0 1111 8H2m10.59 11.41A2 2 0 1014 16H2m15.73-8.27A2.5 2.5 0 1119.5 12H2"
      }, void 0)
    }), void 0);
  },
  "x-circle": function xCircle(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "x-circle_svg__feather x-circle_svg__feather-x-circle"
    }, n, {
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }, void 0), e("path", {
        d: "M15 9l-6 6M9 9l6 6"
      }, void 0)]
    }), void 0);
  },
  "x-octagon": function xOctagon(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "x-octagon_svg__feather x-octagon_svg__feather-x-octagon"
    }, o, {
      children: e("path", {
        d: "M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2zM15 9l-6 6M9 9l6 6"
      }, void 0)
    }), void 0);
  },
  "x-square": function xSquare(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "x-square_svg__feather x-square_svg__feather-x-square"
    }, n, {
      children: [e("rect", {
        x: 3,
        y: 3,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2
      }, void 0), e("path", {
        d: "M9 9l6 6M15 9l-6 6"
      }, void 0)]
    }), void 0);
  },
  x: function x(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "x_svg__feather x_svg__feather-x"
    }, o, {
      children: e("path", {
        d: "M18 6L6 18M6 6l12 12"
      }, void 0)
    }), void 0);
  },
  youtube: function youtube(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "youtube_svg__feather youtube_svg__feather-youtube"
    }, n, {
      children: [e("path", {
        d: "M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 11.75a29 29 0 00.46 5.33A2.78 2.78 0 003.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 29 29 0 00.46-5.25 29 29 0 00-.46-5.33z"
      }, void 0), e("path", {
        d: "M9.75 15.02l5.75-3.27-5.75-3.27v6.54z"
      }, void 0)]
    }), void 0);
  },
  "zap-off": function zapOff(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "zap-off_svg__feather zap-off_svg__feather-zap-off"
    }, o, {
      children: e("path", {
        d: "M12.41 6.75L13 2l-2.43 2.92M18.57 12.91L21 10h-5.34M8 8l-5 6h9l-1 8 5-6M1 1l22 22"
      }, void 0)
    }), void 0);
  },
  zap: function zap(o) {
    return e("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "zap_svg__feather zap_svg__feather-zap"
    }, o, {
      children: e("path", {
        d: "M13 2L3 14h9l-1 8 10-12h-9l1-8z"
      }, void 0)
    }), void 0);
  },
  "zoom-in": function zoomIn(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "zoom-in_svg__feather zoom-in_svg__feather-zoom-in"
    }, n, {
      children: [e("circle", {
        cx: 11,
        cy: 11,
        r: 8
      }, void 0), e("path", {
        d: "M21 21l-4.35-4.35M11 8v6M8 11h6"
      }, void 0)]
    }), void 0);
  },
  "zoom-out": function zoomOut(n) {
    return o("svg", _v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "zoom-out_svg__feather zoom-out_svg__feather-zoom-out"
    }, n, {
      children: [e("circle", {
        cx: 11,
        cy: 11,
        r: 8
      }, void 0), e("path", {
        d: "M21 21l-4.35-4.35M8 11h6"
      }, void 0)]
    }), void 0);
  }
},
    be = {
  lineHeight: 0,
  margin: 0,
  svg: {
    color: "var(--color-stone-300)",
    height: 20,
    strokeWidth: 1,
    width: 20
  }
},
    Ce = {
  svg: {
    height: 24,
    width: 24
  }
},
    Me = {
  svg: {
    height: 32,
    width: 32
  }
},
    Le = {
  svg: {
    height: 48,
    width: 48
  }
},
    je = function je(e) {
  var o,
      n,
      r,
      t = e.variant || "m";
  return [be, "m" === t && [Ce, null === (o = e.variantCss) || void 0 === o ? void 0 : o.m], "l" === t && [Me, null === (n = e.variantCss) || void 0 === n ? void 0 : n.l], "xl" === t && [Le, null === (r = e.variantCss) || void 0 === r ? void 0 : r.xl]];
},
    We = function We(o) {
  var n = o.anyCss,
      r = o.name,
      t = o.variant,
      i = o.variantCss,
      s = g(o, ["anyCss", "name", "variant", "variantCss"]),
      l = je({
    variant: t,
    variantCss: i
  }),
      a = xe[r || "book-open"];
  return e(H, _v({
    anyCss: re([l, n])
  }, {
    children: e(a, _v({}, s, {
      viewBox: "0 0 24 24"
    }), void 0)
  }), void 0);
},
    Ne = {
  backgroundColor: "var(--color-jeans-400)",
  border: "1px solid var(--color-jeans-400)",
  borderRadius: "var(--radius-pill)",
  color: "white",
  cursor: "pointer",
  display: "inline-flex",
  fontFamily: "var(--body-font-family)",
  fontSize: "var(--body-font-size-s)",
  fontWeight: "var(--body-font-weight)",
  gap: 10,
  justifyContent: "center",
  lineHeight: "var(--body-line-height-s)",
  padding: "8px 16px",
  textDecoration: "none",
  transition: "0.35s",
  userSelect: "none",
  ":active, :focus": {
    outline: "0",
    boxShadow: "0 0 6px var(--color-jeans-300)"
  },
  ":hover": {
    backgroundColor: "var(--color-jeans-500)",
    borderColor: "var(--color-jeans-500)"
  },
  "& > figure > svg": {
    color: "white",
    strokeWidth: 2
  }
},
    Ae = {
  fontSize: "var(--body-font-size-m)",
  lineHeight: "var(--body-line-height-m)",
  padding: "12px 24px",
  gap: 12
},
    Se = {
  fontSize: "var(--body-font-size-l)",
  lineHeight: "var(--body-line-height-l)",
  padding: "16px 32px",
  gap: 16
},
    He = {
  backgroundColor: "transparent",
  color: "var(--color-jeans-500)",
  ":hover": {
    backgroundColor: "transparent",
    borderColor: "var(--color-jeans-500)",
    color: "var(--color-jeans-500)"
  },
  "& > figure > svg": {
    color: "var(--color-jeans-500)"
  }
},
    ze = {
  width: "100%"
},
    Te = function Te(e) {
  var o,
      n,
      r,
      t,
      i,
      s,
      l = e.variant || "m";
  return [Ne, "m" === l && [Ae, null === (o = e.variantCss) || void 0 === o ? void 0 : o.m], "l" === l && [Se, null === (n = e.variantCss) || void 0 === n ? void 0 : n.l], (null === (r = e.options) || void 0 === r ? void 0 : r.outline) && [He, null === (t = e.optionsCss) || void 0 === t ? void 0 : t.outline], (null === (i = e.options) || void 0 === i ? void 0 : i.stretch) && [ze, null === (s = e.optionsCss) || void 0 === s ? void 0 : s.stretch]];
},
    Oe = function Oe(n) {
  var r = n.children,
      t = n.anyCss,
      i = n.icon,
      s = n.options,
      l = n.optionsCss,
      a = n.subComponents,
      d = n.variant,
      c = n.variantCss,
      h = g(n, ["children", "anyCss", "icon", "options", "optionsCss", "subComponents", "variant", "variantCss"]),
      u = Te({
    variant: d,
    variantCss: c,
    options: s,
    optionsCss: l
  }),
      f = (null == a ? void 0 : a.Icon) || We;
  return o(N, _v({
    anyCss: re([u, t])
  }, h, {
    children: [i && e(f, {
      name: i,
      variant: d
    }, void 0), r]
  }), void 0);
},
    Ee = {
  border: "1px solid transparent",
  borderColor: "var(--color-stone-300)",
  borderRadius: 4,
  color: "var(--color-stone-500)",
  display: "block",
  fontFamily: "var(--body-font-family)",
  fontSize: 18,
  lineHeight: 1.5,
  padding: 8,
  width: "100%",
  ":active, :focus": {
    outline: "0",
    boxShadow: "0 0 8px var(--color-stone-200)"
  },
  "::placeholder": {
    color: "var(--color-stone-300)"
  }
},
    Ve = {
  checkbox: {},
  email: Ee,
  number: Ee,
  password: Ee,
  radio: {},
  switch: {
    appearance: "none",
    backgroundColor: "var(--color-stone-100)",
    backgroundImage: "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")",
    backgroundPosition: "left center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    border: "1px solid rgba(0,0,0,.25)",
    borderColor: "var(--color-stone-100)",
    borderRadius: "var(--radius-circle)",
    cursor: "pointer",
    height: "24px",
    margin: "5px 5px 5px 0",
    transition: "background-color .15s ease, background-position .15s ease, border-color .15s ease",
    verticalAlign: "top",
    width: "42px",
    ":disabled": {
      cursor: "default",
      opacity: .5
    },
    ":checked": {
      backgroundColor: "var(--color-stone-400)",
      borderColor: "var(--color-stone-400)",
      backgroundPosition: "right center"
    }
  },
  text: Ee
},
    Ie = {
  backgroundColor: "var(--color-stone-100)",
  color: "var(--color-stone-300)",
  cursor: "not-allowed"
},
    De = function De(e) {
  var o,
      n = e.variant || "text";
  return [Ve[n], (null === (o = e.options) || void 0 === o ? void 0 : o.disabled) && Ie];
},
    Pe = function Pe(o) {
  var n = o.anyCss,
      r = o.options,
      t = o.variant,
      i = g(o, ["anyCss", "options", "variant"]);
  (i.disabled || (null == r ? void 0 : r.disabled)) && (r = {
    disabled: !0
  }, i.disabled = !0);
  var s = De({
    options: r,
    variant: t
  });
  return "switch" === t && (i.type = "checkbox"), e(V, _v({
    anyCss: [s, n],
    type: t
  }, i), void 0);
},
    Re = function Re(o) {
  var n = [];
  return i.forEach(o, function (o) {
    if (o && "string" == typeof o) {
      var r = o.split(/\*(.*)/);
      if (!(r.length > 1)) return void n.push(r[0]);
      var t = r[1].split(/\*(.*)/);
      if (!(t.length > 1)) return void n.push.apply(n, r);
      n.push(r[0], e("b", {
        children: t[0]
      }, r[0]));
      var i = Re(t[1]);
      n.push.apply(n, i);
    } else o && n.push(o);
  }), n;
},
    Ue = function Ue(e) {
  var o = i.toArray(e);
  return o && Array.isArray(o) && o.length > 0 && "string" == typeof o[0] && o[0].indexOf("*") >= 0;
},
    Fe = function Fe(o) {
  var n = o.children,
      r = g(o, ["children"]);
  return e(U, _v({}, r, {
    children: Re(n)
  }), void 0);
},
    Be = function Be(o) {
  var n = o.actionFn,
      r = o.body,
      t = o.linkMap,
      i = o.linkStyle;
  if (!r) return null;

  var s = [],
      l = {
    last: !1,
    next: !1
  },
      a = function (e) {
    var o = e.linkMap,
        n = e.body,
        r = [],
        t = n.matchAll(/([^[]*)(\[([^[\]]*)\])*(\(([^()]*)\))*([^[]*)/g),
        i = "",
        s = 0,
        l = Array.from(t),
        a = Object.values(o);
    return l.forEach(function (e, n) {
      var t = (i + e[1]).trim();

      if (t && r.push({
        type: "text",
        text: t
      }), e[3]) {
        var d = e[5];
        o[d] ? d = o[d] : !d && a[s] && (d = a[s]), r.push({
          type: "link",
          text: e[3].trim(),
          ref: d
        }), s++;
      }

      (i = e[6].trim()) && n + 1 === l.length && r.push({
        type: "text",
        text: i
      });
    }), r;
  }({
    body: r,
    linkMap: t || {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5"
    }
  });

  return a.forEach(function (o, r) {
    var t = a[r + 1],
        d = i || {
      color: "var(--color-jeans-400)",
      cursor: "pointer",
      textDecoration: "underline"
    };

    if (l.next = !1, "text" === (null == t ? void 0 : t.type)) {
      var c = t.text.charAt(0);
      l.next = ".,\"'()!".includes(c);
    }

    if ("text" === o.type) {
      s.push(o.text);
      var h = o.text.slice(-1);
      l.last = "\"'()".includes(h);
    }

    "link" === o.type && (l.last || s.push(" "), s.push(e(L, _v({
      anyCss: d,
      onClick: function onClick(e) {
        e.preventDefault(), n && n(o.ref);
      }
    }, {
      children: o.text
    }), o.ref)), l.next || s.push(" "));
  }), s;
},
    qe = function qe(o) {
  var n = [];
  return i.forEach(o, function (o) {
    o && "string" == typeof o ? n.push(o.split("\n").reduce(function (o, n, r) {
      return f(f([], o, !0), [r > 0 && e("br", {}, r), n], !1);
    }, [])) : o && n.push(o);
  }), n;
},
    $e = function $e(o) {
  var n = o.children,
      r = g(o, ["children"]);
  return e(U, _v({}, r, {
    children: qe(n)
  }), void 0);
},
    Ye = function Ye(o) {
  var n = [];
  return i.forEach(o, function (o) {
    o && "string" == typeof o ? n = o.split("\n").filter(function (e) {
      return e.length > 0;
    }).reduce(function (o, n, r) {
      return o.push(e(X, {
        children: n.split("|").filter(function (e) {
          return e.length > 0;
        }).map(function (o, n) {
          return e(J, {
            children: o
          }, n);
        })
      }, r)), o;
    }, []) : o && n.push(o);
  }), n;
},
    Ge = function Ge(e) {
  var o = i.toArray(e);
  return o && Array.isArray(o) && o.length > 0 && "string" == typeof o[0] && "|" === o[0][0];
},
    Ke = function Ke(o) {
  var n = o.children,
      r = g(o, ["children"]);
  return e(G, _v({}, r, {
    children: e(K, {
      children: Ye(n)
    }, void 0)
  }), void 0);
},
    Je = {
  color: "var(--color-jeans-300)",
  cursor: "pointer",
  display: "inline-flex",
  gap: 8,
  textDecoration: "none",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "underline"
  },
  "& > figure > svg": {
    color: "var(--color-jeans-300)",
    strokeWidth: 2
  }
},
    Qe = {
  textDecoration: "underline"
},
    Xe = function Xe(e) {
  var o, n;
  return [ge({
    variant: e.variant
  }), Je, (null === (o = null == e ? void 0 : e.options) || void 0 === o ? void 0 : o.isActive) && [Qe, null === (n = e.optionsCss) || void 0 === n ? void 0 : n.isActive]];
},
    Ze = function Ze(n) {
  var r = n.children,
      t = n.anyCss,
      i = n.icon,
      s = n.options,
      l = n.optionsCss,
      a = n.subComponents,
      d = n.variant,
      c = g(n, ["children", "anyCss", "icon", "options", "optionsCss", "subComponents", "variant"]),
      h = Xe({
    options: s,
    optionsCss: l,
    variant: d
  }),
      u = (null == a ? void 0 : a.A) || L,
      f = (null == a ? void 0 : a.Icon) || We;
  return o(u, _v({
    anyCss: re([h, t])
  }, c, {
    children: [i && e(f, {
      name: i,
      variant: d
    }, void 0), r]
  }), void 0);
},
    eo = {
  border: "1px solid transparent",
  borderColor: "var(--color-stone-200)",
  borderRadius: 4,
  color: "var(--color-stone-500)",
  display: "block",
  fontFamily: "var(--body-font-family)",
  fontSize: 18,
  lineHeight: 1.5,
  padding: 8,
  resize: "none",
  width: "100%",
  ":active, :focus": {
    outline: "0",
    boxShadow: "0 0 8px var(--color-jeans-200)"
  }
},
    oo = {
  overflow: "auto",
  resize: "vertical"
},
    no = {
  backgroundColor: "var(--color-stone-100)",
  color: "var(--color-stone-300)",
  cursor: "not-allowed"
},
    ro = function ro(e) {
  var o, n;
  return [eo, (null === (o = e.options) || void 0 === o ? void 0 : o.resize) && oo, (null === (n = e.options) || void 0 === n ? void 0 : n.disabled) && no];
},
    to = function to(o) {
  var n = o.anyCss,
      r = o.options,
      t = g(o, ["anyCss", "options"]);
  (t.disabled || (null == r ? void 0 : r.disabled)) && (r = {
    disabled: !0
  }, t.disabled = !0);
  var i = ro({
    options: r
  });
  return e(Q, _v({
    anyCss: [i, n],
    rows: 3
  }, t), void 0);
},
    io = {
  animation: "spin .8s linear infinite",
  border: "3px solid var(--color-stone-200)",
  borderRadius: "50%",
  borderTopColor: "transparent",
  display: "inline-block",
  height: 20,
  width: 20,
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg) }"
    }
  }
},
    so = {
  alignItems: "center",
  backdropFilter: "saturate(180%) blur(20px)",
  backgroundColor: "rgba(255,255,255,0.7)",
  border: "1px solid rvar(--color-stone-500)",
  borderRadius: 8,
  bottom: "20px",
  boxShadow: "var(--color-stone-500) 0 0 8px",
  color: "var(--color-stone-600)",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  minHeight: "40px",
  minWidth: "100px",
  position: "fixed",
  right: "20px",
  zIndex: 1e3
},
    lo = function lo() {
  return [ge({
    variant: "s"
  }), so];
},
    ao = function ao(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.options,
      i = g(o, ["anyCss", "children", "options"]),
      s = lo();
  return e(S, _v({
    anyCss: re([s, n])
  }, i, {
    children: (null == t ? void 0 : t.loading) ? e(S, {
      anyCss: io
    }, void 0) : r
  }), void 0);
},
    co = {
  display: "flex",
  flexDirection: "column",
  gap: 4
},
    ho = function ho() {
  return [co];
},
    uo = function uo(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.variant,
      s = g(n, ["anyCss", "model", "variant"]),
      l = ho(),
      a = f([], ge({}), !0);
  return o(S, _v({
    anyCss: [l, r]
  }, s, {
    children: [Object.keys((null == t ? void 0 : t.items) || []).map(function (n, r) {
      var s = "binary-field-".concat(n, "-").concat(r);
      return o(S, _v({
        anyCss: {
          display: "flex",
          gap: 8,
          alignItems: "flex-start"
        }
      }, {
        children: [e(Pe, _v({
          anyCss: {
            marginTop: 5
          },
          id: s,
          name: null == t ? void 0 : t.groupId,
          variant: i
        }, null == t ? void 0 : t.items[n].inputProps), void 0), e(I, _v({
          htmlFor: s,
          anyCss: a
        }, {
          children: Be({
            body: null == t ? void 0 : t.items[n].label,
            actionFn: null == t ? void 0 : t.items[n].labelActionFn
          })
        }), void 0)]
      }), s);
    }), (null == t ? void 0 : t.errorMessage) && e(fe, _v({
      anyCss: {
        color: "red"
      },
      variant: "s"
    }, {
      children: null == t ? void 0 : t.errorMessage
    }), void 0)]
  }), void 0);
},
    vo = {
  display: "flex",
  flexDirection: "row",
  columnGap: 16,
  margin: 0,
  padding: 0,
  li: {
    cursor: "pointer",
    listStyle: "none",
    display: "flex",
    gap: 4,
    "& > figure > svg": {
      color: "var(--color-jeans-300)",
      strokeWidth: 2
    }
  }
},
    go = function go() {
  return vo;
},
    fo = function fo(o) {
  var n,
      r = o.anyCss,
      t = o.model,
      i = o.subComponents,
      s = o.options,
      l = g(o, ["anyCss", "model", "subComponents", "options"]);
  if (!(null === (n = null == t ? void 0 : t.items) || void 0 === n ? void 0 : n.length)) return null;
  var a = go(),
      d = (null == i ? void 0 : i.TextLink) || Ze;
  return e(ee, _v({
    anyCss: re([a, r])
  }, l, {
    children: null == t ? void 0 : t.items.map(function (o, n) {
      var r;
      return e(D, _v({
        onClick: o.actionFn
      }, {
        children: e(d, _v({
          href: null == o ? void 0 : o.actionHref,
          icon: o.icon,
          options: {
            isActive: null === (r = null == t ? void 0 : t.activeId) || void 0 === r ? void 0 : r.startsWith(o.id)
          },
          subComponents: i,
          variant: "s"
        }, {
          children: !(null == s ? void 0 : s.hideHeading) && o.heading
        }), void 0)
      }), n);
    })
  }), void 0);
},
    po = function po() {
  return {
    alignItems: "center",
    display: "flex",
    flexDirection: ["column", "row"],
    gap: 16,
    justifyContent: "space-between",
    "& > ul": {
      flexWrap: "wrap",
      justifyContent: "center"
    }
  };
},
    wo = function wo(n) {
  var r,
      t,
      i = n.anyCss,
      s = n.model,
      l = n.subComponents,
      a = g(n, ["anyCss", "model", "subComponents"]),
      d = {
    alignItems: "center",
    display: "flex",
    flexDirection: ["column", "row"],
    gap: 16,
    justifyContent: "space-between",
    "& > ul": {
      flexWrap: "wrap",
      justifyContent: "center"
    }
  },
      c = (null == l ? void 0 : l.Navigation) || fo;
  return o(P, _v({
    anyCss: re([d, i])
  }, a, {
    children: [e(c, {
      model: null == s ? void 0 : s.menuSegment,
      subComponents: l
    }, void 0), !!(null === (t = null === (r = null == s ? void 0 : s.socialSegment) || void 0 === r ? void 0 : r.items) || void 0 === t ? void 0 : t.length) && e(c, {
      model: null == s ? void 0 : s.socialSegment,
      options: {
        hideHeading: !0
      },
      subComponents: l
    }, void 0)]
  }), void 0);
},
    mo = {
  alignItems: "center",
  color: "black",
  fontWeight: "var(--body-font-weight-bold)"
},
    _o = function _o(o) {
  var n = o.anyCss,
      r = o.model;
  o.options;
  var t = o.subComponents;
  o.variant;
  var i = g(o, ["anyCss", "model", "options", "subComponents", "variant"]),
      s = mo,
      l = (null == t ? void 0 : t.TextLink) || Ze;
  return e(l, _v({
    anyCss: re([s, n]),
    href: null == r ? void 0 : r.actionHref,
    onClick: null == r ? void 0 : r.actionFn,
    subComponents: t,
    variant: "s"
  }, i, {
    children: null == r ? void 0 : r.heading
  }), void 0);
},
    ko = {
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  bottom: 0,
  left: 0,
  position: "fixed",
  right: 0,
  top: 0,
  transition: "opacity 0.5s ease 0s",
  zIndex: -10
},
    yo = function yo(o) {
  var n = o.anyCss,
      r = o.options,
      t = o.variant,
      i = g(o, ["anyCss", "options", "variant"]),
      s = function (e) {
    var o, n;
    return [ko, {
      opacity: (null === (o = e.options) || void 0 === o ? void 0 : o.modalVisible) ? 1 : 0,
      visibility: (null === (n = e.options) || void 0 === n ? void 0 : n.modalVisible) ? "visible" : "hidden"
    }];
  }({
    options: r,
    variant: t
  });

  return e(S, _v({
    anyCss: re([s, n])
  }, i), void 0);
},
    xo = {
  position: "fixed",
  display: "flex",
  inset: "0%",
  width: "100%",
  height: "100%",
  justifyContent: "flex-end",
  visibility: "visible",
  overflowY: "auto",
  zIndex: 10,
  "& > nav": {
    alignItems: "flex-start",
    backgroundColor: "white",
    border: "1px solid var(--color-stone-300)",
    borderRadius: "var(--radius-rounded)",
    boxShadow: "0px 0px 16px var(--color-stone-600)",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    height: "fit-content",
    margin: 16,
    overflow: "hidden",
    padding: 16,
    transition: "transform 0.35s cubic-bezier(0.8, -0.4, 0.2, 1.44) 0s, opacity 0.5s ease 0s",
    width: ["100%", "360px"],
    "& > button": {
      alignSelf: "flex-end",
      padding: 8,
      transition: "none"
    },
    "& > ul:nth-of-type(1)": {
      alignItems: "flex-start",
      flexDirection: "column",
      gap: 0,
      width: "100%",
      li: {
        borderBottom: "1px solid var(--color-stone-200)",
        padding: "16px 0",
        width: "100%"
      }
    },
    "& > ul:nth-of-type(2)": {
      width: "100%",
      flexWrap: "wrap",
      rowGap: 8
    },
    "& > div": {
      display: "flex",
      flexWrap: "wrap",
      gap: 16,
      width: "100%",
      "& > button": {
        transition: "none"
      }
    }
  }
},
    bo = function bo(n) {
  var r,
      t,
      i = n.anyCss,
      s = n.model,
      l = n.options,
      a = n.subComponents,
      d = g(n, ["anyCss", "model", "options", "subComponents"]),
      c = function (e) {
    var o, n, r;
    return [xo, {
      "& > nav": {
        opacity: (null === (o = e.options) || void 0 === o ? void 0 : o.modalVisible) ? 1 : 0,
        transform: (null === (n = e.options) || void 0 === n ? void 0 : n.modalVisible) ? "scale(1)" : "scale(0.7)",
        visibility: (null === (r = e.options) || void 0 === r ? void 0 : r.modalVisible) ? "visible" : "hidden"
      }
    }];
  }({
    options: l
  }),
      h = (null == a ? void 0 : a.Button) || Oe,
      u = (null == a ? void 0 : a.Modal) || yo,
      f = (null == a ? void 0 : a.Navigation) || fo;

  return o(S, _v({
    anyCss: re([c, i]),
    style: {
      visibility: (null == l ? void 0 : l.modalVisible) ? "visible" : "hidden"
    }
  }, d, {
    children: [e(u, {
      onClick: null == s ? void 0 : s.toggleModal,
      options: {
        modalVisible: null == l ? void 0 : l.modalVisible
      }
    }, void 0), o(P, _v({
      anyCss: re([{}])
    }, {
      children: [e(h, {
        onClick: null == s ? void 0 : s.toggleModal,
        icon: "x",
        variant: "s"
      }, void 0), e(f, {
        model: null == s ? void 0 : s.menuSegment,
        subComponents: a
      }, void 0), e(f, {
        model: null == s ? void 0 : s.socialSegment,
        options: {
          hideHeading: !0
        },
        subComponents: a
      }, void 0), e(S, {
        children: (null === (r = null == s ? void 0 : s.actionSegment) || void 0 === r ? void 0 : r.items) && (null === (t = null == s ? void 0 : s.actionSegment) || void 0 === t ? void 0 : t.items.map(function (o, n) {
          return e(h, _v({
            icon: o.icon,
            onClick: o.actionFn,
            variant: "s"
          }, {
            children: o.heading
          }), n);
        }))
      }, void 0)]
    }), void 0)]
  }), void 0);
},
    Co = {
  alignItems: "center",
  display: "flex",
  gap: 16,
  justifyContent: "space-between",
  "& > nav": {
    alignItems: "center",
    display: ["none", "flex"],
    gap: 16,
    flex: "1",
    "& > ul:nth-of-type(1)": {
      alignItems: "center",
      display: ["none", "flex"],
      flex: "1",
      flexWrap: "wrap",
      rowGap: 8
    },
    "& > ul:nth-of-type(2)": {
      alignItems: "center",
      display: ["none", "flex"],
      flexWrap: "wrap",
      rowGap: 8
    },
    "& > div": {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 16
    }
  },
  "& > div": {
    display: ["block", "none"]
  }
},
    Mo = function Mo() {
  return Co;
},
    Lo = function Lo(n) {
  var r,
      t,
      i = n.anyCss,
      l = n.model,
      a = n.subComponents,
      d = g(n, ["anyCss", "model", "subComponents"]),
      c = s(!1),
      h = c[0],
      u = c[1],
      f = Mo(),
      p = function p() {
    u(!h);
  },
      w = (null == a ? void 0 : a.Branding) || _o,
      m = (null == a ? void 0 : a.Button) || Oe,
      _ = (null == a ? void 0 : a.ModalMenu) || bo,
      k = (null == a ? void 0 : a.Navigation) || fo;

  return o(S, _v({
    anyCss: re([f, i])
  }, d, {
    children: [e(w, {
      model: {
        actionFn: null == l ? void 0 : l.brandingActionFn,
        actionHref: null == l ? void 0 : l.brandingActionHref,
        heading: null == l ? void 0 : l.brandingHeading
      },
      subComponents: a
    }, void 0), o(P, {
      children: [e(k, {
        model: null == l ? void 0 : l.menuSegment,
        subComponents: a
      }, void 0), (null == l ? void 0 : l.socialSegment) && e(k, {
        model: null == l ? void 0 : l.socialSegment,
        options: {
          hideHeading: !0
        },
        subComponents: a
      }, void 0), (null === (r = null == l ? void 0 : l.actionSegment) || void 0 === r ? void 0 : r.items) && e(S, {
        children: null === (t = null == l ? void 0 : l.actionSegment) || void 0 === t ? void 0 : t.items.map(function (o, n) {
          return e(m, _v({
            icon: o.icon,
            onClick: o.actionFn,
            variant: "s"
          }, {
            children: o.heading
          }), n);
        })
      }, void 0)]
    }, void 0), o(S, {
      children: [e(m, _v({
        onClick: p,
        variant: "s"
      }, {
        children: "Menu"
      }), void 0), e(_, {
        model: {
          actionSegment: null == l ? void 0 : l.actionSegment,
          menuSegment: null == l ? void 0 : l.menuSegment,
          socialSegment: null == l ? void 0 : l.socialSegment,
          toggleModal: p
        },
        options: {
          modalVisible: h
        },
        subComponents: a
      }, void 0)]
    }, void 0)]
  }), void 0);
},
    jo = {},
    Wo = {
  display: "flex",
  flexDirection: "column",
  gap: 4
},
    No = function No(e) {
  var o = e.variant || "text";
  return [("number" === o || "password" === o || "text" === o || "email" === o) && Wo, jo];
},
    Ao = function Ao(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.options,
      s = n.variant,
      l = g(n, ["anyCss", "model", "options", "variant"]),
      a = No({
    options: i,
    variant: s
  }),
      d = ge({
    variant: "s"
  }),
      c = s || "text";
  return o(S, _v({
    anyCss: [a, r]
  }, l, {
    children: [(null == t ? void 0 : t.label) && e(I, _v({
      htmlFor: null == t ? void 0 : t.id,
      anyCss: d
    }, {
      children: null == t ? void 0 : t.label
    }), void 0), e(Pe, _v({
      variant: c,
      options: i,
      id: null == t ? void 0 : t.id
    }, null == t ? void 0 : t.inputProps), void 0), (null == t ? void 0 : t.helpText) && e(fe, _v({
      anyCss: {
        color: "var(--color-stone-300)"
      }
    }, {
      children: Be({
        body: null == t ? void 0 : t.helpText,
        actionFn: null == t ? void 0 : t.helpTextActionFn
      })
    }), void 0), (null == t ? void 0 : t.errorMessage) && e(fe, _v({
      anyCss: {
        color: "red"
      },
      variant: "s"
    }, {
      children: Be({
        body: null == t ? void 0 : t.errorMessage,
        actionFn: null == t ? void 0 : t.errorActionFn,
        linkStyle: {
          textDecoration: "underline",
          cursor: "pointer"
        }
      })
    }), void 0)]
  }), void 0);
},
    So = function So() {
  return {
    alignItems: "center",
    display: "flex",
    flexDirection: ["column", "row"],
    gap: 8,
    justifyContent: "space-between"
  };
},
    Ho = function Ho(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.subComponents,
      s = g(n, ["anyCss", "model", "subComponents"]),
      l = {
    alignItems: "center",
    display: "flex",
    flexDirection: ["column", "row"],
    gap: 8,
    justifyContent: "space-between"
  },
      a = (null == i ? void 0 : i.TextLink) || Ze;
  return o(P, _v({
    anyCss: re([l, r])
  }, s, {
    children: [e(fe, _v({
      variant: "s",
      anyCss: {
        fontSize: 14
      }
    }, {
      children: null == t ? void 0 : t.copyright
    }), void 0), o(a, _v({
      anyCss: {
        display: "inline-block",
        fontSize: 14,
        color: "black"
      },
      href: null == t ? void 0 : t.modelberryActionHref,
      onClick: null == t ? void 0 : t.modelberryActionFn,
      subComponents: i,
      variant: "s"
    }, {
      children: [null == t ? void 0 : t.modelberryHeading, e(Y, _v({
        anyCss: {
          top: "-1em"
        }
      }, {
        children: null == t ? void 0 : t.modelberryVersion
      }), void 0)]
    }), void 0)]
  }), void 0);
},
    zo = {
  overflow: "hidden",
  iframe: {
    height: "100%",
    width: "100%"
  }
},
    To = {
  height: 0,
  paddingBottom: "56.25%",
  position: "relative",
  iframe: {
    display: "block",
    height: "100%",
    position: "absolute",
    width: "100%"
  }
},
    Oo = {
  iframe: {
    display: "block",
    width: "100%"
  }
},
    Eo = {
  iframe: {
    display: "block",
    width: "100%"
  }
},
    Vo = function Vo(e) {
  var o,
      n,
      r,
      t,
      i = e.variant || "imageAspectRatio";
  return ["contentHeight" === i && [zo, null === (o = e.variantCss) || void 0 === o ? void 0 : o.contentHeight], "fixedAspectRatio" === i && [To, null === (n = e.variantCss) || void 0 === n ? void 0 : n.fixedAspectRatio], "imageAspectRatio" === i && [Oo, null === (r = e.variantCss) || void 0 === r ? void 0 : r.imageAspectRatio], "round" === i && [Eo, null === (t = e.variantCss) || void 0 === t ? void 0 : t.round]];
},
    Io = function Io(o) {
  var n = o.model,
      r = o.anyCss,
      t = o.variant,
      i = o.variantCss,
      s = g(o, ["model", "anyCss", "variant", "variantCss"]),
      l = Vo({
    variant: t,
    variantCss: i
  });
  return e(S, _v({
    anyCss: re([l, r]),
    dangerouslySetInnerHTML: {
      __html: (null == n ? void 0 : n.embed) || ""
    }
  }, s), void 0);
},
    Do = function Do(e) {
  var o = e.fm,
      n = e.imgUrl,
      r = e.resolutions;
  return n && (null == n ? void 0 : n.includes("ctfassets")) ? r.map(function (e) {
    return "".concat(n, "?fm=").concat(o, "&w=").concat(e, " ").concat(e, "w");
  }).join(", ") : "";
},
    Po = {
  display: "block",
  width: "100%",
  overflow: "hidden",
  img: {
    display: "block",
    height: "100%",
    objectFit: "cover",
    width: "100%"
  }
},
    Ro = {
  display: "block",
  width: "100%",
  height: 0,
  paddingBottom: "56.25%",
  position: "relative",
  img: {
    display: "block",
    height: "100%",
    objectFit: "cover",
    position: "absolute",
    width: "100%"
  }
},
    Uo = {
  display: "block",
  width: "100%",
  img: {
    display: "block",
    height: "auto",
    width: "100%"
  }
},
    Fo = {
  display: "block",
  width: "100%",
  overflow: "hidden",
  borderRadius: "100%",
  img: {
    display: "block",
    height: "100%",
    width: "100%",
    objectFit: "cover"
  }
},
    Bo = function Bo(e) {
  var o,
      n,
      r,
      t,
      i = e.variant || "imageAspectRatio";
  return ["contentHeight" === i && [Po, null === (o = e.variantCss) || void 0 === o ? void 0 : o.contentHeight], "fixedAspectRatio" === i && [Ro, null === (n = e.variantCss) || void 0 === n ? void 0 : n.fixedAspectRatio], "imageAspectRatio" === i && [Uo, null === (r = e.variantCss) || void 0 === r ? void 0 : r.imageAspectRatio], "round" === i && [Fo, null === (t = e.variantCss) || void 0 === t ? void 0 : t.round]];
},
    qo = function qo(n) {
  var r = n.model,
      t = n.anyCss,
      i = n.variant,
      s = n.variantCss,
      l = g(n, ["model", "anyCss", "variant", "variantCss"]),
      a = Bo({
    variant: i,
    variantCss: s
  }),
      d = [300, 768, 1024, 1280],
      c = Do({
    resolutions: d,
    fm: "jpg",
    imgUrl: null == r ? void 0 : r.imageUrl
  }),
      h = Do({
    resolutions: d,
    fm: "webp",
    imgUrl: null == r ? void 0 : r.imageUrl
  }),
      u = f([void 0], ne, !0),
      p = "100vw";
  return Array.isArray(null == r ? void 0 : r.imageVwSizes) && (p = null == r ? void 0 : r.imageVwSizes.map(function (e, o) {
    return [u[o] ? "(min-width: ".concat(u[o], "px)") : "", "".concat(e, "vw")].join(" ");
  }).reverse().join(", ")), o(F, _v({
    anyCss: re([a, t])
  }, l, {
    children: [h && e(q, {
      srcSet: h,
      sizes: p,
      type: "image/webp"
    }, void 0), c && e(q, {
      srcSet: c,
      sizes: p,
      type: "image/jpeg"
    }, void 0), e(E, {
      src: "".concat(null == r ? void 0 : r.imageUrl, "?fm=jpg"),
      alt: null == r ? void 0 : r.description
    }, void 0)]
  }), void 0);
},
    $o = {
  display: "block",
  width: "100%"
},
    Yo = {
  display: "block",
  width: "100%"
},
    Go = {
  display: "block",
  width: "100%"
},
    Ko = {
  display: "block",
  width: "100%"
},
    Jo = function Jo(e) {
  var o,
      n,
      r,
      t,
      i = e.variant || "imageAspectRatio";
  return ["contentHeight" === i && [$o, null === (o = e.variantCss) || void 0 === o ? void 0 : o.contentHeight], "fixedAspectRatio" === i && [Yo, null === (n = e.variantCss) || void 0 === n ? void 0 : n.fixedAspectRatio], "imageAspectRatio" === i && [Go, null === (r = e.variantCss) || void 0 === r ? void 0 : r.imageAspectRatio], "round" === i && [Ko, null === (t = e.variantCss) || void 0 === t ? void 0 : t.round]];
},
    Qo = function Qo(n) {
  var r = n.model,
      t = n.anyCss,
      i = n.variant,
      s = n.variantCss,
      l = g(n, ["model", "anyCss", "variant", "variantCss"]),
      a = Jo({
    variant: i,
    variantCss: s
  });
  return o(oe, _v({
    anyCss: re([a, t]),
    poster: null == r ? void 0 : r.posterUrl,
    title: null == r ? void 0 : r.title
  }, l, {
    controls: !0,
    playsInline: !0
  }, {
    children: [e(q, {
      src: null == r ? void 0 : r.videoUrl,
      type: (null == r ? void 0 : r.contentType) || "video/mp4"
    }, void 0), "Your browser does not support the video tag."]
  }), void 0);
},
    Xo = function Xo(r) {
  var t = r.model,
      i = r.subComponents,
      s = g(r, ["model", "subComponents"]),
      l = (null == i ? void 0 : i.Video) || Qo,
      a = (null == i ? void 0 : i.Embed) || Io,
      d = (null == i ? void 0 : i.Picture) || qo;
  return o(n, {
    children: [(null == t ? void 0 : t.imageUrl) && e(d, _v({
      model: t
    }, s), void 0), !(null == t ? void 0 : t.imageUrl) && (null == t ? void 0 : t.videoUrl) && e(l, _v({
      model: t
    }, s), void 0), !((null == t ? void 0 : t.imageUrl) || (null == t ? void 0 : t.videoUrl)) && (null == t ? void 0 : t.embed) && e(a, _v({
      model: t
    }, s), void 0)]
  }, void 0);
},
    Zo = {
  display: "flex",
  flexDirection: "column",
  gap: 16,
  width: "100%",
  "div, picture, video": {
    order: 1
  },
  button: {
    margin: "0 auto 0 0"
  },
  "& > section": {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 16,
    order: 2,
    padding: "0 16px",
    width: "100%"
  },
  "& > section > section": {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 16,
    width: "100%",
    "& > label": {
      color: "var(--color-jeans-300)"
    }
  }
},
    en = {
  "div, picture, video": {
    order: 2
  },
  "& > section": {
    order: 1
  }
},
    on = function on(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.options,
      s = n.subComponents,
      l = g(n, ["anyCss", "model", "options", "subComponents"]),
      a = function (e) {
    var o;
    return [Zo, (null === (o = e.options) || void 0 === o ? void 0 : o.reversedOrder) && en];
  }({
    options: i
  }),
      d = (null == s ? void 0 : s.Body) || fe,
      c = (null == s ? void 0 : s.Button) || Oe,
      h = (null == s ? void 0 : s.Heading) || de,
      u = (null == s ? void 0 : s.Icon) || We,
      f = (null == s ? void 0 : s.Media) || Xo,
      p = (null == t ? void 0 : t.imageUrl) || (null == t ? void 0 : t.videoUrl) || (null == t ? void 0 : t.embed);

  return o(B, _v({
    anyCss: re([a, r])
  }, l, {
    children: [p && e(f, {
      variant: "fixedAspectRatio",
      model: {
        description: null == t ? void 0 : t.mediaDescription,
        imageUrl: null == t ? void 0 : t.imageUrl,
        imageVwSizes: [100, 50],
        videoUrl: null == t ? void 0 : t.videoUrl,
        embed: null == t ? void 0 : t.embed
      }
    }, void 0), o(B, {
      children: [o(B, {
        children: [(null == t ? void 0 : t.icon) && e(u, {
          name: null == t ? void 0 : t.icon,
          variant: "xl"
        }, void 0), ((null == t ? void 0 : t.label) || (null == t ? void 0 : t.date) || (null == t ? void 0 : t.author)) && e(d, _v({
          is: "label",
          variant: "s"
        }, {
          children: [null == t ? void 0 : t.label, null == t ? void 0 : t.author, null == t ? void 0 : t.date].filter(function (e) {
            return e;
          }).join(" | ")
        }), void 0), (null == t ? void 0 : t.heading) && e(h, _v({
          is: "h3",
          variant: "l"
        }, {
          children: null == t ? void 0 : t.heading
        }), void 0), (null == t ? void 0 : t.abstract) && e(d, _v({
          variant: "m"
        }, {
          children: Be({
            body: null == t ? void 0 : t.abstract,
            actionFn: null == t ? void 0 : t.actionFn
          })
        }), void 0)]
      }, void 0), (null == t ? void 0 : t.actionHeading) && e(c, _v({
        icon: null == t ? void 0 : t.actionIcon,
        variant: "s",
        onClick: null == t ? void 0 : t.actionFn
      }, {
        children: null == t ? void 0 : t.actionHeading
      }), void 0)]
    }, void 0)]
  }), void 0);
},
    nn = {
  border: "1px solid var(--color-stone-200)",
  borderRadius: "var(--radius-rounded)",
  boxShadow: "0 0 14px var(--color-stone-100)",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  gap: 16,
  padding: 16,
  transition: "transform .20s ease",
  width: "100%",
  ":hover": {
    transform: "translate3d(0, -5px, 0)"
  },
  "div, picture, video": {
    order: 1
  },
  button: {
    margin: "0 auto 0 0"
  },
  "& > section": {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 16,
    order: 2,
    width: "100%"
  },
  "& > section > section": {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 16,
    width: "100%",
    "& > label": {
      color: "var(--color-jeans-300)"
    }
  }
},
    rn = {
  boxShadow: "none",
  cursor: "inherit",
  ":hover": {
    transform: "none"
  }
},
    tn = {
  "div, picture, video": {
    order: 2
  },
  "& > section": {
    order: 1
  }
},
    sn = function sn(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.options,
      s = n.subComponents,
      l = g(n, ["anyCss", "model", "options", "subComponents"]),
      a = function (e) {
    var o;
    return [nn, (null === (o = e.options) || void 0 === o ? void 0 : o.reversedOrder) && tn];
  }({
    options: i
  }),
      d = (null == s ? void 0 : s.Body) || fe,
      c = (null == s ? void 0 : s.Button) || Oe,
      h = (null == s ? void 0 : s.Heading) || de,
      u = (null == s ? void 0 : s.Icon) || We,
      f = (null == s ? void 0 : s.Media) || Xo,
      p = (null == t ? void 0 : t.imageUrl) || (null == t ? void 0 : t.videoUrl) || (null == t ? void 0 : t.embed);

  return o(B, _v({
    anyCss: re([a, r, !(null == t ? void 0 : t.actionFn) && rn]),
    onClick: null == t ? void 0 : t.actionFn
  }, l, {
    children: [p && e(f, {
      variant: "fixedAspectRatio",
      model: {
        description: null == t ? void 0 : t.mediaDescription,
        imageUrl: null == t ? void 0 : t.imageUrl,
        imageVwSizes: [100, 25],
        videoUrl: null == t ? void 0 : t.videoUrl,
        embed: null == t ? void 0 : t.embed
      }
    }, void 0), o(B, {
      children: [o(B, {
        children: [(null == t ? void 0 : t.icon) && e(u, {
          name: null == t ? void 0 : t.icon,
          variant: "xl"
        }, void 0), ((null == t ? void 0 : t.label) || (null == t ? void 0 : t.date) || (null == t ? void 0 : t.author)) && e(d, _v({
          is: "label",
          variant: "s"
        }, {
          children: [null == t ? void 0 : t.label, null == t ? void 0 : t.author, null == t ? void 0 : t.date].filter(function (e) {
            return e;
          }).join(" | ")
        }), void 0), (null == t ? void 0 : t.heading) && e(h, _v({
          is: "h3",
          variant: "l"
        }, {
          children: null == t ? void 0 : t.heading
        }), void 0), (null == t ? void 0 : t.abstract) && e(d, _v({
          variant: "m"
        }, {
          children: Be({
            body: null == t ? void 0 : t.abstract,
            actionFn: null == t ? void 0 : t.actionFn
          })
        }), void 0)]
      }, void 0), (null == t ? void 0 : t.actionHeading) && e(c, _v({
        icon: null == t ? void 0 : t.actionIcon,
        variant: "s",
        onClick: null == t ? void 0 : t.actionFn
      }, {
        children: null == t ? void 0 : t.actionHeading
      }), void 0)]
    }, void 0)]
  }), void 0);
},
    ln = {
  alignItems: "center",
  display: "flex",
  flexDirection: ["column", "row"],
  gap: [16, 48],
  padding: [8, 32],
  width: "100%",
  "div, video, picture": {
    width: ["100%", "calc(50% - 24px)"],
    order: 1
  },
  button: {
    margin: "0 auto 0 0"
  },
  "& > section": {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    order: 2,
    width: ["100%", "calc(50% - 24px)"]
  },
  "& > section > section": {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    width: "100%",
    "& > label": {
      color: "var(--color-jeans-300)"
    }
  }
},
    an = {
  "div, picture, video": {
    order: 2
  },
  "& > section": {
    order: 1
  }
},
    dn = function dn(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.options,
      s = n.subComponents,
      l = g(n, ["anyCss", "model", "options", "subComponents"]),
      a = function (e) {
    var o;
    return [ln, (null === (o = e.options) || void 0 === o ? void 0 : o.reversedOrder) && an];
  }({
    options: i
  }),
      d = (null == s ? void 0 : s.Body) || fe,
      c = (null == s ? void 0 : s.Button) || Oe,
      h = (null == s ? void 0 : s.Display) || ye,
      u = (null == s ? void 0 : s.Icon) || We,
      f = (null == s ? void 0 : s.Media) || Xo,
      p = (null == t ? void 0 : t.imageUrl) || (null == t ? void 0 : t.videoUrl) || (null == t ? void 0 : t.embed);

  return o(B, _v({
    anyCss: re([a, r])
  }, l, {
    children: [p && e(f, {
      variant: "imageAspectRatio",
      model: {
        description: null == t ? void 0 : t.mediaDescription,
        imageUrl: null == t ? void 0 : t.imageUrl,
        imageVwSizes: [100, 50],
        videoUrl: null == t ? void 0 : t.videoUrl,
        embed: null == t ? void 0 : t.embed
      }
    }, void 0), o(B, {
      children: [o(B, {
        children: [(null == t ? void 0 : t.icon) && e(u, {
          name: null == t ? void 0 : t.icon,
          variant: "xl"
        }, void 0), ((null == t ? void 0 : t.label) || (null == t ? void 0 : t.date) || (null == t ? void 0 : t.author)) && e(d, _v({
          is: "label",
          variant: "m"
        }, {
          children: [null == t ? void 0 : t.label, null == t ? void 0 : t.author, null == t ? void 0 : t.date].filter(function (e) {
            return e;
          }).join(" | ")
        }), void 0), (null == t ? void 0 : t.heading) && e(h, _v({
          is: "h2",
          variant: "l"
        }, {
          children: null == t ? void 0 : t.heading
        }), void 0), (null == t ? void 0 : t.abstract) && e(d, _v({
          variant: "l"
        }, {
          children: Be({
            body: null == t ? void 0 : t.abstract,
            actionFn: null == t ? void 0 : t.actionFn
          })
        }), void 0)]
      }, void 0), (null == t ? void 0 : t.actionHeading) && e(c, _v({
        icon: null == t ? void 0 : t.actionIcon,
        variant: "m",
        onClick: null == t ? void 0 : t.actionFn
      }, {
        children: null == t ? void 0 : t.actionHeading
      }), void 0)]
    }, void 0)]
  }), void 0);
},
    cn = {
  display: "flex",
  flexDirection: "column",
  gap: 32,
  width: "100%",
  "div, picture, video": {
    order: 1
  },
  "& > section": {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 16,
    margin: "0 auto",
    maxWidth: 860,
    padding: "0 16px",
    order: 2,
    width: "100%"
  },
  "& > section > section": {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    gap: 16,
    width: "100%",
    "& > label": {
      color: "var(--color-jeans-300)"
    }
  }
},
    hn = {
  "div, picture, video": {
    order: 2
  },
  "& > section": {
    order: 1
  }
},
    un = function un(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.options,
      s = n.subComponents,
      l = g(n, ["anyCss", "model", "options", "subComponents"]),
      a = function (e) {
    var o;
    return [cn, (null === (o = e.options) || void 0 === o ? void 0 : o.reversedOrder) && hn];
  }({
    options: i
  }),
      d = (null == s ? void 0 : s.Body) || fe,
      c = (null == s ? void 0 : s.Button) || Oe,
      h = (null == s ? void 0 : s.Display) || ye,
      u = (null == s ? void 0 : s.Icon) || We,
      f = (null == s ? void 0 : s.Media) || Xo,
      p = (null == t ? void 0 : t.imageUrl) || (null == t ? void 0 : t.videoUrl) || (null == t ? void 0 : t.embed);

  return o(B, _v({
    anyCss: re([a, r])
  }, l, {
    children: [p && e(f, {
      variant: "imageAspectRatio",
      model: {
        description: null == t ? void 0 : t.mediaDescription,
        imageUrl: null == t ? void 0 : t.imageUrl,
        videoUrl: null == t ? void 0 : t.videoUrl,
        embed: null == t ? void 0 : t.embed
      }
    }, void 0), o(B, {
      children: [o(B, {
        children: [(null == t ? void 0 : t.icon) && e(u, {
          name: null == t ? void 0 : t.icon,
          variant: "xl"
        }, void 0), ((null == t ? void 0 : t.label) || (null == t ? void 0 : t.date) || (null == t ? void 0 : t.author)) && e(d, _v({
          is: "label",
          variant: "m"
        }, {
          children: [null == t ? void 0 : t.label, null == t ? void 0 : t.author, null == t ? void 0 : t.date].filter(function (e) {
            return e;
          }).join(" | ")
        }), void 0), (null == t ? void 0 : t.heading) && e(h, _v({
          is: "h1",
          variant: "l"
        }, {
          children: null == t ? void 0 : t.heading
        }), void 0), (null == t ? void 0 : t.abstract) && e(d, _v({
          variant: "l"
        }, {
          children: Be({
            body: null == t ? void 0 : t.abstract,
            actionFn: null == t ? void 0 : t.actionFn
          })
        }), void 0)]
      }, void 0), (null == t ? void 0 : t.actionHeading) && e(c, _v({
        icon: null == t ? void 0 : t.actionIcon,
        variant: "m",
        onClick: null == t ? void 0 : t.actionFn
      }, {
        children: null == t ? void 0 : t.actionHeading
      }), void 0)]
    }, void 0)]
  }), void 0);
},
    vn = {
  display: "flex",
  flexDirection: "column",
  gap: 16,
  position: "relative",
  width: "100%",
  "div, video, picture": {
    bottom: 0,
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: -1
  },
  "& > section": {
    display: "flex",
    flexDirection: "column",
    gap: 32,
    margin: ["16px auto", "32px auto"],
    padding: ["48px 24px", "72px 40px"],
    textShadow: "1px 1px 0px var(--color-stone-500)",
    width: "100%"
  },
  "& > section > section": {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    maxWidth: 600,
    width: "100%",
    "& > h1": {
      color: "white"
    },
    "& > p": {
      color: "white",
      fontWeight: "var(--body-font-weight-bold)"
    },
    "& > label": {
      color: "white"
    }
  },
  button: {
    margin: "0 auto 0 0",
    boxShadow: "1px 1px 0px var(--color-stone-500)"
  }
},
    gn = function gn(n) {
  var r = n.anyCss,
      t = n.model;
  n.options;
  var i = n.subComponents,
      s = g(n, ["anyCss", "model", "options", "subComponents"]),
      l = vn,
      a = (null == i ? void 0 : i.Body) || fe,
      d = (null == i ? void 0 : i.Button) || Oe,
      c = (null == i ? void 0 : i.Display) || ye,
      h = (null == i ? void 0 : i.Icon) || We,
      u = (null == i ? void 0 : i.Media) || Xo,
      f = (null == t ? void 0 : t.imageUrl) || (null == t ? void 0 : t.videoUrl) || (null == t ? void 0 : t.embed);
  return o(B, _v({
    anyCss: re([l, r])
  }, s, {
    children: [f && e(u, {
      variant: "contentHeight",
      model: {
        description: null == t ? void 0 : t.mediaDescription,
        imageUrl: null == t ? void 0 : t.imageUrl,
        videoUrl: null == t ? void 0 : t.videoUrl,
        embed: null == t ? void 0 : t.embed
      }
    }, void 0), o(B, {
      children: [o(B, {
        children: [(null == t ? void 0 : t.icon) && e(h, {
          name: null == t ? void 0 : t.icon,
          variant: "xl"
        }, void 0), ((null == t ? void 0 : t.label) || (null == t ? void 0 : t.date) || (null == t ? void 0 : t.author)) && e(a, _v({
          is: "label",
          variant: "l"
        }, {
          children: [null == t ? void 0 : t.label, null == t ? void 0 : t.author, null == t ? void 0 : t.date].filter(function (e) {
            return e;
          }).join(" | ")
        }), void 0), (null == t ? void 0 : t.heading) && e(c, _v({
          is: "h1",
          variant: "l"
        }, {
          children: null == t ? void 0 : t.heading
        }), void 0), (null == t ? void 0 : t.abstract) && e(a, _v({
          variant: "l"
        }, {
          children: Be({
            body: null == t ? void 0 : t.abstract,
            actionFn: null == t ? void 0 : t.actionFn
          })
        }), void 0)]
      }, void 0), (null == t ? void 0 : t.actionHeading) && e(d, _v({
        icon: null == t ? void 0 : t.actionIcon,
        variant: "m",
        onClick: null == t ? void 0 : t.actionFn
      }, {
        children: null == t ? void 0 : t.actionHeading
      }), void 0)]
    }, void 0)]
  }), void 0);
},
    fn = {
  display: "flex",
  flexDirection: "column",
  gap: 16,
  padding: [8, 0],
  width: "100%",
  "div, picture, video": {
    order: 1
  },
  button: {
    margin: "0 auto 0 0"
  },
  "& > section": {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 16,
    order: 2,
    width: "100%"
  },
  "& > section > section": {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 16,
    width: "100%",
    "& > label": {
      color: "var(--color-jeans-300)"
    }
  }
},
    pn = {
  "div, picture, video": {
    order: 2
  },
  "& > section": {
    order: 1
  }
},
    wn = function wn(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.options,
      s = n.subComponents,
      l = g(n, ["anyCss", "model", "options", "subComponents"]),
      a = function (e) {
    var o;
    return [fn, (null === (o = e.options) || void 0 === o ? void 0 : o.reversedOrder) && pn];
  }({
    options: i
  }),
      d = (null == s ? void 0 : s.TextLink) || Ze,
      c = (null == s ? void 0 : s.Body) || fe,
      h = (null == s ? void 0 : s.Heading) || de,
      u = (null == s ? void 0 : s.Icon) || We,
      f = (null == s ? void 0 : s.Media) || Xo,
      p = (null == t ? void 0 : t.imageUrl) || (null == t ? void 0 : t.videoUrl) || (null == t ? void 0 : t.embed);

  return o(B, _v({
    anyCss: re([a, r])
  }, l, {
    children: [p && e(f, {
      variant: "imageAspectRatio",
      model: {
        description: null == t ? void 0 : t.mediaDescription,
        imageUrl: null == t ? void 0 : t.imageUrl,
        videoUrl: null == t ? void 0 : t.videoUrl,
        embed: null == t ? void 0 : t.embed
      }
    }, void 0), o(B, {
      children: [o(B, {
        children: [(null == t ? void 0 : t.icon) && e(u, {
          name: null == t ? void 0 : t.icon,
          variant: "xl"
        }, void 0), ((null == t ? void 0 : t.label) || (null == t ? void 0 : t.date) || (null == t ? void 0 : t.author)) && e(c, _v({
          is: "label",
          variant: "s"
        }, {
          children: [null == t ? void 0 : t.label, null == t ? void 0 : t.author, null == t ? void 0 : t.date].filter(function (e) {
            return e;
          }).join(" | ")
        }), void 0), (null == t ? void 0 : t.heading) && e(h, _v({
          is: "h3",
          variant: "l"
        }, {
          children: null == t ? void 0 : t.heading
        }), void 0), (null == t ? void 0 : t.abstract) && e(c, _v({
          variant: "m"
        }, {
          children: Be({
            body: null == t ? void 0 : t.abstract,
            actionFn: null == t ? void 0 : t.actionFn
          })
        }), void 0)]
      }, void 0), (null == t ? void 0 : t.actionHeading) && e(d, _v({
        href: null == t ? void 0 : t.actionHref,
        icon: null == t ? void 0 : t.actionIcon,
        onClick: null == t ? void 0 : t.actionFn,
        subComponents: s,
        variant: "s"
      }, {
        children: null == t ? void 0 : t.actionHeading
      }), void 0)]
    }, void 0)]
  }), void 0);
},
    mn = {
  display: "flex",
  flexDirection: "column",
  gap: 32,
  width: "100%",
  "video, div, video": {
    order: 1
  },
  picture: {
    height: 300,
    width: 300,
    margin: "0 auto",
    order: 1
  },
  "& > section": {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 32,
    order: 2,
    textAlign: "center",
    width: "100%"
  },
  "& > section > section": {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 16,
    width: "100%",
    "& > label": {
      color: "var(--color-jeans-300)"
    }
  }
},
    _n = {
  "div, picture, video": {
    order: 2
  },
  "& > section": {
    order: 1
  }
},
    kn = function kn(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.options,
      s = n.subComponents,
      l = g(n, ["anyCss", "model", "options", "subComponents"]),
      a = function (e) {
    var o;
    return [mn, (null === (o = e.options) || void 0 === o ? void 0 : o.reversedOrder) && _n];
  }({
    options: i
  }),
      d = (null == s ? void 0 : s.Body) || fe,
      c = (null == s ? void 0 : s.Button) || Oe,
      h = (null == s ? void 0 : s.Display) || ye,
      u = (null == s ? void 0 : s.Icon) || We,
      f = (null == s ? void 0 : s.Media) || Xo,
      p = (null == t ? void 0 : t.imageUrl) || (null == t ? void 0 : t.videoUrl) || (null == t ? void 0 : t.embed);

  return o(B, _v({
    anyCss: re([a, r])
  }, l, {
    children: [p && e(f, {
      variant: "round",
      model: {
        description: null == t ? void 0 : t.mediaDescription,
        imageUrl: null == t ? void 0 : t.imageUrl,
        videoUrl: null == t ? void 0 : t.videoUrl,
        imageVwSizes: [50, 25],
        embed: null == t ? void 0 : t.embed
      }
    }, void 0), o(B, {
      children: [o(B, {
        children: [(null == t ? void 0 : t.icon) && e(u, {
          name: null == t ? void 0 : t.icon,
          variant: "xl"
        }, void 0), ((null == t ? void 0 : t.label) || (null == t ? void 0 : t.date) || (null == t ? void 0 : t.author)) && e(d, _v({
          is: "label",
          variant: "m"
        }, {
          children: [null == t ? void 0 : t.label, null == t ? void 0 : t.author, null == t ? void 0 : t.date].filter(function (e) {
            return e;
          }).join(" | ")
        }), void 0), (null == t ? void 0 : t.heading) && e(h, _v({
          is: "h2",
          variant: "l"
        }, {
          children: null == t ? void 0 : t.heading
        }), void 0), (null == t ? void 0 : t.abstract) && e(d, _v({
          variant: "l"
        }, {
          children: Be({
            body: null == t ? void 0 : t.abstract,
            actionFn: null == t ? void 0 : t.actionFn
          })
        }), void 0)]
      }, void 0), (null == t ? void 0 : t.actionHeading) && e(c, _v({
        icon: null == t ? void 0 : t.actionIcon,
        variant: "m",
        onClick: null == t ? void 0 : t.actionFn
      }, {
        children: null == t ? void 0 : t.actionHeading
      }), void 0)]
    }, void 0)]
  }), void 0);
},
    yn = {
  alignItems: "center",
  columnGap: 8,
  display: "flex",
  flexDirection: ["column", "row"],
  rowGap: 32,
  width: "100%",
  "video, div, video": {
    order: 1
  },
  picture: {
    height: 200,
    width: 200,
    margin: "0 auto",
    order: 1
  },
  "& > section": {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 32,
    order: 2,
    textAlign: "center",
    width: "100%"
  },
  "& > section > section": {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 16,
    width: "100%",
    "& > label": {
      color: "var(--color-jeans-300)"
    }
  }
},
    xn = {
  "div, picture, video": {
    order: 2
  },
  "& > section": {
    order: 1
  }
},
    bn = function bn(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.options,
      s = n.subComponents,
      l = g(n, ["anyCss", "model", "options", "subComponents"]),
      a = function (e) {
    var o;
    return [yn, (null === (o = e.options) || void 0 === o ? void 0 : o.reversedOrder) && xn];
  }({
    options: i
  }),
      d = (null == s ? void 0 : s.Body) || fe,
      c = (null == s ? void 0 : s.Button) || Oe,
      h = (null == s ? void 0 : s.Heading) || de,
      u = (null == s ? void 0 : s.Icon) || We,
      f = (null == s ? void 0 : s.Media) || Xo,
      p = (null == t ? void 0 : t.imageUrl) || (null == t ? void 0 : t.videoUrl) || (null == t ? void 0 : t.embed);

  return o(B, _v({
    anyCss: re([a, r])
  }, l, {
    children: [p && e(f, {
      variant: "round",
      model: {
        description: null == t ? void 0 : t.mediaDescription,
        imageUrl: null == t ? void 0 : t.imageUrl,
        videoUrl: null == t ? void 0 : t.videoUrl,
        imageVwSizes: [50, 25],
        embed: null == t ? void 0 : t.embed
      }
    }, void 0), o(B, {
      children: [o(B, {
        children: [(null == t ? void 0 : t.icon) && e(u, {
          name: null == t ? void 0 : t.icon,
          variant: "xl"
        }, void 0), ((null == t ? void 0 : t.label) || (null == t ? void 0 : t.date) || (null == t ? void 0 : t.author)) && e(d, _v({
          is: "label",
          variant: "m"
        }, {
          children: [null == t ? void 0 : t.label, null == t ? void 0 : t.author, null == t ? void 0 : t.date].filter(function (e) {
            return e;
          }).join(" | ")
        }), void 0), (null == t ? void 0 : t.heading) && e(h, _v({
          is: "h4",
          variant: "s"
        }, {
          children: null == t ? void 0 : t.heading
        }), void 0), (null == t ? void 0 : t.abstract) && e(d, _v({
          variant: "l",
          anyCss: {
            fontStyle: "italic"
          }
        }, {
          children: Be({
            body: null == t ? void 0 : t.abstract,
            actionFn: null == t ? void 0 : t.actionFn
          })
        }), void 0)]
      }, void 0), (null == t ? void 0 : t.actionHeading) && e(c, _v({
        icon: null == t ? void 0 : t.actionIcon,
        variant: "m",
        onClick: null == t ? void 0 : t.actionFn
      }, {
        children: null == t ? void 0 : t.actionHeading
      }), void 0)]
    }, void 0)]
  }), void 0);
},
    Cn = {
  alignItems: "center",
  display: "flex",
  flexDirection: ["column", "row"],
  gap: 16,
  padding: [8, 0],
  width: "100%",
  "div, picture, video": {
    maxWidth: ["none", 260],
    width: ["100%", "inherit"],
    order: 1
  },
  button: {
    margin: "0 auto 0 0"
  },
  "& > section": {
    display: "flex",
    flexDirection: "column",
    columnGap: 32,
    order: 2,
    rowGap: 16,
    width: "100%"
  },
  "& > section > section": {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    width: "100%",
    "& > label": {
      color: "var(--color-jeans-300)"
    }
  }
},
    Mn = {
  "div, picture, video": {
    order: 2
  },
  "& > section": {
    order: 1
  }
},
    Ln = function Ln(n) {
  var r = n.anyCss,
      t = n.model,
      i = n.options,
      s = n.subComponents,
      l = g(n, ["anyCss", "model", "options", "subComponents"]),
      a = function (e) {
    var o;
    return [Cn, (null === (o = e.options) || void 0 === o ? void 0 : o.reversedOrder) && Mn];
  }({
    options: i
  }),
      d = (null == s ? void 0 : s.TextLink) || Ze,
      c = (null == s ? void 0 : s.Body) || fe,
      h = (null == s ? void 0 : s.Heading) || de,
      u = (null == s ? void 0 : s.Icon) || We,
      f = (null == s ? void 0 : s.Media) || Xo,
      p = (null == t ? void 0 : t.imageUrl) || (null == t ? void 0 : t.videoUrl) || (null == t ? void 0 : t.embed);

  return o(B, _v({
    anyCss: re([a, r])
  }, l, {
    children: [p && e(f, {
      variant: "imageAspectRatio",
      model: {
        description: null == t ? void 0 : t.mediaDescription,
        imageUrl: null == t ? void 0 : t.imageUrl,
        videoUrl: null == t ? void 0 : t.videoUrl,
        imageVwSizes: [100, 25],
        embed: null == t ? void 0 : t.embed
      }
    }, void 0), o(B, {
      children: [o(B, {
        children: [(null == t ? void 0 : t.icon) && e(u, {
          name: null == t ? void 0 : t.icon,
          variant: "xl"
        }, void 0), ((null == t ? void 0 : t.label) || (null == t ? void 0 : t.date) || (null == t ? void 0 : t.author)) && e(c, _v({
          is: "label",
          variant: "s"
        }, {
          children: [null == t ? void 0 : t.label, null == t ? void 0 : t.author, null == t ? void 0 : t.date].filter(function (e) {
            return e;
          }).join(" | ")
        }), void 0), (null == t ? void 0 : t.heading) && e(h, _v({
          is: "h3",
          variant: "l"
        }, {
          children: null == t ? void 0 : t.heading
        }), void 0), (null == t ? void 0 : t.abstract) && e(c, _v({
          variant: "m"
        }, {
          children: Be({
            body: null == t ? void 0 : t.abstract,
            actionFn: null == t ? void 0 : t.actionFn
          })
        }), void 0)]
      }, void 0), (null == t ? void 0 : t.actionHeading) && e(d, _v({
        href: null == t ? void 0 : t.actionHref,
        icon: null == t ? void 0 : t.actionIcon,
        onClick: null == t ? void 0 : t.actionFn,
        subComponents: s,
        variant: "s"
      }, {
        children: null == t ? void 0 : t.actionHeading
      }), void 0)]
    }, void 0)]
  }), void 0);
},
    jn = function jn(o) {
  var n,
      r,
      t,
      i,
      s,
      l,
      a,
      d,
      c,
      h = o.variant,
      u = g(o, ["variant"]),
      f = (null === (n = u.subComponents) || void 0 === n ? void 0 : n.TopicBlock) || on,
      p = (null === (r = u.subComponents) || void 0 === r ? void 0 : r.TopicCard) || sn,
      w = (null === (t = u.subComponents) || void 0 === t ? void 0 : t.TopicFeatured) || dn,
      m = (null === (i = u.subComponents) || void 0 === i ? void 0 : i.TopicHeadline) || un,
      _ = (null === (s = u.subComponents) || void 0 === s ? void 0 : s.TopicHero) || gn,
      k = (null === (l = u.subComponents) || void 0 === l ? void 0 : l.TopicMedia) || wn,
      y = (null === (a = u.subComponents) || void 0 === a ? void 0 : a.TopicProfile) || kn,
      x = (null === (d = u.subComponents) || void 0 === d ? void 0 : d.TopicQuote) || bn,
      b = (null === (c = u.subComponents) || void 0 === c ? void 0 : c.TopicShowcase) || Ln;

  switch (h) {
    case "block":
      return e(f, _v({}, u), void 0);

    case "card":
      return e(p, _v({}, u), void 0);

    case "featured":
      return e(w, _v({}, u), void 0);

    case "headline":
      return e(m, _v({}, u), void 0);

    case "hero":
      return e(_, _v({}, u), void 0);

    case "media":
      return e(k, _v({}, u), void 0);

    case "profile":
      return e(y, _v({}, u), void 0);

    case "quote":
      return e(x, _v({}, u), void 0);

    case "showcase":
      return e(b, _v({}, u), void 0);
  }

  return null;
},
    Wn = function Wn(o) {
  var n = o.numberOfDots,
      r = o.activeDot,
      t = o.onDotClick;
  return e(S, _v({
    anyCss: {
      display: "flex",
      gap: 8
    }
  }, {
    children: f([], Array(n), !0).map(function (o, n) {
      return e($, {
        onClick: function onClick() {
          return t(n);
        },
        anyCss: {
          cursor: "pointer",
          height: 16,
          width: 16,
          backgroundColor: n === r ? "var(--color-stone-500)" : "var(--color-stone-200)",
          borderRadius: "50%",
          transition: "background-color 0.5s ease",
          ":hover": {
            backgroundColor: "var(--color-stone-500)"
          }
        }
      }, n);
    })
  }), void 0);
},
    Nn = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 16,
  "& > section": {
    display: "flex",
    margin: "0 auto",
    MsOverflowStyle: "none",
    overflowX: "scroll",
    scrollbarWidth: "none",
    scrollSnapType: "x mandatory",
    width: "100%",
    WebkitOverflowScrolling: "touch",
    "&::-webkit-scrollbar": {
      display: "none"
    }
  }
},
    An = function An() {
  return Nn;
},
    Sn = function Sn(n) {
  var r = n.children,
      t = n.anyCss;
  n.variant, n.variantCss;

  var d = g(n, ["children", "anyCss", "variant", "variantCss"]),
      c = l(null),
      h = s(0),
      u = h[0],
      f = h[1],
      p = s(!1),
      w = p[0],
      m = p[1],
      _ = i.count(r);

  a(function () {
    var e = setTimeout(function () {
      w ? u - 1 >= 0 ? y(u - 1) : (m(!1), y(1)) : u + 1 <= _ - 1 ? y(u + 1) : (m(!0), y(_ - 2));
    }, 3e3);
    return function () {
      return clearTimeout(e);
    };
  }, [u]);

  var k = An(),
      y = function y(e) {
    c.current && (m(e < u), c.current.scrollTo({
      left: e * c.current.offsetWidth,
      behavior: "smooth"
    }));
  };

  return o(S, _v({
    anyCss: re([k, t])
  }, d, {
    children: [e("section", _v({
      ref: c,
      onScroll: function onScroll() {
        if (c.current) {
          var e = Math.round(c.current.scrollLeft / c.current.offsetWidth);
          m(e < u), f(e);
        }
      }
    }, {
      children: i.map(r, function (o) {
        return e(S, _v({
          anyCss: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minWidth: "100%"
          }
        }, {
          children: o
        }), void 0);
      })
    }), void 0), e(Wn, {
      activeDot: u,
      numberOfDots: _,
      onDotClick: function onDotClick(e) {
        return y(e);
      }
    }, void 0)]
  }), void 0);
},
    Hn = {
  display: "flex",
  flexDirection: "column",
  gap: [32, 80]
},
    zn = function zn() {
  return Hn;
},
    Tn = function Tn(o) {
  var n = o.children,
      r = o.anyCss;
  o.variant, o.variantCss;
  var t = g(o, ["children", "anyCss", "variant", "variantCss"]),
      i = zn();
  return e(S, _v({
    anyCss: re([i, r])
  }, t, {
    children: n
  }), void 0);
},
    On = {
  margin: "0 auto",
  maxWidth: 1280,
  padding: ["0 16px", "0 32px"],
  width: "100%"
},
    En = function En() {
  return On;
},
    Vn = function Vn(o) {
  var n = o.children,
      r = o.anyCss;
  o.variant, o.variantCss;
  var t = g(o, ["children", "anyCss", "variant", "variantCss"]),
      i = En();
  return e(S, _v({
    anyCss: re([i, r])
  }, t, {
    children: n
  }), void 0);
},
    In = {
  columnGap: 32,
  justifyContent: "center",
  display: "flex",
  flexDirection: ["column", "row"],
  flexWrap: "wrap",
  rowGap: [32, 48],
  "& > section": {
    width: ["100%", "calc(33.33% - 22px)"]
  }
},
    Dn = function Dn() {
  return In;
},
    Pn = function Pn(o) {
  var n = o.anyCss,
      r = o.children;
  o.options, o.variant;
  var t = g(o, ["anyCss", "children", "options", "variant"]),
      i = Dn();
  return e(S, _v({
    anyCss: re([i, n])
  }, t, {
    children: r
  }), void 0);
},
    Rn = {
  columnGap: 32,
  justifyContent: "center",
  display: "flex",
  flexDirection: ["column", "row"],
  flexWrap: "wrap",
  rowGap: [32, 48],
  "& > section": {
    width: ["100%", "calc(25% - 24px)"]
  }
},
    Un = function Un() {
  return Rn;
},
    Fn = function Fn(o) {
  var n = o.anyCss,
      r = o.children;
  o.options, o.variant;
  var t = g(o, ["anyCss", "children", "options", "variant"]),
      i = Un();
  return e(S, _v({
    anyCss: re([i, n])
  }, t, {
    children: r
  }), void 0);
},
    Bn = {
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  rowGap: [32, 64],
  "& > section:nth-of-type(odd) > picture": {
    order: 2
  },
  "& > section:nth-of-type(odd) > section": {
    order: 1
  }
},
    qn = function qn() {
  return Bn;
},
    $n = function $n(o) {
  var n = o.anyCss,
      r = o.children;
  o.options, o.variant;
  var t = g(o, ["anyCss", "children", "options", "variant"]),
      i = qn();
  return e(S, _v({
    anyCss: re([i, n])
  }, t, {
    children: r
  }), void 0);
},
    Yn = {
  columnGap: 16,
  justifyContent: "center",
  display: "flex",
  flexDirection: ["column", "row"],
  flexWrap: "wrap",
  rowGap: [32, 64],
  "& > section": {
    width: ["100%", "calc(50% - 8px)"]
  },
  "& > section:last-of-type:nth-of-type(odd)": {
    width: "100%"
  }
},
    Gn = function Gn() {
  return Yn;
},
    Kn = function Kn(o) {
  var n = o.anyCss,
      r = o.children;
  o.options, o.variant;
  var t = g(o, ["anyCss", "children", "options", "variant"]),
      i = Gn();
  return e(S, _v({
    anyCss: re([i, n])
  }, t, {
    children: r
  }), void 0);
},
    Jn = {
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  rowGap: [32, 64]
},
    Qn = function Qn() {
  return Jn;
},
    Xn = function Xn(o) {
  var n = o.anyCss,
      r = o.children;
  o.options, o.variant;
  var t = g(o, ["anyCss", "children", "options", "variant"]),
      i = Qn();
  return e(S, _v({
    anyCss: re([i, n])
  }, t, {
    children: r
  }), void 0);
},
    Zn = function Zn(o) {
  var n = o.anyCss,
      r = o.subComponents,
      t = g(o, ["anyCss", "subComponents"]),
      i = (null == r ? void 0 : r.SectionLayout) || Vn;
  return e(i, _v({
    anyCss: [{
      maxWidth: 700
    }, n]
  }, t), void 0);
},
    er = {
  exports: {}
},
    or = {
  exports: {}
},
    nr = {},
    rr = "function" == typeof Symbol && Symbol.for,
    tr = rr ? Symbol.for("react.element") : 60103,
    ir = rr ? Symbol.for("react.portal") : 60106,
    sr = rr ? Symbol.for("react.fragment") : 60107,
    lr = rr ? Symbol.for("react.strict_mode") : 60108,
    ar = rr ? Symbol.for("react.profiler") : 60114,
    dr = rr ? Symbol.for("react.provider") : 60109,
    cr = rr ? Symbol.for("react.context") : 60110,
    hr = rr ? Symbol.for("react.async_mode") : 60111,
    ur = rr ? Symbol.for("react.concurrent_mode") : 60111,
    vr = rr ? Symbol.for("react.forward_ref") : 60112,
    gr = rr ? Symbol.for("react.suspense") : 60113,
    fr = rr ? Symbol.for("react.suspense_list") : 60120,
    pr = rr ? Symbol.for("react.memo") : 60115,
    wr = rr ? Symbol.for("react.lazy") : 60116,
    mr = rr ? Symbol.for("react.block") : 60121,
    _r = rr ? Symbol.for("react.fundamental") : 60117,
    kr = rr ? Symbol.for("react.responder") : 60118,
    yr = rr ? Symbol.for("react.scope") : 60119;

function xr(e) {
  if ("object" == typeof e && null !== e) {
    var o = e.$$typeof;

    switch (o) {
      case tr:
        switch (e = e.type) {
          case hr:
          case ur:
          case sr:
          case ar:
          case lr:
          case gr:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case cr:
              case vr:
              case wr:
              case pr:
              case dr:
                return e;

              default:
                return o;
            }

        }

      case ir:
        return o;
    }
  }
}

function br(e) {
  return xr(e) === ur;
}

nr.AsyncMode = hr, nr.ConcurrentMode = ur, nr.ContextConsumer = cr, nr.ContextProvider = dr, nr.Element = tr, nr.ForwardRef = vr, nr.Fragment = sr, nr.Lazy = wr, nr.Memo = pr, nr.Portal = ir, nr.Profiler = ar, nr.StrictMode = lr, nr.Suspense = gr, nr.isAsyncMode = function (e) {
  return br(e) || xr(e) === hr;
}, nr.isConcurrentMode = br, nr.isContextConsumer = function (e) {
  return xr(e) === cr;
}, nr.isContextProvider = function (e) {
  return xr(e) === dr;
}, nr.isElement = function (e) {
  return "object" == typeof e && null !== e && e.$$typeof === tr;
}, nr.isForwardRef = function (e) {
  return xr(e) === vr;
}, nr.isFragment = function (e) {
  return xr(e) === sr;
}, nr.isLazy = function (e) {
  return xr(e) === wr;
}, nr.isMemo = function (e) {
  return xr(e) === pr;
}, nr.isPortal = function (e) {
  return xr(e) === ir;
}, nr.isProfiler = function (e) {
  return xr(e) === ar;
}, nr.isStrictMode = function (e) {
  return xr(e) === lr;
}, nr.isSuspense = function (e) {
  return xr(e) === gr;
}, nr.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === sr || e === ur || e === ar || e === lr || e === gr || e === fr || "object" == typeof e && null !== e && (e.$$typeof === wr || e.$$typeof === pr || e.$$typeof === dr || e.$$typeof === cr || e.$$typeof === vr || e.$$typeof === _r || e.$$typeof === kr || e.$$typeof === yr || e.$$typeof === mr);
}, nr.typeOf = xr;
var Cr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

"production" !== process.env.NODE_ENV && function () {
  var e = "function" == typeof Symbol && Symbol.for,
      o = e ? Symbol.for("react.element") : 60103,
      n = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      t = e ? Symbol.for("react.strict_mode") : 60108,
      i = e ? Symbol.for("react.profiler") : 60114,
      s = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      a = e ? Symbol.for("react.async_mode") : 60111,
      d = e ? Symbol.for("react.concurrent_mode") : 60111,
      c = e ? Symbol.for("react.forward_ref") : 60112,
      h = e ? Symbol.for("react.suspense") : 60113,
      u = e ? Symbol.for("react.suspense_list") : 60120,
      v = e ? Symbol.for("react.memo") : 60115,
      g = e ? Symbol.for("react.lazy") : 60116,
      f = e ? Symbol.for("react.block") : 60121,
      p = e ? Symbol.for("react.fundamental") : 60117,
      w = e ? Symbol.for("react.responder") : 60118,
      m = e ? Symbol.for("react.scope") : 60119;

  function _(e) {
    if ("object" == typeof e && null !== e) {
      var u = e.$$typeof;

      switch (u) {
        case o:
          var f = e.type;

          switch (f) {
            case a:
            case d:
            case r:
            case i:
            case t:
            case h:
              return f;

            default:
              var p = f && f.$$typeof;

              switch (p) {
                case l:
                case c:
                case g:
                case v:
                case s:
                  return p;

                default:
                  return u;
              }

          }

        case n:
          return u;
      }
    }
  }

  var k = a,
      y = d,
      x = l,
      b = s,
      C = o,
      M = c,
      L = r,
      j = g,
      W = v,
      N = n,
      A = i,
      S = t,
      H = h,
      z = !1;

  function T(e) {
    return _(e) === d;
  }

  Cr.AsyncMode = k, Cr.ConcurrentMode = y, Cr.ContextConsumer = x, Cr.ContextProvider = b, Cr.Element = C, Cr.ForwardRef = M, Cr.Fragment = L, Cr.Lazy = j, Cr.Memo = W, Cr.Portal = N, Cr.Profiler = A, Cr.StrictMode = S, Cr.Suspense = H, Cr.isAsyncMode = function (e) {
    return z || (z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), T(e) || _(e) === a;
  }, Cr.isConcurrentMode = T, Cr.isContextConsumer = function (e) {
    return _(e) === l;
  }, Cr.isContextProvider = function (e) {
    return _(e) === s;
  }, Cr.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === o;
  }, Cr.isForwardRef = function (e) {
    return _(e) === c;
  }, Cr.isFragment = function (e) {
    return _(e) === r;
  }, Cr.isLazy = function (e) {
    return _(e) === g;
  }, Cr.isMemo = function (e) {
    return _(e) === v;
  }, Cr.isPortal = function (e) {
    return _(e) === n;
  }, Cr.isProfiler = function (e) {
    return _(e) === i;
  }, Cr.isStrictMode = function (e) {
    return _(e) === t;
  }, Cr.isSuspense = function (e) {
    return _(e) === h;
  }, Cr.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === r || e === d || e === i || e === t || e === h || e === u || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === v || e.$$typeof === s || e.$$typeof === l || e.$$typeof === c || e.$$typeof === p || e.$$typeof === w || e.$$typeof === m || e.$$typeof === f);
  }, Cr.typeOf = _;
}(), "production" === process.env.NODE_ENV ? or.exports = nr : or.exports = Cr
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
;
var Mr = Object.getOwnPropertySymbols,
    Lr = Object.prototype.hasOwnProperty,
    jr = Object.prototype.propertyIsEnumerable;

function Wr(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

var Nr = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var o = {}, n = 0; n < 10; n++) {
      o["_" + String.fromCharCode(n)] = n;
    }

    var r = Object.getOwnPropertyNames(o).map(function (e) {
      return o[e];
    });
    if ("0123456789" !== r.join("")) return !1;
    var t = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      t[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, t)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (e, o) {
  for (var n, r, t = Wr(e), i = 1; i < arguments.length; i++) {
    for (var s in n = Object(arguments[i])) {
      Lr.call(n, s) && (t[s] = n[s]);
    }

    if (Mr) {
      r = Mr(n);

      for (var l = 0; l < r.length; l++) {
        jr.call(n, r[l]) && (t[r[l]] = n[r[l]]);
      }
    }
  }

  return t;
},
    Ar = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    Sr = function Sr() {};

if ("production" !== process.env.NODE_ENV) {
  var Hr = Ar,
      zr = {},
      Tr = Function.call.bind(Object.prototype.hasOwnProperty);

  Sr = function Sr(e) {
    var o = "Warning: " + e;
    "undefined" != typeof console && console.error(o);

    try {
      throw new Error(o);
    } catch (e) {}
  };
}

function Or(e, o, n, r, t) {
  if ("production" !== process.env.NODE_ENV) for (var i in e) {
    if (Tr(e, i)) {
      var s;

      try {
        if ("function" != typeof e[i]) {
          var l = Error((r || "React class") + ": " + n + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.");
          throw l.name = "Invariant Violation", l;
        }

        s = e[i](o, i, r, n, null, Hr);
      } catch (e) {
        s = e;
      }

      if (!s || s instanceof Error || Sr((r || "React class") + ": type specification of " + n + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), s instanceof Error && !(s.message in zr)) {
        zr[s.message] = !0;
        var a = t ? t() : "";
        Sr("Failed " + n + " type: " + s.message + (null != a ? a : ""));
      }
    }
  }
}

Or.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (zr = {});
};

var Er = Or,
    Vr = or.exports,
    Ir = Nr,
    Dr = Ar,
    Pr = Er,
    Rr = Function.call.bind(Object.prototype.hasOwnProperty),
    Ur = function Ur() {};

function Fr() {
  return null;
}

"production" !== process.env.NODE_ENV && (Ur = function Ur(e) {
  var o = "Warning: " + e;
  "undefined" != typeof console && console.error(o);

  try {
    throw new Error(o);
  } catch (e) {}
});

function Br() {}

function qr() {}

qr.resetWarningCache = Br;

if ("production" !== process.env.NODE_ENV) {
  var $r = or.exports;

  er.exports = function (e, o) {
    var n = "function" == typeof Symbol && Symbol.iterator,
        r = "<<anonymous>>",
        t = {
      array: a("array"),
      bool: a("boolean"),
      func: a("function"),
      number: a("number"),
      object: a("object"),
      string: a("string"),
      symbol: a("symbol"),
      any: l(Fr),
      arrayOf: function arrayOf(e) {
        return l(function (o, n, r, t, i) {
          if ("function" != typeof e) return new s("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
          var l = o[n];
          if (!Array.isArray(l)) return new s("Invalid " + t + " `" + i + "` of type `" + c(l) + "` supplied to `" + r + "`, expected an array.");

          for (var a = 0; a < l.length; a++) {
            var d = e(l, a, r, t, i + "[" + a + "]", Dr);
            if (d instanceof Error) return d;
          }

          return null;
        });
      },
      element: l(function (o, n, r, t, i) {
        var l = o[n];
        return e(l) ? null : new s("Invalid " + t + " `" + i + "` of type `" + c(l) + "` supplied to `" + r + "`, expected a single ReactElement.");
      }),
      elementType: l(function (e, o, n, r, t) {
        var i = e[o];
        return Vr.isValidElementType(i) ? null : new s("Invalid " + r + " `" + t + "` of type `" + c(i) + "` supplied to `" + n + "`, expected a single ReactElement type.");
      }),
      instanceOf: function instanceOf(e) {
        return l(function (o, n, t, i, l) {
          if (!(o[n] instanceof e)) {
            var a = e.name || r;
            return new s("Invalid " + i + " `" + l + "` of type `" + ((d = o[n]).constructor && d.constructor.name ? d.constructor.name : r) + "` supplied to `" + t + "`, expected instance of `" + a + "`.");
          }

          var d;
          return null;
        });
      },
      node: l(function (e, o, n, r, t) {
        return d(e[o]) ? null : new s("Invalid " + r + " `" + t + "` supplied to `" + n + "`, expected a ReactNode.");
      }),
      objectOf: function objectOf(e) {
        return l(function (o, n, r, t, i) {
          if ("function" != typeof e) return new s("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
          var l = o[n],
              a = c(l);
          if ("object" !== a) return new s("Invalid " + t + " `" + i + "` of type `" + a + "` supplied to `" + r + "`, expected an object.");

          for (var d in l) {
            if (Rr(l, d)) {
              var h = e(l, d, r, t, i + "." + d, Dr);
              if (h instanceof Error) return h;
            }
          }

          return null;
        });
      },
      oneOf: function oneOf(e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && Ur(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), Fr;

        function o(o, n, r, t, l) {
          for (var a = o[n], d = 0; d < e.length; d++) {
            if (i(a, e[d])) return null;
          }

          var c = JSON.stringify(e, function (e, o) {
            return "symbol" === h(o) ? String(o) : o;
          });
          return new s("Invalid " + t + " `" + l + "` of value `" + String(a) + "` supplied to `" + r + "`, expected one of " + c + ".");
        }

        return l(o);
      },
      oneOfType: function oneOfType(e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && Ur("Invalid argument supplied to oneOfType, expected an instance of array."), Fr;

        for (var o = 0; o < e.length; o++) {
          var n = e[o];
          if ("function" != typeof n) return Ur("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + u(n) + " at index " + o + "."), Fr;
        }

        return l(function (o, n, r, t, i) {
          for (var l = 0; l < e.length; l++) {
            if (null == (0, e[l])(o, n, r, t, i, Dr)) return null;
          }

          return new s("Invalid " + t + " `" + i + "` supplied to `" + r + "`.");
        });
      },
      shape: function shape(e) {
        return l(function (o, n, r, t, i) {
          var l = o[n],
              a = c(l);
          if ("object" !== a) return new s("Invalid " + t + " `" + i + "` of type `" + a + "` supplied to `" + r + "`, expected `object`.");

          for (var d in e) {
            var h = e[d];

            if (h) {
              var u = h(l, d, r, t, i + "." + d, Dr);
              if (u) return u;
            }
          }

          return null;
        });
      },
      exact: function exact(e) {
        return l(function (o, n, r, t, i) {
          var l = o[n],
              a = c(l);
          if ("object" !== a) return new s("Invalid " + t + " `" + i + "` of type `" + a + "` supplied to `" + r + "`, expected `object`.");
          var d = Ir({}, o[n], e);

          for (var h in d) {
            var u = e[h];
            if (!u) return new s("Invalid " + t + " `" + i + "` key `" + h + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(o[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
            var v = u(l, h, r, t, i + "." + h, Dr);
            if (v) return v;
          }

          return null;
        });
      }
    };

    function i(e, o) {
      return e === o ? 0 !== e || 1 / e == 1 / o : e != e && o != o;
    }

    function s(e) {
      this.message = e, this.stack = "";
    }

    function l(e) {
      if ("production" !== process.env.NODE_ENV) var n = {},
          t = 0;

      function i(i, l, a, d, c, h, u) {
        if (d = d || r, h = h || a, u !== Dr) {
          if (o) {
            var v = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw v.name = "Invariant Violation", v;
          }

          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var g = d + ":" + a;
            !n[g] && t < 3 && (Ur("You are manually calling a React.PropTypes validation function for the `" + h + "` prop on `" + d + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, t++);
          }
        }

        return null == l[a] ? i ? null === l[a] ? new s("The " + c + " `" + h + "` is marked as required in `" + d + "`, but its value is `null`.") : new s("The " + c + " `" + h + "` is marked as required in `" + d + "`, but its value is `undefined`.") : null : e(l, a, d, c, h);
      }

      var l = i.bind(null, !1);
      return l.isRequired = i.bind(null, !0), l;
    }

    function a(e) {
      return l(function (o, n, r, t, i, l) {
        var a = o[n];
        return c(a) !== e ? new s("Invalid " + t + " `" + i + "` of type `" + h(a) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
      });
    }

    function d(o) {
      switch (typeof o) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !o;

        case "object":
          if (Array.isArray(o)) return o.every(d);
          if (null === o || e(o)) return !0;

          var r = function (e) {
            var o = e && (n && e[n] || e["@@iterator"]);
            if ("function" == typeof o) return o;
          }(o);

          if (!r) return !1;
          var t,
              i = r.call(o);

          if (r !== o.entries) {
            for (; !(t = i.next()).done;) {
              if (!d(t.value)) return !1;
            }
          } else for (; !(t = i.next()).done;) {
            var s = t.value;
            if (s && !d(s[1])) return !1;
          }

          return !0;

        default:
          return !1;
      }
    }

    function c(e) {
      var o = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, o) {
        return "symbol" === e || !!o && ("Symbol" === o["@@toStringTag"] || "function" == typeof Symbol && o instanceof Symbol);
      }(o, e) ? "symbol" : o;
    }

    function h(e) {
      if (null == e) return "" + e;
      var o = c(e);

      if ("object" === o) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }

      return o;
    }

    function u(e) {
      var o = h(e);

      switch (o) {
        case "array":
        case "object":
          return "an " + o;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + o;

        default:
          return o;
      }
    }

    return s.prototype = Error.prototype, t.checkPropTypes = Pr, t.resetWarningCache = Pr.resetWarningCache, t.PropTypes = t, t;
  }($r.isElement, !0);
} else er.exports = function () {
  function e(e, o, n, r, t, i) {
    if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== i) {
      var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw s.name = "Invariant Violation", s;
    }
  }

  function o() {
    return e;
  }

  e.isRequired = e;
  var n = {
    array: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: o,
    element: e,
    elementType: e,
    instanceOf: o,
    node: e,
    objectOf: o,
    oneOf: o,
    oneOfType: o,
    shape: o,
    exact: o,
    checkPropTypes: qr,
    resetWarningCache: Br
  };
  return n.PropTypes = n, n;
}();

var Yr = er.exports;
var Gr,
    Kr = t,
    Jr = (Gr = Kr) && "object" == typeof Gr && "default" in Gr ? Gr.default : Gr;

function Qr(e, o, n) {
  return o in e ? Object.defineProperty(e, o, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = n, e;
}

var Xr = !("undefined" == typeof window || !window.document || !window.document.createElement);

var Zr = function Zr(e, o, n) {
  if ("function" != typeof e) throw new Error("Expected reducePropsToState to be a function.");
  if ("function" != typeof o) throw new Error("Expected handleStateChangeOnClient to be a function.");
  if (void 0 !== n && "function" != typeof n) throw new Error("Expected mapStateOnServer to either be undefined or a function.");
  return function (r) {
    if ("function" != typeof r) throw new Error("Expected WrappedComponent to be a React component.");
    var t,
        i = [];

    function s() {
      t = e(i.map(function (e) {
        return e.props;
      })), l.canUseDOM ? o(t) : n && (t = n(t));
    }

    var l = function (e) {
      var o, n;

      function l() {
        return e.apply(this, arguments) || this;
      }

      n = e, (o = l).prototype = Object.create(n.prototype), o.prototype.constructor = o, o.__proto__ = n, l.peek = function () {
        return t;
      }, l.rewind = function () {
        if (l.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
        var e = t;
        return t = void 0, i = [], e;
      };
      var a = l.prototype;
      return a.UNSAFE_componentWillMount = function () {
        i.push(this), s();
      }, a.componentDidUpdate = function () {
        s();
      }, a.componentWillUnmount = function () {
        var e = i.indexOf(this);
        i.splice(e, 1), s();
      }, a.render = function () {
        return Jr.createElement(r, this.props);
      }, l;
    }(Kr.PureComponent);

    return Qr(l, "displayName", "SideEffect(" + function (e) {
      return e.displayName || e.name || "Component";
    }(r) + ")"), Qr(l, "canUseDOM", Xr), l;
  };
},
    et = "undefined" != typeof Element,
    ot = "function" == typeof Map,
    nt = "function" == typeof Set,
    rt = "function" == typeof ArrayBuffer && !!ArrayBuffer.isView;

function tt(e, o) {
  if (e === o) return !0;

  if (e && o && "object" == typeof e && "object" == typeof o) {
    if (e.constructor !== o.constructor) return !1;
    var n, r, t, i;

    if (Array.isArray(e)) {
      if ((n = e.length) != o.length) return !1;

      for (r = n; 0 != r--;) {
        if (!tt(e[r], o[r])) return !1;
      }

      return !0;
    }

    if (ot && e instanceof Map && o instanceof Map) {
      if (e.size !== o.size) return !1;

      for (i = e.entries(); !(r = i.next()).done;) {
        if (!o.has(r.value[0])) return !1;
      }

      for (i = e.entries(); !(r = i.next()).done;) {
        if (!tt(r.value[1], o.get(r.value[0]))) return !1;
      }

      return !0;
    }

    if (nt && e instanceof Set && o instanceof Set) {
      if (e.size !== o.size) return !1;

      for (i = e.entries(); !(r = i.next()).done;) {
        if (!o.has(r.value[0])) return !1;
      }

      return !0;
    }

    if (rt && ArrayBuffer.isView(e) && ArrayBuffer.isView(o)) {
      if ((n = e.length) != o.length) return !1;

      for (r = n; 0 != r--;) {
        if (e[r] !== o[r]) return !1;
      }

      return !0;
    }

    if (e.constructor === RegExp) return e.source === o.source && e.flags === o.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === o.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === o.toString();
    if ((n = (t = Object.keys(e)).length) !== Object.keys(o).length) return !1;

    for (r = n; 0 != r--;) {
      if (!Object.prototype.hasOwnProperty.call(o, t[r])) return !1;
    }

    if (et && e instanceof Element) return !1;

    for (r = n; 0 != r--;) {
      if (("_owner" !== t[r] && "__v" !== t[r] && "__o" !== t[r] || !e.$$typeof) && !tt(e[t[r]], o[t[r]])) return !1;
    }

    return !0;
  }

  return e != e && o != o;
}

var it,
    st,
    lt,
    at,
    dt = function dt(e, o) {
  try {
    return tt(e, o);
  } catch (e) {
    if ((e.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw e;
  }
},
    ct = "bodyAttributes",
    ht = "htmlAttributes",
    ut = "titleAttributes",
    vt = {
  BASE: "base",
  BODY: "body",
  HEAD: "head",
  HTML: "html",
  LINK: "link",
  META: "meta",
  NOSCRIPT: "noscript",
  SCRIPT: "script",
  STYLE: "style",
  TITLE: "title"
},
    gt = Object.keys(vt).map(function (e) {
  return vt[e];
}),
    ft = "charset",
    pt = "cssText",
    wt = "href",
    mt = "http-equiv",
    _t = "innerHTML",
    kt = "itemprop",
    yt = "name",
    xt = "property",
    bt = "rel",
    Ct = "src",
    Mt = "target",
    Lt = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
},
    jt = "defaultTitle",
    Wt = "defer",
    Nt = "encodeSpecialCharacters",
    At = "onChangeClientState",
    St = "titleTemplate",
    Ht = Object.keys(Lt).reduce(function (e, o) {
  return e[Lt[o]] = o, e;
}, {}),
    zt = [vt.NOSCRIPT, vt.SCRIPT, vt.STYLE],
    Tt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
},
    Ot = function Ot(e, o) {
  if (!(e instanceof o)) throw new TypeError("Cannot call a class as a function");
},
    Et = function () {
  function e(e, o) {
    for (var n = 0; n < o.length; n++) {
      var r = o[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  return function (o, n, r) {
    return n && e(o.prototype, n), r && e(o, r), o;
  };
}(),
    Vt = Object.assign || function (e) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o];

    for (var r in n) {
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
  }

  return e;
},
    It = function It(e, o) {
  var n = {};

  for (var r in e) {
    o.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  }

  return n;
},
    Dt = function Dt(e, o) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !o || "object" != typeof o && "function" != typeof o ? e : o;
},
    Pt = function Pt(e) {
  var o = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
  return !1 === o ? String(e) : String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
},
    Rt = function Rt(e) {
  var o = $t(e, vt.TITLE),
      n = $t(e, St);
  if (n && o) return n.replace(/%s/g, function () {
    return Array.isArray(o) ? o.join("") : o;
  });
  var r = $t(e, jt);
  return o || r || void 0;
},
    Ut = function Ut(e) {
  return $t(e, At) || function () {};
},
    Ft = function Ft(e, o) {
  return o.filter(function (o) {
    return void 0 !== o[e];
  }).map(function (o) {
    return o[e];
  }).reduce(function (e, o) {
    return Vt({}, e, o);
  }, {});
},
    Bt = function Bt(e, o) {
  return o.filter(function (e) {
    return void 0 !== e[vt.BASE];
  }).map(function (e) {
    return e[vt.BASE];
  }).reverse().reduce(function (o, n) {
    if (!o.length) for (var r = Object.keys(n), t = 0; t < r.length; t++) {
      var i = r[t].toLowerCase();
      if (-1 !== e.indexOf(i) && n[i]) return o.concat(n);
    }
    return o;
  }, []);
},
    qt = function qt(e, o, n) {
  var r = {};
  return n.filter(function (o) {
    return !!Array.isArray(o[e]) || (void 0 !== o[e] && Qt("Helmet: " + e + ' should be of type "Array". Instead found type "' + Tt(o[e]) + '"'), !1);
  }).map(function (o) {
    return o[e];
  }).reverse().reduce(function (e, n) {
    var t = {};
    n.filter(function (e) {
      for (var n = void 0, i = Object.keys(e), s = 0; s < i.length; s++) {
        var l = i[s],
            a = l.toLowerCase();
        -1 === o.indexOf(a) || n === bt && "canonical" === e[n].toLowerCase() || a === bt && "stylesheet" === e[a].toLowerCase() || (n = a), -1 === o.indexOf(l) || l !== _t && l !== pt && l !== kt || (n = l);
      }

      if (!n || !e[n]) return !1;
      var d = e[n].toLowerCase();
      return r[n] || (r[n] = {}), t[n] || (t[n] = {}), !r[n][d] && (t[n][d] = !0, !0);
    }).reverse().forEach(function (o) {
      return e.push(o);
    });

    for (var i = Object.keys(t), s = 0; s < i.length; s++) {
      var l = i[s],
          a = Nr({}, r[l], t[l]);
      r[l] = a;
    }

    return e;
  }, []).reverse();
},
    $t = function $t(e, o) {
  for (var n = e.length - 1; n >= 0; n--) {
    var r = e[n];
    if (r.hasOwnProperty(o)) return r[o];
  }

  return null;
},
    Yt = (it = Date.now(), function (e) {
  var o = Date.now();
  o - it > 16 ? (it = o, e(o)) : setTimeout(function () {
    Yt(e);
  }, 0);
}),
    Gt = function Gt(e) {
  return clearTimeout(e);
},
    Kt = "undefined" != typeof window ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || Yt : global.requestAnimationFrame || Yt,
    Jt = "undefined" != typeof window ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || Gt : global.cancelAnimationFrame || Gt,
    Qt = function Qt(e) {
  return console && "function" == typeof console.warn && console.warn(e);
},
    Xt = null,
    Zt = function Zt(e, o) {
  var n = e.baseTag,
      r = e.bodyAttributes,
      t = e.htmlAttributes,
      i = e.linkTags,
      s = e.metaTags,
      l = e.noscriptTags,
      a = e.onChangeClientState,
      d = e.scriptTags,
      c = e.styleTags,
      h = e.title,
      u = e.titleAttributes;
  ni(vt.BODY, r), ni(vt.HTML, t), oi(h, u);
  var v = {
    baseTag: ri(vt.BASE, n),
    linkTags: ri(vt.LINK, i),
    metaTags: ri(vt.META, s),
    noscriptTags: ri(vt.NOSCRIPT, l),
    scriptTags: ri(vt.SCRIPT, d),
    styleTags: ri(vt.STYLE, c)
  },
      g = {},
      f = {};
  Object.keys(v).forEach(function (e) {
    var o = v[e],
        n = o.newTags,
        r = o.oldTags;
    n.length && (g[e] = n), r.length && (f[e] = v[e].oldTags);
  }), o && o(), a(e, g, f);
},
    ei = function ei(e) {
  return Array.isArray(e) ? e.join("") : e;
},
    oi = function oi(e, o) {
  void 0 !== e && document.title !== e && (document.title = ei(e)), ni(vt.TITLE, o);
},
    ni = function ni(e, o) {
  var n = document.getElementsByTagName(e)[0];

  if (n) {
    for (var r = n.getAttribute("data-react-helmet"), t = r ? r.split(",") : [], i = [].concat(t), s = Object.keys(o), l = 0; l < s.length; l++) {
      var a = s[l],
          d = o[a] || "";
      n.getAttribute(a) !== d && n.setAttribute(a, d), -1 === t.indexOf(a) && t.push(a);
      var c = i.indexOf(a);
      -1 !== c && i.splice(c, 1);
    }

    for (var h = i.length - 1; h >= 0; h--) {
      n.removeAttribute(i[h]);
    }

    t.length === i.length ? n.removeAttribute("data-react-helmet") : n.getAttribute("data-react-helmet") !== s.join(",") && n.setAttribute("data-react-helmet", s.join(","));
  }
},
    ri = function ri(e, o) {
  var n = document.head || document.querySelector(vt.HEAD),
      r = n.querySelectorAll(e + "[data-react-helmet]"),
      t = Array.prototype.slice.call(r),
      i = [],
      s = void 0;
  return o && o.length && o.forEach(function (o) {
    var n = document.createElement(e);

    for (var r in o) {
      if (o.hasOwnProperty(r)) if (r === _t) n.innerHTML = o.innerHTML;else if (r === pt) n.styleSheet ? n.styleSheet.cssText = o.cssText : n.appendChild(document.createTextNode(o.cssText));else {
        var l = void 0 === o[r] ? "" : o[r];
        n.setAttribute(r, l);
      }
    }

    n.setAttribute("data-react-helmet", "true"), t.some(function (e, o) {
      return s = o, n.isEqualNode(e);
    }) ? t.splice(s, 1) : i.push(n);
  }), t.forEach(function (e) {
    return e.parentNode.removeChild(e);
  }), i.forEach(function (e) {
    return n.appendChild(e);
  }), {
    oldTags: t,
    newTags: i
  };
},
    ti = function ti(e) {
  return Object.keys(e).reduce(function (o, n) {
    var r = void 0 !== e[n] ? n + '="' + e[n] + '"' : "" + n;
    return o ? o + " " + r : r;
  }, "");
},
    ii = function ii(e) {
  var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return Object.keys(e).reduce(function (o, n) {
    return o[Lt[n] || n] = e[n], o;
  }, o);
},
    si = function si(e, o, n) {
  switch (e) {
    case vt.TITLE:
      return {
        toComponent: function toComponent() {
          return e = o.title, n = o.titleAttributes, (r = {
            key: e
          })["data-react-helmet"] = !0, i = ii(n, r), [t.createElement(vt.TITLE, i, e)];
          var e, n, r, i;
        },
        toString: function toString() {
          return function (e, o, n, r) {
            var t = ti(n),
                i = ei(o);
            return t ? "<" + e + ' data-react-helmet="true" ' + t + ">" + Pt(i, r) + "</" + e + ">" : "<" + e + ' data-react-helmet="true">' + Pt(i, r) + "</" + e + ">";
          }(e, o.title, o.titleAttributes, n);
        }
      };

    case ct:
    case ht:
      return {
        toComponent: function toComponent() {
          return ii(o);
        },
        toString: function toString() {
          return ti(o);
        }
      };

    default:
      return {
        toComponent: function toComponent() {
          return function (e, o) {
            return o.map(function (o, n) {
              var r,
                  i = ((r = {
                key: n
              })["data-react-helmet"] = !0, r);
              return Object.keys(o).forEach(function (e) {
                var n = Lt[e] || e;

                if (n === _t || n === pt) {
                  var r = o.innerHTML || o.cssText;
                  i.dangerouslySetInnerHTML = {
                    __html: r
                  };
                } else i[n] = o[e];
              }), t.createElement(e, i);
            });
          }(e, o);
        },
        toString: function toString() {
          return function (e, o, n) {
            return o.reduce(function (o, r) {
              var t = Object.keys(r).filter(function (e) {
                return !(e === _t || e === pt);
              }).reduce(function (e, o) {
                var t = void 0 === r[o] ? o : o + '="' + Pt(r[o], n) + '"';
                return e ? e + " " + t : t;
              }, ""),
                  i = r.innerHTML || r.cssText || "",
                  s = -1 === zt.indexOf(e);
              return o + "<" + e + ' data-react-helmet="true" ' + t + (s ? "/>" : ">" + i + "</" + e + ">");
            }, "");
          }(e, o, n);
        }
      };
  }
},
    li = function li(e) {
  var o = e.baseTag,
      n = e.bodyAttributes,
      r = e.encode,
      t = e.htmlAttributes,
      i = e.linkTags,
      s = e.metaTags,
      l = e.noscriptTags,
      a = e.scriptTags,
      d = e.styleTags,
      c = e.title,
      h = void 0 === c ? "" : c,
      u = e.titleAttributes;
  return {
    base: si(vt.BASE, o, r),
    bodyAttributes: si(ct, n, r),
    htmlAttributes: si(ht, t, r),
    link: si(vt.LINK, i, r),
    meta: si(vt.META, s, r),
    noscript: si(vt.NOSCRIPT, l, r),
    script: si(vt.SCRIPT, a, r),
    style: si(vt.STYLE, d, r),
    title: si(vt.TITLE, {
      title: h,
      titleAttributes: u
    }, r)
  };
},
    ai = Zr(function (e) {
  return {
    baseTag: Bt([wt, Mt], e),
    bodyAttributes: Ft(ct, e),
    defer: $t(e, Wt),
    encode: $t(e, Nt),
    htmlAttributes: Ft(ht, e),
    linkTags: qt(vt.LINK, [bt, wt], e),
    metaTags: qt(vt.META, [yt, ft, mt, xt, kt], e),
    noscriptTags: qt(vt.NOSCRIPT, [_t], e),
    onChangeClientState: Ut(e),
    scriptTags: qt(vt.SCRIPT, [Ct, _t], e),
    styleTags: qt(vt.STYLE, [pt], e),
    title: Rt(e),
    titleAttributes: Ft(ut, e)
  };
}, function (e) {
  Xt && Jt(Xt), e.defer ? Xt = Kt(function () {
    Zt(e, function () {
      Xt = null;
    });
  }) : (Zt(e), Xt = null);
}, li)(function () {
  return null;
}),
    di = (st = ai, at = lt = function (e) {
  function o() {
    return Ot(this, o), Dt(this, e.apply(this, arguments));
  }

  return function (e, o) {
    if ("function" != typeof o && null !== o) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
    e.prototype = Object.create(o && o.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
  }(o, e), o.prototype.shouldComponentUpdate = function (e) {
    return !dt(this.props, e);
  }, o.prototype.mapNestedChildrenToProps = function (e, o) {
    if (!o) return null;

    switch (e.type) {
      case vt.SCRIPT:
      case vt.NOSCRIPT:
        return {
          innerHTML: o
        };

      case vt.STYLE:
        return {
          cssText: o
        };
    }

    throw new Error("<" + e.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
  }, o.prototype.flattenArrayTypeChildren = function (e) {
    var o,
        n = e.child,
        r = e.arrayTypeChildren,
        t = e.newChildProps,
        i = e.nestedChildren;
    return Vt({}, r, ((o = {})[n.type] = [].concat(r[n.type] || [], [Vt({}, t, this.mapNestedChildrenToProps(n, i))]), o));
  }, o.prototype.mapObjectTypeChildren = function (e) {
    var o,
        n,
        r = e.child,
        t = e.newProps,
        i = e.newChildProps,
        s = e.nestedChildren;

    switch (r.type) {
      case vt.TITLE:
        return Vt({}, t, ((o = {})[r.type] = s, o.titleAttributes = Vt({}, i), o));

      case vt.BODY:
        return Vt({}, t, {
          bodyAttributes: Vt({}, i)
        });

      case vt.HTML:
        return Vt({}, t, {
          htmlAttributes: Vt({}, i)
        });
    }

    return Vt({}, t, ((n = {})[r.type] = Vt({}, i), n));
  }, o.prototype.mapArrayTypeChildrenToProps = function (e, o) {
    var n = Vt({}, o);
    return Object.keys(e).forEach(function (o) {
      var r;
      n = Vt({}, n, ((r = {})[o] = e[o], r));
    }), n;
  }, o.prototype.warnOnInvalidChildren = function (e, o) {
    if ("production" !== process.env.NODE_ENV) {
      if (!gt.some(function (o) {
        return e.type === o;
      })) return "function" == typeof e.type ? Qt("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.") : Qt("Only elements types " + gt.join(", ") + " are allowed. Helmet does not support rendering <" + e.type + "> elements. Refer to our API for more information.");
      if (o && "string" != typeof o && (!Array.isArray(o) || o.some(function (e) {
        return "string" != typeof e;
      }))) throw new Error("Helmet expects a string as a child of <" + e.type + ">. Did you forget to wrap your children in braces? ( <" + e.type + ">{``}</" + e.type + "> ) Refer to our API for more information.");
    }

    return !0;
  }, o.prototype.mapChildrenToProps = function (e, o) {
    var n = this,
        r = {};
    return t.Children.forEach(e, function (e) {
      if (e && e.props) {
        var t = e.props,
            i = t.children,
            s = function (e) {
          var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return Object.keys(e).reduce(function (o, n) {
            return o[Ht[n] || n] = e[n], o;
          }, o);
        }(It(t, ["children"]));

        switch (n.warnOnInvalidChildren(e, i), e.type) {
          case vt.LINK:
          case vt.META:
          case vt.NOSCRIPT:
          case vt.SCRIPT:
          case vt.STYLE:
            r = n.flattenArrayTypeChildren({
              child: e,
              arrayTypeChildren: r,
              newChildProps: s,
              nestedChildren: i
            });
            break;

          default:
            o = n.mapObjectTypeChildren({
              child: e,
              newProps: o,
              newChildProps: s,
              nestedChildren: i
            });
        }
      }
    }), o = this.mapArrayTypeChildrenToProps(r, o);
  }, o.prototype.render = function () {
    var e = this.props,
        o = e.children,
        n = It(e, ["children"]),
        r = Vt({}, n);
    return o && (r = this.mapChildrenToProps(o, r)), t.createElement(st, r);
  }, Et(o, null, [{
    key: "canUseDOM",
    set: function set(e) {
      st.canUseDOM = e;
    }
  }]), o;
}(t.Component), lt.propTypes = {
  base: Yr.object,
  bodyAttributes: Yr.object,
  children: Yr.oneOfType([Yr.arrayOf(Yr.node), Yr.node]),
  defaultTitle: Yr.string,
  defer: Yr.bool,
  encodeSpecialCharacters: Yr.bool,
  htmlAttributes: Yr.object,
  link: Yr.arrayOf(Yr.object),
  meta: Yr.arrayOf(Yr.object),
  noscript: Yr.arrayOf(Yr.object),
  onChangeClientState: Yr.func,
  script: Yr.arrayOf(Yr.object),
  style: Yr.arrayOf(Yr.object),
  title: Yr.string,
  titleAttributes: Yr.object,
  titleTemplate: Yr.string
}, lt.defaultProps = {
  defer: !0,
  encodeSpecialCharacters: !0
}, lt.peek = st.peek, lt.rewind = function () {
  var e = st.rewind();
  return e || (e = li({
    baseTag: [],
    bodyAttributes: {},
    encodeSpecialCharacters: !0,
    htmlAttributes: {},
    linkTags: [],
    metaTags: [],
    noscriptTags: [],
    scriptTags: [],
    styleTags: [],
    title: "",
    titleAttributes: {}
  })), e;
}, at);

di.renderStatic = di.rewind;

var ci = function ci(e) {
  var o = e.values;
  return Array.isArray(o) && 0 !== o.length && o.find(function (e) {
    return "string" == typeof e;
  }) || "";
},
    hi = function hi(n) {
  var r = n.alternateLocales,
      t = n.authors,
      i = n.descriptions,
      s = n.headings,
      l = n.imageSrcs,
      a = n.jsonLd,
      d = n.keywordSets,
      c = n.locale,
      h = n.meta,
      u = n.siteVersion,
      g = ci({
    values: t
  }),
      f = ci({
    values: i
  }),
      p = ci({
    values: s
  }),
      w = ci({
    values: l
  }),
      m = function (e) {
    var o = e.values;
    return Array.isArray(o) && 0 !== o.length && o.find(function (e) {
      return Array.isArray(e);
    }) || [];
  }({
    values: d
  }),
      _ = m.join(", "),
      k = r || [],
      y = "%s";

  if (Array.isArray(s) && s.length > 1) {
    var x = function (e) {
      var o = e.values;
      return Array.isArray(o) && 0 !== o.length && o.reverse().find(function (e) {
        return "string" == typeof e;
      }) || "";
    }({
      values: s
    });

    p !== x && (y = "%s | ".concat(x));
  }

  return o(di, _v({
    htmlAttributes: {
      lang: c
    },
    titleTemplate: y,
    meta: [{
      content: u,
      name: "site-version"
    }, {
      content: f,
      name: "description"
    }, {
      content: _,
      name: "keywords"
    }, {
      content: p,
      property: "og:title"
    }, {
      content: w,
      property: "og:image"
    }, {
      content: f,
      property: "og:description"
    }, {
      content: c,
      property: "og:locale"
    }, {
      content: "summary",
      name: "twitter:card"
    }, {
      content: g,
      name: "twitter:creator"
    }, {
      content: p,
      name: "twitter:title"
    }, {
      content: f,
      name: "twitter:description"
    }, {
      content: w,
      name: "twitter:image"
    }].concat(h || [])
  }, {
    children: [e("title", {
      children: p
    }, void 0), k.map(function (o) {
      return e("link", {
        rel: "alternate",
        href: o.href,
        hrefLang: o.hrefLang
      }, o.hrefLang);
    }), a && e("script", _v({
      type: "application/ld+json"
    }, {
      children: JSON.stringify(a)
    }), void 0)]
  }), void 0);
},
    ui = function ui(o) {
  var n,
      r,
      t = o.anyCss,
      i = o.model,
      s = o.subComponents,
      l = g(o, ["anyCss", "model", "subComponents"]),
      a = null === (n = null == i ? void 0 : i.links) || void 0 === n ? void 0 : n.assets.block.find(function (e) {
    var o;
    return (null === (o = e.sys) || void 0 === o ? void 0 : o.id) === (null == i ? void 0 : i.node.data.target.sys.id);
  }),
      d = null === (r = null == a ? void 0 : a.contentType) || void 0 === r ? void 0 : r.split("/"),
      c = (null == s ? void 0 : s.Media) || Xo,
      h = (null == s ? void 0 : s.MaxWidthSectionLayout) || Zn;
  return "image" === (null == d ? void 0 : d[0]) ? e(h, _v({
    anyCss: t
  }, l, {
    children: e(c, {
      anyCss: {
        marginBottom: [12, 24]
      },
      variant: "imageAspectRatio",
      model: {
        imageUrl: null == a ? void 0 : a.url,
        description: null == a ? void 0 : a.description
      }
    }, void 0)
  }), void 0) : "video" === (null == d ? void 0 : d[0]) ? e(h, _v({
    anyCss: t
  }, l, {
    children: e(c, {
      anyCss: {
        marginBottom: [12, 24]
      },
      variant: "imageAspectRatio",
      model: {
        contentType: null == a ? void 0 : a.contentType,
        title: null == a ? void 0 : a.title,
        videoUrl: null == a ? void 0 : a.url
      }
    }, void 0)
  }), void 0) : null;
},
    vi = function vi(e) {
  var o,
      n,
      r = e.model,
      t = null === (n = null === (o = null == r ? void 0 : r.links) || void 0 === o ? void 0 : o.entries) || void 0 === n ? void 0 : n.block.find(function (e) {
    var o;
    return (null === (o = e.sys) || void 0 === o ? void 0 : o.id) === (null == r ? void 0 : r.node.data.target.sys.id);
  });
  return console.log("BlocksEmbeddedEntry not implemented: ".concat(null == t ? void 0 : t.__typename)), null;
},
    gi = function gi(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = (null == t ? void 0 : t.Display) || ye,
      l = (null == t ? void 0 : t.MaxWidthSectionLayout) || Zn;
  return e(l, _v({
    anyCss: n
  }, i, {
    children: e(s, _v({
      is: "h1",
      variant: "m",
      anyCss: {
        margin: "32px 0"
      }
    }, {
      children: r
    }), void 0)
  }), void 0);
},
    fi = function fi(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = (null == t ? void 0 : t.Heading) || de,
      l = (null == t ? void 0 : t.MaxWidthSectionLayout) || Zn;
  return e(l, _v({
    anyCss: n
  }, i, {
    children: e(s, _v({
      is: "h2",
      variant: "xl",
      anyCss: {
        margin: "24px 0"
      }
    }, {
      children: r
    }), void 0)
  }), void 0);
},
    pi = function pi(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = (null == t ? void 0 : t.Heading) || de,
      l = (null == t ? void 0 : t.MaxWidthSectionLayout) || Zn;
  return e(l, _v({
    anyCss: n
  }, i, {
    children: e(s, _v({
      is: "h3",
      variant: "l",
      anyCss: {
        margin: "20px 0"
      }
    }, {
      children: r
    }), void 0)
  }), void 0);
},
    wi = function wi(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = (null == t ? void 0 : t.Heading) || de,
      l = (null == t ? void 0 : t.MaxWidthSectionLayout) || Zn;
  return e(l, _v({
    anyCss: n
  }, i, {
    children: e(s, _v({
      is: "h4",
      variant: "m",
      anyCss: {
        margin: "16px 0"
      }
    }, {
      children: r
    }), void 0)
  }), void 0);
},
    mi = function mi(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = (null == t ? void 0 : t.Heading) || de,
      l = (null == t ? void 0 : t.MaxWidthSectionLayout) || Zn;
  return e(l, _v({
    anyCss: n
  }, i, {
    children: e(s, _v({
      is: "h5",
      variant: "s",
      anyCss: {
        margin: "8px 0"
      }
    }, {
      children: r
    }), void 0)
  }), void 0);
},
    _i = function _i(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = (null == t ? void 0 : t.Heading) || de,
      l = (null == t ? void 0 : t.MaxWidthSectionLayout) || Zn;
  return e(l, _v({
    anyCss: n
  }, i, {
    children: e(s, _v({
      is: "h6",
      variant: "s",
      anyCss: {
        margin: "4px 0"
      }
    }, {
      children: r
    }), void 0)
  }), void 0);
},
    ki = function ki(o) {
  var n = o.anyCss,
      r = o.subComponents,
      t = g(o, ["anyCss", "subComponents"]),
      i = (null == r ? void 0 : r.Hr) || T;
  return e(i, _v({
    anyCss: re([{
      border: "0.5px solid lightgrey",
      marginBottom: [24, 48],
      marginTop: [24, 48]
    }, n])
  }, t), void 0);
},
    yi = function yi(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = (null == t ? void 0 : t.Li) || D;
  return e(s, _v({
    anyCss: re([{
      p: {
        margin: "0 0 0 4px"
      },
      div: {
        padding: 0
      }
    }, n])
  }, i, {
    children: r
  }), void 0);
},
    xi = function xi(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = (null == t ? void 0 : t.Ol) || R,
      l = (null == t ? void 0 : t.MaxWidthSectionLayout) || Zn,
      a = ge({});
  return e(l, _v({
    anyCss: n
  }, i, {
    children: e(s, _v({
      anyCss: re([a, {
        marginBottom: [12, 24]
      }])
    }, {
      children: r
    }), void 0)
  }), void 0);
},
    bi = function bi(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = (null == t ? void 0 : t.Body) || fe,
      l = (null == t ? void 0 : t.MaxWidthSectionLayout) || Zn;
  return e(l, _v({
    anyCss: n
  }, i, {
    children: e(s, _v({
      anyCss: {
        marginBottom: [12, 24]
      }
    }, {
      children: r
    }), void 0)
  }), void 0);
},
    Ci = function Ci(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = (null == t ? void 0 : t.Blockquote) || W,
      l = (null == t ? void 0 : t.MaxWidthSectionLayout) || Zn;
  return e(l, _v({
    anyCss: n
  }, i, {
    children: e(s, _v({
      anyCss: re([{
        border: "2px solid var(--color-stone-100)",
        borderRadius: 4,
        fontStyle: "italic",
        margin: ["24px 16px", "48px 32px"],
        padding: ["0px 6px", "0px 12px"],
        paddingTop: [12, 24]
      }])
    }, {
      children: r
    }), void 0)
  }), void 0);
},
    Mi = function Mi(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.subComponents,
      i = g(o, ["anyCss", "children", "subComponents"]),
      s = ge({}),
      l = (null == t ? void 0 : t.Ul) || ee,
      a = (null == t ? void 0 : t.MaxWidthSectionLayout) || Zn;
  return e(a, _v({
    anyCss: n
  }, i, {
    children: e(l, _v({
      anyCss: re([s, {
        marginBottom: [12, 24]
      }])
    }, {
      children: r
    }), void 0)
  }), void 0);
},
    Li = function Li(o) {
  var n,
      r = o.anyCss,
      t = o.children,
      i = o.model,
      s = o.subComponents,
      l = g(o, ["anyCss", "children", "model", "subComponents"]),
      a = null === (n = null == i ? void 0 : i.links) || void 0 === n ? void 0 : n.assets.hyperlink.find(function (e) {
    var o;
    return (null === (o = e.sys) || void 0 === o ? void 0 : o.id) === (null == i ? void 0 : i.node.data.target.sys.id);
  }),
      d = (null == s ? void 0 : s.TextLink) || Ze;
  return e(d, _v({
    anyCss: r,
    href: null == a ? void 0 : a.url,
    subComponents: s,
    title: null == a ? void 0 : a.description
  }, l, {
    children: t
  }), void 0);
},
    ji = function ji(e) {
  var o,
      n,
      r = e.model,
      t = null === (n = null === (o = null == r ? void 0 : r.links) || void 0 === o ? void 0 : o.entries) || void 0 === n ? void 0 : n.inline.find(function (e) {
    var o;
    return (null === (o = e.sys) || void 0 === o ? void 0 : o.id) === (null == r ? void 0 : r.node.data.target.sys.id);
  });
  return console.log("InlinesEmbeddedEntry not implemented: ".concat(null == t ? void 0 : t.__typename)), null;
},
    Wi = function Wi(e) {
  var o,
      n,
      r = e.model,
      t = null === (n = null === (o = null == r ? void 0 : r.links) || void 0 === o ? void 0 : o.entries) || void 0 === n ? void 0 : n.hyperlink.find(function (e) {
    var o;
    return (null === (o = e.sys) || void 0 === o ? void 0 : o.id) === (null == r ? void 0 : r.node.data.target.sys.id);
  });
  return console.log("InlinesEntryHyperlink not implemented: ".concat(null == t ? void 0 : t.__typename)), null;
},
    Ni = function Ni(o) {
  var n = o.anyCss,
      r = o.children,
      t = o.model,
      i = o.subComponents,
      s = g(o, ["anyCss", "children", "model", "subComponents"]),
      l = (null == i ? void 0 : i.TextLink) || Ze;
  return e(l, _v({
    anyCss: n,
    href: null == t ? void 0 : t.node.data.uri,
    subComponents: i
  }, s, {
    children: r
  }), void 0);
},
    Ai = function Ai(o) {
  var n,
      r,
      t,
      i,
      s,
      l = o.anyCss,
      a = o.model,
      f = o.options,
      p = o.subComponents,
      w = g(o, ["anyCss", "model", "options", "subComponents"]);
  if (!(null === (t = null == a ? void 0 : a.text) || void 0 === t ? void 0 : t.json)) return null;

  var m = null === (i = a.text) || void 0 === i ? void 0 : i.json,
      _ = null === (s = a.text) || void 0 === s ? void 0 : s.links,
      k = (null == p ? void 0 : p.BlocksHeading1) || gi,
      y = (null == p ? void 0 : p.BlocksHeading2) || fi,
      x = (null == p ? void 0 : p.BlocksHeading3) || pi,
      b = (null == p ? void 0 : p.BlocksHeading4) || wi,
      C = (null == p ? void 0 : p.BlocksHeading5) || mi,
      M = (null == p ? void 0 : p.BlocksHeading6) || _i,
      L = (null == p ? void 0 : p.BlocksEmbeddedAsset) || ui,
      W = (null == p ? void 0 : p.BlocksEmbeddedEntry) || vi,
      N = (null == p ? void 0 : p.BlocksHr) || ki,
      H = (null == p ? void 0 : p.BlocksListItem) || yi,
      z = (null == p ? void 0 : p.BlocksOrderedList) || xi,
      T = (null == p ? void 0 : p.BlocksParagraph) || bi,
      E = (null == p ? void 0 : p.BlocksQuote) || Ci,
      V = (null == p ? void 0 : p.BlocksUnorderedList) || Mi,
      I = (null == p ? void 0 : p.InlinesAssetHyperlink) || Li,
      D = (null == p ? void 0 : p.InlinesEmbeddedEntry) || ji,
      P = (null == p ? void 0 : p.InlinesEntryHyperlink) || Wi,
      R = (null == p ? void 0 : p.InlinesHyperlink) || Ni,
      U = {
    renderMark: (n = {}, n[d.BOLD] = function (o) {
      return e(j, {
        children: o
      }, void 0);
    }, n[d.CODE] = function (o) {
      return e(A, {
        children: o
      }, void 0);
    }, n[d.ITALIC] = function (o) {
      return e(O, {
        children: o
      }, void 0);
    }, n[d.UNDERLINE] = function (o) {
      return e(Z, {
        children: o
      }, void 0);
    }, n),
    renderNode: (r = {}, r[c.HEADING_1] = function (o, n) {
      return e(k, _v({
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[c.HEADING_2] = function (o, n) {
      return e(y, _v({
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[c.HEADING_3] = function (o, n) {
      return e(x, _v({
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[c.HEADING_4] = function (o, n) {
      return e(b, _v({
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[c.HEADING_5] = function (o, n) {
      return e(C, _v({
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[c.HEADING_6] = function (o, n) {
      return e(M, _v({
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[c.HR] = function () {
      return e(N, {}, void 0);
    }, r[c.LIST_ITEM] = function (o, n) {
      return e(H, _v({
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[c.OL_LIST] = function (o, n) {
      return e(z, _v({
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[c.UL_LIST] = function (o, n) {
      return e(V, _v({
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[c.PARAGRAPH] = function (o, n) {
      return e(T, _v({
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[c.QUOTE] = function (o, n) {
      return e(E, {
        children: n
      }, void 0);
    }, r[c.EMBEDDED_ENTRY] = function (o) {
      return e(W, {
        model: {
          node: o,
          links: _
        },
        options: {
          preview: null == f ? void 0 : f.preview
        },
        subComponents: p
      }, void 0);
    }, r[c.EMBEDDED_ASSET] = function (o) {
      return e(L, {
        model: {
          node: o,
          links: _
        },
        subComponents: p
      }, void 0);
    }, r[h.ASSET_HYPERLINK] = function (o, n) {
      return e(I, _v({
        model: {
          node: o,
          links: _
        },
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[h.ENTRY_HYPERLINK] = function (o, n) {
      return e(P, _v({
        model: {
          node: o,
          links: _
        },
        options: {
          preview: null == f ? void 0 : f.preview
        },
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[h.HYPERLINK] = function (o, n) {
      return e(R, _v({
        model: {
          node: o
        },
        subComponents: p
      }, {
        children: n
      }), void 0);
    }, r[h.EMBEDDED_ENTRY] = function (o) {
      return e(D, {
        model: {
          node: o,
          links: _
        },
        subComponents: p
      }, void 0);
    }, r)
  };

  return e(S, _v({
    anyCss: re([l])
  }, w, {
    children: u(m, U)
  }), void 0);
},
    Si = function Si(n) {
  var r,
      t,
      i,
      s,
      l = n.anyCss,
      a = n.model,
      d = n.subComponents,
      c = g(n, ["anyCss", "model", "subComponents"]),
      h = ((null === (t = null === (r = null == a ? void 0 : a.socialSegment) || void 0 === r ? void 0 : r.items) || void 0 === t ? void 0 : t.length) || 0) + ((null === (s = null === (i = null == a ? void 0 : a.menuSegment) || void 0 === i ? void 0 : i.items) || void 0 === s ? void 0 : s.length) || 0) > 0;
  return o(S, _v({
    is: "footer",
    anyCss: re([{
      marginTop: 80
    }, l])
  }, c, {
    children: [h && e(S, _v({
      anyCss: {
        borderTop: "1px solid var(--color-stone-100)"
      }
    }, {
      children: e(Vn, {
        children: e(wo, {
          anyCss: {
            minHeight: 48,
            padding: "16px 0"
          },
          model: {
            menuSegment: null == a ? void 0 : a.menuSegment,
            socialSegment: null == a ? void 0 : a.socialSegment
          },
          subComponents: d
        }, void 0)
      }, void 0)
    }), void 0), e(S, _v({
      anyCss: {
        borderTop: "1px solid var(--color-stone-100)"
      }
    }, {
      children: e(Vn, {
        children: e(Ho, {
          anyCss: {
            minHeight: 48,
            padding: "16px 0"
          },
          model: {
            copyright: "Copyright 2021 © ".concat(null == a ? void 0 : a.brandingHeading),
            modelberryHeading: "Made with Modelberry",
            modelberryVersion: null == a ? void 0 : a.siteVersion,
            modelberryActionHref: "https://www.modelberry.com"
          }
        }, void 0)
      }, void 0)
    }), void 0)]
  }), void 0);
},
    Hi = function Hi(o) {
  var n,
      r,
      t,
      i,
      s,
      l,
      a = o.model,
      d = o.anyCss,
      c = o.subComponents,
      h = g(o, ["model", "anyCss", "subComponents"]);
  return ((null === (r = null === (n = null == a ? void 0 : a.actionSegment) || void 0 === n ? void 0 : n.items) || void 0 === r ? void 0 : r.length) || 0) + ((null === (i = null === (t = null == a ? void 0 : a.socialSegment) || void 0 === t ? void 0 : t.items) || void 0 === i ? void 0 : i.length) || 0) + ((null === (l = null === (s = null == a ? void 0 : a.menuSegment) || void 0 === s ? void 0 : s.items) || void 0 === l ? void 0 : l.length) || 0) <= 0 ? null : e(S, _v({
    anyCss: re([{
      borderBottom: "1px solid var(--color-stone-100)"
    }, d]),
    is: "header"
  }, h, {
    children: e(Vn, {
      children: e(Lo, {
        anyCss: {
          minHeight: 70,
          padding: "16px 0"
        },
        model: {
          actionSegment: null == a ? void 0 : a.actionSegment,
          brandingHeading: null == a ? void 0 : a.brandingHeading,
          brandingActionFn: null == a ? void 0 : a.brandingActionFn,
          menuSegment: null == a ? void 0 : a.menuSegment,
          socialSegment: null == a ? void 0 : a.socialSegment
        },
        subComponents: c
      }, void 0)
    }, void 0)
  }), void 0);
},
    zi = function zi(o) {
  var n = o.anyCss,
      r = o.model,
      t = o.options,
      i = o.variant,
      s = o.variantCss,
      l = o.subComponents,
      a = o.topicVariant,
      d = o.topicVariantCss,
      c = g(o, ["anyCss", "model", "options", "variant", "variantCss", "subComponents", "topicVariant", "topicVariantCss"]),
      h = (null == r ? void 0 : r.topics) || [],
      u = i || "three-collumn",
      f = a || "block",
      p = "single" === u,
      w = "hero" === f,
      m = "headline" === f,
      _ = "carousel" === u,
      k = null == t ? void 0 : t.reversedOrder,
      y = (null == s ? void 0 : s[u]) || {},
      x = (null == d ? void 0 : d[f]) || {},
      b = (null == l ? void 0 : l.OneCollumnLayout) || Xn,
      C = (null == l ? void 0 : l.OneCollumnSwapMediaLayout) || $n,
      M = (null == l ? void 0 : l.TwoCollumnLayout) || Kn,
      L = (null == l ? void 0 : l.ThreeCollumnLayout) || Pn,
      j = (null == l ? void 0 : l.FourCollumnLayout) || Fn,
      W = (null == l ? void 0 : l.CarouselLayout) || Sn,
      N = (null == l ? void 0 : l.SectionLayout) || Vn,
      A = (null == l ? void 0 : l.Topic) || jn;

  if (p && w) return e(A, {
    anyCss: [{
      section: {
        maxWidth: 1280
      },
      marginLeft: "auto",
      marginRight: "auto"
    }, (null == t ? void 0 : t.useTextColumnWidth) ? {
      maxWidth: 700
    } : {}, x, n],
    model: h[0],
    options: {
      reversedOrder: k
    },
    subComponents: l,
    variant: f
  }, void 0);
  if (p) return e(N, _v({
    anyCss: [m ? {
      padding: [0, 0]
    } : {}, (null == t ? void 0 : t.useTextColumnWidth) ? {
      maxWidth: 700
    } : {}, y, n]
  }, c, {
    children: e(A, {
      anyCss: [x],
      model: h[0],
      options: {
        reversedOrder: k
      },
      subComponents: l,
      variant: f
    }, void 0)
  }), void 0);
  var S = "one-collumn" === u ? b : "one-collumn-swap-media" === u ? C : "two-collumn" === u ? M : "three-collumn" === u ? L : "four-collumn" === u ? j : "carousel" === u ? W : N,
      H = _ && (null == t ? void 0 : t.useTextColumnWidth) ? {
    maxWidth: 700
  } : {},
      z = !_ && (null == t ? void 0 : t.useTextColumnWidth) ? {
    maxWidth: 700
  } : {};
  return e(N, _v({
    anyCss: [z, y, n]
  }, c, {
    children: e(S, {
      children: h.map(function (o, n) {
        return e(A, {
          anyCss: [H, x],
          model: o,
          options: {
            reversedOrder: k
          },
          subComponents: l,
          variant: f
        }, n);
      })
    }, void 0)
  }), void 0);
},
    Ti = function Ti(e) {
  var o,
      n,
      r = e.queryResponse,
      t = e.collectionId,
      i = Object.keys(t)[0] || "page",
      s = t[i],
      l = function (e) {
    if (e && Array.isArray(e) && !(e.length < 0)) return e[0];
  }(null === (n = null === (o = r.contentful) || void 0 === o ? void 0 : o["".concat(i, "Collection")]) || void 0 === n ? void 0 : n.items);

  return function (e) {
    var o,
        n,
        r,
        t = e.matchAll(/(.+)\/(.+)\((.+)\)\.(.+)/g),
        a = Array.from(t)[0],
        d = a[1],
        c = a[2],
        h = a[3],
        u = a[4],
        v = "".concat(d, "Collection"),
        g = (null === (o = null == l ? void 0 : l[v]) || void 0 === o ? void 0 : o.items) || [];
    if (0 === g.length) return "Could not find ".concat(i, "(").concat(s, "), query: ").concat(e, ", ").concat(d, " field does not exist or has no entries");

    for (var f = 0, p = g; f < p.length; f++) {
      var w = p[f];

      if ("Contentful_".concat((r = c).charAt(0).toUpperCase() + r.slice(1)) === w.__typename && h === w.id) {
        n = w;
        break;
      }
    }

    return n ? u in n ? n[u] : "Could not find ".concat(i, "(").concat(s, "), query: ").concat(e, ", ").concat(u, " field is missing") : "Could not find ".concat(i, "(").concat(s, "), query: ").concat(e);
  };
};

export { uo as BinaryField, ui as BlocksEmbeddedAsset, vi as BlocksEmbeddedEntry, gi as BlocksHeading1, fi as BlocksHeading2, pi as BlocksHeading3, wi as BlocksHeading4, mi as BlocksHeading5, _i as BlocksHeading6, ki as BlocksHr, yi as BlocksListItem, xi as BlocksOrderedList, bi as BlocksParagraph, Ci as BlocksQuote, Mi as BlocksUnorderedList, fe as Body, Oe as Button, Sn as CarouselLayout, Ai as ContentfulRichText, ye as Display, Io as Embed, wo as FooterNavigation, Si as FooterSection, Fn as FourCollumnLayout, Lo as HeaderNavigation, Hi as HeaderSection, de as Heading, We as Icon, Li as InlinesAssetHyperlink, ji as InlinesEmbeddedEntry, Wi as InlinesEntryHyperlink, Ni as InlinesHyperlink, Pe as Input, Ao as InputField, Ho as LegalNavigation, Fe as MarkdownBold, $e as MarkdownNewLines, Ke as MarkdownTable, Zn as MaxWidthSectionLayout, Xo as Media, hi as Meta, fo as Navigation, Xn as OneCollumnLayout, $n as OneCollumnSwapMediaLayout, Tn as PageLayout, qo as Picture, Vn as SectionLayout, Ze as TextLink, to as Textarea, Pn as ThreeCollumnLayout, jn as Topic, zi as TopicSection, Kn as TwoCollumnLayout, ao as UpdateButton, Qo as Video, ho as binaryFieldStyleFactory, ge as bodyStyleFactory, ne as breakpoints, Te as buttonStyleFactory, An as carouselLayoutStyleFactory, Ti as cmsGetFactory, ke as displayStyleFactory, Vo as embedStyleFactory, po as footerNavigationStyleFactory, Un as fourCollumnLayoutStyleFactory, Mo as headerNavigationStyleFactory, ae as headingStyleFactory, je as iconStyleFactory, No as inputFieldStyleFactory, De as inputStyleFactory, Ue as isValidMarkdownBold, Ge as isValidMarkdownTable, So as legalNavigationStyleFactory, re as mediaQuery, go as navigationStyleFactory, Qn as oneCollumnLayoutStyleFactory, qn as oneCollumnSwapMediaLayoutStyleFactory, zn as pageLayoutStyleFactory, Bo as pictureStyleFactory, Be as replaceLinks, qe as replaceNewlines, Re as replaceStars, En as sectionLayoutStyleFactory, Xe as textLinkStyleFactory, ro as textareaStyleFactory, Dn as threeCollumnLayoutStyleFactory, Gn as twoCollumnLayoutStyleFactory, lo as updateButtonStyleFactory, Jo as videoStyleFactory };